import { ElementRef, Directive } from '@angular/core';
import { lang } from 'moment';

@Directive({
    selector: '[translate]'
})

export class Translate {
    private labelval: string;
    language: string;
    constructor(private el: ElementRef) {
        this.placeText(el);
        this.getLanguage();
    }

    getLanguage() {
        if (localStorage.getItem('language') === undefined || localStorage.getItem('language') == null) {
            this.language = "en"; //default to English (at least the first time)
        } else {
            this.language = localStorage.getItem('language');
        }
        Translate.currentLanguage = this.language;
    }

    placeText(el: ElementRef) {
        let currentLanguage = Translate.getCurrentLanguage();
        this.labelval = Translate.languages[currentLanguage][el.nativeElement.getAttribute('paramdata')];
        el.nativeElement.innerHTML = this.labelval;
    }

    static setLang(language: string) {
        Translate.currentLanguage = language;
        localStorage.setItem('language', Translate.currentLanguage);
    }

    static currentLanguage: string = "en";

    static getCurrentLanguage() {
        //remove the following line if Chinese Cantonese and Mandarin will be translated differently than Chinese Simplified
        if (Translate.currentLanguage == "yue" || Translate.currentLanguage == "cmn") return "zh";
        return Translate.currentLanguage;
    }
    static getTranslation(word: string) {
        let currentLanguage = Translate.getCurrentLanguage();
        return Translate.languages[currentLanguage][word];
    }

    getLanguages() {

    }

    static languages: any =
        {
            "en": {
                Nothing: "",
                Username: "Email or Username",
                Password: "Password",
                NewAppVersionAvailable: "New application version is available please update!",
                UserError: "Please enter a valid username.",
                PwError: "Your password needs more than 6 characters.",
                Login: "Log in",
                FaceID: "FaceID",
                Fingerprint: "Fingerprint",
                PwForgot: "Forgot password?",
                Version: "Version",
                TitleApp: "MANOS HOME CARE",
                Subtitle: "Caregiver Portal",
                Monday: "Monday",
                Tuesday: "Tuesday",
                Wednesday: "Wednesday",
                Thursday: "Thursday",
                Friday: "Friday",
                Saturday: "Saturday",
                Sunday: "Sunday",
                ViewMap: "View Map",
                NoteTooLong: "Note is too long. Please maintain a maximum of 512 characters! ",
                NoteTooLong4000characters: "Note is too long. Please maintain a maximum of 4000 characters! ",
                OfflinePassForgot: "You are offline. Please connect to a network to reset your password.",
                ConfirmPassReset: "Are you sure you want to reset your password?",
                ConfirmShiftResponse: "Are you sure you want to respond to this open shift?",
                PatientName: "</br></br>Patient Name: ",
                EmptyUsername: "Please make sure you have the username/email completed!",
                EmptyError: "You don't have a phone number or email on file. Please contact your office to have them reset your password.",
                PassResetSuccess: "A password reset email has been sent to your email",
                PhoneError: "A password reset text has been sent to your phone number.",
                NewMessages: "You may have new messages.",
                ReadNow: "Read Now",
                ReadLater: "Read Later",
                Ok: "Ok",
                Close: "Close",
                DeleteWorking: "Are you sure you want to delete working hour?",
                DeleteAdjustment: "Are you sure you want to delete adjustment <b>",
                InitiatingCall: "Initiating call ...",
                CallFailed: "Call failed",
                CallCanceled: "Call canceled",
                OngoingCall: "Ongoing call...",
                CallEnded: "Call ended",
                IncomingCall: "Incoming call",
                ConnectingToCall: "Connecting...",
                Rejected: "Rejected ...",
                RejectionFailed: "Rejection failed ...",
                ChangePasswordOfflineWarning: "Change password only available when there is internet connection!",
                PassBlank: "Reenter password is blank or does not match!",
                PleaseConnect: "Please connect to the internet to log in!",
                InvalidPassword: "Current password is invalid. Please try again!",
                AcceptedChars: "Accepted characters are letters, numbers, and the following symbols: '.', '!'.",
                NewInvalidPass: "New password invalid. Please check requirements above.",
                InvalidCurrentPassword: "Invalid current password!",
                PasswordMustBeDifferent: "New password must be different from your last 3 passwords. Please try a different new password.",
                PasswordsDoNotMatch: "Passwords do not match!",
                PassBlockedWord1: "New password contains blocked word: ",
                PassBlockedWord2: ". Password must not contain blocked words.",
                PasswordResetSuccess: "You have successfully changed your password. Please login.",
                AgreeToReceiveInformationalMessages: "I agree to receive informational messages/notifications on my phone number from ",
                PasswordResetNotSuccessful: "Could not change password. Please try again.",
                Enable: "Enable",
                Disable: "Disable",
                UnableToSaveCode: "Unable to save the code. Please contact the support team!",
                InvalidCode: "Invalid Code",
                ConfirmingLocation: "Confirming Location - Please wait!",
                GPSNotCaptured: "Your GPS coordinates were not captured. Please try again using Refresh GPS!",
                GPSNotCaptured2: "Your GPS coordinates were not captured. You may press 'Accept Time' to start your visit, but please leave the app open for up to 3 minutes so we can keep trying to get your location.",
                GPSNotCaptured3: "Your GPS coordinates were not captured. Please try again!",
                TooEarlyToReport: "You are too early to clock in. Please clock in at your scheduled time.",
                TooLateToReport: "You are too late to clock in.",
                LocationNotCloseEnough: "Your location is not close enough to the client's home. Please clock in from the client's home and try again using Refresh GPS!",
                YourArrivalTimeIs: "Your clock-in time is ",
                SomeoneElseIsAlreadyClocked: "Someone else is already clocked in. Please ask them to clock out so that you may clock in.",
                YourDepartureTimeIs: "</br></br>Your departure time is ",
                YourVisitDurationIs: "</br></br>Visit duration is ",
                YourExpectedDeparture: " Your expected departure time is ",
                ClientDocumentsReady: " By confirming your arrival, you are acknowledging that you have read the client documents.",
                OpenShiftDate: "</br></br>Open Shift Date: ",
                OpenShiftTime: "</br></br>Open Shift Time: ",
                WeStillTryingConfirmLocation: " We are still trying to confirm your location. We will keep trying for up to 3 minutes.",
                YourExpectedDepartureTimeNotUntil: "Your expected departure time is ",
                CompleteFullySchedule: "If you would like to complete your fully scheduled time, please clock out in",
                PleaseSetStatus: "Please set a status to all items!",
                CarePlanItemAlreadyExisit: "The Care plan item you want to add is already added to the list",
                DurationGreaterThan0: "Visit duration must be greater than 0 minutes!",
                MessageConfirmLogOut: "Are you sure you want to log out?",
                Confirm: "Confirm",
                Cancel: "Cancel",
                PageAvailableOnlyOnline: "This page is only available while online.",
                SomethingWentWrong: "Something went wrong, please try again!",
                EnrolledSuccessfully: "Enrolled succesfuly!",
                SuccessfullPictureUpload: "Sucessfully uploaded the picture.",
                VisitMoved: "Visit moved today! ",
                PatientConcernTooLong: "Patient concern is too long. Please add maintain maximum of 2500 characters!",
                VisitHistoryOffline: "Visit History is only available if there is internet connection.",
                OnlyNetAccess: "Only available when there is internet access!",
                ErrorSavingSignature: "Error saving signature. Please try again or contact Ankota.",
                ErrorSavingWorkerSignature: "Error saving worker signature. Please try again or contact Ankota.",
                ErrorSavingPatientSignature: "Error saving patient signature. Please try again or contact Ankota.",
                CouldNotCreateFile: "Could not create file",
                NoRecording: "No Recording!",
                UploadedFile: "Sucessfully Uploaded File.",
                MarkWhileOffline: "You cannot mark a message as read while you are offline!",
                Offline: "You are offline",
                Syncing: "Syncing... Please Wait",
                LoadingMessage: "Loading... Please Wait",
                Title: "Title",
                Message: "Message",
                Date: "Date",
                DateAndTime: "Date & Time",
                MarkAsRead: "Mark As Read",
                Call: "Call",
                Immediately: "immediately.",
                HourShort: "h",
                MinShort: "m",
                Actions: "Actions",
                UnblockUser: "Unblock User",
                Image: "Image",
                Document: "Document",
                LoadingDocsWait: "Loading documents, please wait",
                ProcessDocsWait: "Process documents, please wait",
                PleaseConnectToLogIn: "Please connect to the internet to log in!",
                AvailableShifsNoInternet: "Available Shifts is only accessible if there is internet connection!",
                ShiftNotAvailable: "The shift is no longer available.",
                ShiftAssignedToYou: "The office scheduled you for this shift. If you can`t do it, please contact the office!",
                InvalidUserOrPass: "Invalid username or password. Please try again.",
                UnexpectedErrorContactSupport: "Unexpected error! Please contact support!",
                FingerprintAuthError: "There was an error while processing the fingerprint authentication",
                EnrollAgain: "Something went wrong, please enroll again!",
                UsernameEnrollmentError: "There is no enrollment for this username, please try a different username or login by password!",
                BiometricAuthentication: "Please input username for biometric authentication.",
                InvalidCoordinates: "Invalid Coordinates",
                SigningInPleaseWait: "Signing in, please wait",
                PleaseWaitSearch: "Please wait while we search for your active assignments.",
                SignIn: "Sign In",
                UseBackup: "Use Backup",
                FingerprintAuthentication: "Fingerprint Authentication",
                PleaseEnrollYourProfile: "Please enroll your profile",
                DoYouHave: "Do you have",
                Concerns: "concerns?",
                HRNotifications: "HR Notifications",
                NoNotifications: "No Notifications.",
                Hi: "HI",
                Expected: "expected",
                SelectLanguage: "Choose a Language...",
                ChangePassword: "Change Password",
                LoginErr: "Login invalid. Please try again.",
                About: "About",
                Account: "Account",
                UploadDocumentOrPicture: "Upload document or picture",
                Name: "Name",
                PickUpCases: "PICK UP CASES",
                CaseOrderName: "Case#:",
                TimeBetweenCases: "Time Between Cases:",
                TravelTime: "Travel Time",
                Status: "Status",
                Language: "Language",
                AssignToMe: "Assign To Me",
                AcceptCase: "Accept Case",
                DeclineCase: "Decline Case",
                SeeDetails: "See Details",
                ConsumerNoShow: "Consumer No Show",
                ReturnCase: "Return Case",
                LateCancellation: "Late Cancellation",
                YouArePreferred: "YOU ARE PREFERRED",
                NoCasesToShow: "No cases to show.",
                AssignedPatients: "ASSIGNED CLIENTS",
                AvailableShifts: "Available Shifts",
                NoAssignedPatients: "You do not have assigned clients!",
                ReportTasks: "Report Tasks",
                MyRegularSchedule: "My Regular Schedule",
                BookingsPerWeek: "Bookings Per Week",
                Slot: "Slot",
                AddASlot: "Add a Slot",
                AddTimeoffConflict: "Add Time off/Conflict",
                OverrideSchedule: "Override Schedule",
                Type: "Type",
                OverwriteEmployeeCalendar: "Overwrite Employee Calendar",
                BlockedUsers: "Blocked Users",
                Chat: "Chat",
                LoadMoreUsers: "Load More Users",
                PasswordMustBe: "Password must be",
                PasswordMustBeAtLeast: "Password must be at least",
                PasswordMustBeAtMost: "Password must be at most",
                PasswordMustContainAtLeast: "Password must contain at least",
                NumericCharacters: "numeric characters",
                SpecialCharacters: "special characters",
                CharactersLong: "characters long.",
                PasswordRequirement: "Password must contain 3 of 4 types: lower, upper, special, numeric characters.",
                CurrentPassword: "Current Password",
                NewPassword: "New Password",
                ReenterPassword: "Reenter New Password",
                TypeMsg: "Type Your Message Here...",
                To: "to",
                SentFileToYou: "has sent you a file, you can download it",
                Here: "here.",
                Hello: "Hello",
                ClientView: "Client View",
                ReportArrival: "Clock In",
                ReportDeparture: "CLOCK OUT",
                Logout: "Log out",
                Completion: "Completed Today",
                NoMatchedClients: "No matched clients! Please contact",
                ConfirmDeparture: "CONFIRM DEPARTURE",
                ArrivalDate: "Arrival Date",
                ArrivalTime: "Arrival Time",
                DepartureDate: "Departure Date",
                DepartureTime: "Departure Time",
                VisitDocuments: "Visit Documents",
                Complete: "Complete",
                Incomplete: "Incomplete",
                NotStarted: "Not started",
                ProcessDocuments: "Process Documents",
                OnlyOnline: "Can only be done online",
                ConnectionOflline: "The internet connection is offline",
                SaveIncomplete: "Save Incomplete",
                ResetToNew: "ResetToNew",
                PickerDisplay: "date/numbers time pickers",
                ReportNoShow: "Report No Show",
                ReportCancelVisit: "Report Cancel Visit",
                NotificationCenter: "NOTIFICATION CENTER",
                Visits: "Visits",
                Time: "Time",
                Client: "Client",
                Location: "Location",
                AcceptVisit: "Accept Visit",
                DeclineVisit: "Decline Visit",
                Messages: "Messages",
                Title2: "Title",
                Delete: "Delete",
                ViewDocsPatients: "View documents for the following patients:",
                ViewDocuments: "View Documents",
                Documents: "Documents",
                PayrollHistory: "PAYROLL HISTORY",
                WeeklyHours: "WEEKLY HOURS",
                NoPayrollsToShow: "No payrolls to show.",
                PayrollSummary: "PAYROLL SUMMARY",
                WeeklySummary: "WEEKLY HOURS SUMMARY",
                GrossEarnings: "GROSS EARNINGS",
                GrossEarnings2: "Gross Earnings",
                TotalHourBreakdown: "Total Hour Breakdown",
                TotalHoursWorked: "Total Hours Worked",
                VisitTime: "Visit Time",
                Regular: "Regular",
                Overtime: "Overtime",
                Adjustments: "Adjustments",
                AdjustmentsReflect: "Adjustments reflect changes to previous payments.",
                ExpectedPayment: "Expected Payment before taxes",
                HoursWorked: "Hours Worked",
                NumberofDays: "Number of Days",
                NumberOfVisits: "Number of Visits",
                VisitHistory: "Visit History",
                Trips: "Trips",
                TripOptionQuestion: "Did you complete non-medical transportation on this visit?",
                RefreshGPS: "Refresh GPS",
                ClockIn: "no clock in time",
                ClockOut: "no clock out time",
                CurrentArrival: "Clock-in Time",
                AcceptTime: "Clock In",
                ReportItems: "REPORT ITEMS",
                AddBreak: "Add Break",
                NA: "N/A",
                Set: "Set",
                NotSet: "Not Set",
                AddAnotherItem: "Add Another Item",
                NothingToAdd: "Nothing To Add",
                AddItem: "Add Item",
                NoItemsToDisplay: "No items to display.",
                Next: "Next",
                SelectVisitType: "Select Visit Type",
                Settings: "SETTINGS",
                Availability: "Availability",
                General: "General",
                Security: "Security",
                NameUploadPicturesDocs: "Name, Upload pictures/Docs",
                ConsenttoReceiveTexts: "Consent to Receive Texts",
                ChangePasswordFingerprintFaceID: "Change Password, Fingerprint/Face ID",
                AddSlots: "Add Slots",
                ToSetAdditionalSettings: "To set additional settings, please log in using the same credentials at ",
                Authentication: "AUTHENTICATION",
                EnterSMSCode: "Enter the code you received via SMS:",
                Back: "Back",
                Code: "Code",
                MyVisits: "MY VISITS",
                Address: "Address",
                CreatedByPhone: "Created by phone",
                ViewMoreDetails: "View More Details",
                NoShow: "No Show",
                Tasks: "Tasks",
                CancelVisit: "Cancel Visit",
                UploadDocs: "Upload Docs",
                DocumentsAreLoading: "Documents are loading...",
                NoDocuments: "No Documents",
                Rework: "REWORK",
                OnHold: "COMPLETE ON HOLD VISIT",
                PleaseSelectReason: "Please select a reason!",
                PleaseSelectDocument: "Please select a document!",
                NoVisitsToShow: "No visits to Show",
                UploadTimesheets: "UPLOAD TIMESHEETS",
                UploadDocuments: "Upload Documents",
                EnterAdditionalNotes: "Enter additional notes here...",
                VisitDirections: "VISIT DIRECTIONS",
                DriveTime: "Drive Time",
                PrecedingVisitEndTime: "Preceding Visit End Time",
                TimeBetweenVisits: "Time Between Visits",
                VisitAddress: "Visit Address",
                LiveDirections: "Live Directions",
                VisitDetails: "VISIT DETAILS",
                ClientName: "Client Name",
                ServiceName: "Service Name",
                VisitDate: "Visit Date",
                VisitStatus: "Visit Status",
                PrimaryPhone: "Primary Phone",
                SecondaryPhone: "Secondary Phone",
                GetDirections: "Get Directions",
                VisitNotes: "Visit Notes",
                Instructions: "Instructions",
                PleaseUseTheButton: "Please use the button on the bottom to take a picture of your sheet. Use the retry button if the picture seems unclear.",
                Keep: "Keep",
                TakePicture: "Take Picture",
                UploadOrTakePicture: "Upload Or Take Picture",
                RetakePicture: "Retake Picture",
                AddPhoto2: "ADD PHOTO",
                VisitHistoryCaps: "VISIT HISTORY",
                Completed: "completed",
                WorkerName: "Worker Name",
                Notes: "Notes",
                ResponseNotes: "Response Notes",
                AddNotes: "Add Notes",
                MoveVisitToday: "Move Visit Today",
                ShowMore: "... Show More",
                VisitType: "Visit Type",
                PleaseAsk: "Please ask ",
                ToConfirmThatTheyReceived: "to confirm that they received their",
                ServiceToday: "service today",
                Yes: "Yes",
                No: "No",
                ToConfirmThatTheVisit: "to confirm that the visit times were from",
                ReportDeparture2: "CLOCK OUT",
                ToSignHere: "to sign here",
                VoiceSignature: "Voice Signature",
                PleaseSignHere: "Please sign here",
                PleaseAskYour: "Please ask your",
                ErrandMiles: "Errand Miles",
                AddPhoto: "Add Photo",
                Clear: "Clear",
                Accept: "Accept",
                NotAvailable: "Not Available",
                VisitConfirmation: "Visit Confirmation",
                RequestForConfirmation: "Please say your name and today's date after pressing Start Recording to confirm that you received your services for today.",
                PlayRecording: "Play Recording",
                StopPlayRecording: "Stop Play Recording",
                StartRecording: "Start Recording",
                StopRecording: "Stop Recording",
                MonthView: "Month View",
                WeekView: "Week View",
                VisitSuccesfullyClosed: "Visit was successfully closed",
                ArrSuccess: "Your arrival was succesfully recorded at",
                ArrOffline: "Your arrival has been recorded but you are offline. Your office may receive a late warning.",
                ArrSuccessDeparture: "Your expected departure time is",
                CurrentVisit: "Current visit duration",
                Hours: "hours",
                Minutes: "minutes",
                ClockOutButton: "Clock Out",
                ConfirmLocation: "We are still trying to confirm your location. We will keep trying for up to 3 minutes.",
                ViewTasks: "View Tasks",
                CurrentDeparture: "Current departure time",
                Duration: "duration",
                Duration2: "Duration",
                ConfirmClockOut: "Are you sure you want to clock out?",
                Only3OnHoldVisitsWillShowAtaTime: "Only 3 On Hold visits will show at a time.",
                Submit: "Submit",
                DepSuccess: "Your departure was succesfully recorded at",
                DepOffline: "Your departure has been recorded, but you are OFFLINE. Your office may receive a late warning.",
                PleaseOpenYourAnkotaApplater: " Please open your Ankota app later today when you have better signal (when you are ONLINE) so that your visit data can be sent to the office.",
                Home: "Home",
                Save: "Save",
                ReportMissedVisit: "Report Missed Visit",
                ReportVisit: "Report Visit",
                AddMissedVisitReason: "Select reason ",
                CorrectDatesTime: "Correct the dates/times above by clicking on them and scrolling to the correct option.",
                ContigousVisitBlock: "This visit was part of a block of visits. Please enter your actual start time and your final clock-out time for this block.",
                AddWorkerDocument: "Select document ",
                ReportExpensesTitle: "Report Expenses",
                ReportExpensesQuestion: "Do you have expenses to report?",
                Amount: "Amount",
                Description: "Description",
                Company: "Company",
                NotesAndInfo: "Notes and Info",
                InfoOnlyItems: "Info Only Items",
                NoNotesForVisit: "There are no notes for this visit!",
                NoInfoForVisit: "There are no info items on this visit!",
                ContiguousVisits: "Contiguous visits",
                Details: "Details",
                Signature: "Signature",
                GoToSign: "Show pad",
                History: "History",
                NoNotesInHistory: "No notes in history!",
                CarePlanHistoryNotAvailableOffline: "Care plan item history is not available in offline mode!",
                TheVisitIsAlreadySigned: "The visit is already signed. You can continue without signature.",
                OfflineUptimeWarning: "Your device may have been restarted since your last online login. If possible please login online to update your time.",
                Phone: "Phone",
                Email: "Email",
                OfflineModeWarning: "Your application is having trouble because of bad connection and will capture your data offline. The office will be updated as soon as your network connection improves.",
                OnlineModeWarning: "Your application managed to reconnect to the server. Your visit data will now be synchronized and processed online.",
                Refresh: "Refresh",
                ResetMapsApp: "Reset Maps App",
                DefaultMapsAppWarning: "The default maps app has been reset. Next time you launch the navigator you will be able to choose a new application.",
                UseBingInstead: "Use Bing Maps",
                NoLocationWarning: "Could not capture your location. Make sure your GPS is turned on, otherwise your chosen maps application might not be able to locate your position. Do you wish to proceed anyway? You might have to input your current position manually!",
                NoMapsWarning: "No maps applications have been found on your device. Bing maps will be opened instead.",
                HoursLimitWarning: "</br><b><p style='color:Red'>Visit duration > 16 hours. Are you sure?</p></b>",
                SlotChangeWarning: "You have scheduled visits during this time slot. Please contact the office to request your availability change.",
                WorkerPhone: "Worker Phone",
                PleaseTurnOnGPS: "Your GPS is turned off. Please allow the application to capture your location before proceeding. You might need to press the 'Refresh GPS' button after allowing your location to be captured.",
                NoGPSOnVisit: "GPS location could not be detected in time. Do you wish to continue without coordinates?",
                NoGPSPermission: "You can not use this app because you have not enabled location sharing for the app. You can either update your app settings or delete and reinstall the app. If you reinstall, when you log in it will ask if the app can use your location. You must say yes to proceed.",
                SyncVisitWarning: "Visit could not be synchronized with the server. Please try again later!",
                CarePlanItemHistoryDisplayMode: "Care Plan History Display Mode",
                Individually: "Individually",
                AllAtOnce: "All at once",
                GpsTimeLeft: "The application is trying to get the GPS coordinates. In case of failure, clocking in/out will be made available in a maximum of ",
                Seconds: "seconds",
                BlockUser: "Block User",
                ServicePeriod: "Service Period",
                ServicePeriodStartDate: "Service Period Start Date",
                UseBy: "Use By",
                TotalTime: "Total Time",
                UsedTime: "Used Time",
                RemainingTime: "Remaining Time",
                AuthInfo: "Auth Info",
                YouMayWorkUpTo: "<br/><br/>You may work up to",
                NoAuthorizedUnitsLeftWarning: "You cannot start a new visit for this patient and visit type because there are 0 authorized minutes left on the visit!",
            },
            "es": { //Spanish
                Nothing: "",
                Username: "Usuario",
                Password: "Contraseña",
                NewAppVersionAvailable: "¡Hay una nueva versión de la aplicación disponible, actualice!",
                UserError: "Por favor introduzca un nombre de usuario válido.",
                PwError: "Tu contraseña tiene que tener más de 6 caracteres.",
                Login: "Acceso",
                FaceID: "Indentificación por cara",
                Fingerprint: "Huella digital",
                PwForgot: "Olvidaste contraseña?",
                Version: "Versión",
                TitleApp: "MANOS CASA CUIDADO",
                Subtitle: "Obrero Portal",
                Monday: "Lunes",
                Tuesday: "Martes",
                Wednesday: "Miércoles",
                Thursday: "Jueves",
                Friday: "Viernes",
                Saturday: "Sábado",
                Sunday: "Domingo",
                ViewMap: "Ver el mapa",
                NoteTooLong: "La nota es demasiado larga. ¡Mantenga un máximo de 512 caracteres!",
                NoteTooLong4000characters: "La nota es demasiado larga. ¡Mantenga un máximo de 4000 caracteres!",
                OfflinePassForgot: "No estás conectado. Conéctate a una red para restablecer tu contraseña",
                ConfirmPassReset: "¿Estás segura de que quieres restablecer tu contraseña?",
                ConfirmShiftResponse: "¿Está seguro de que desea responder a este turno abierto?",
                PatientName: "</br></br>Nombre del paciente: ",
                EmptyUsername: "¡Por favor, asegúrese de haber completado el nombre de usuario / correo electrónico!",
                EmptyError: "No tiene un número de teléfono o correo electrónico registrado. Comuníquese con su oficina para que restablezcan su contraseña.",
                PassResetSuccess: "Se ha enviado un correo electrónico para restablecer la contraseña a su correo electrónico",
                PhoneError: "Se ha enviado un texto de restablecimiento de contraseña a su número de teléfono.",
                NewMessages: "Es posible que tenga mensajes nuevos.",
                ReadNow: "Leer ahora",
                ReadLater: "Leer más tarde",
                Ok: "Ok",
                Close: "Cerrar",
                DeleteWorking: "¿Está seguro de que desea eliminar la hora laboral?",
                DeleteAdjustment: "¿Está seguro de que desea eliminar el ajuste <b>",
                InitiatingCall: "Iniciando llamada ...",
                CallFailed: "Error de llamada",
                CallCanceled: "Llamada cancelada",
                OngoingCall: "Llamada en curso ...",
                CallEnded: "Llamada finalizada",
                IncomingCall: "Llamada entrante",
                ConnectingToCall: "Conectando ...",
                Rejected: "Rechazado …",
                RejectionFailed: "Rechazo fallido ...",
                ChangePasswordOfflineWarning: "¡Cambiar contraseña solo está disponible cuando hay conexión a Internet!",
                PassBlank: "¡Vuelva a introducir la contraseña en blanco o no coincide!",
                PleaseConnect: "¡Conéctese a Internet para iniciar sesión!",
                InvalidPassword: "La contraseña actual no es válida. ¡Inténtelo de nuevo!",
                AcceptedChars: "Los caracteres aceptados son letras, números y los siguientes símbolos'.', '!'.",
                NewInvalidPass: "Nueva contraseña no válida. Verifique los requisitos anteriores.",
                InvalidCurrentPassword: "¡Contraseña actual no válida!",
                PasswordMustBeDifferent: "La nueva contraseña debe ser diferente de sus últimas 3 contraseñas. Pruebe con una nueva contraseña diferente.",
                PasswordsDoNotMatch: "¡Las contraseñas no coinciden!",
                PassBlockedWord1: "La nueva contraseña contiene una palabra bloqueada.",
                PassBlockedWord2: "La contraseña no debe contener palabras bloqueadas.",
                PasswordResetSuccess: "Ha cambiado correctamente su contraseña. Inicie sesión.",
                AgreeToReceiveInformationalMessages: "Acepto recibir mensajes/notificaciones informativas en mi número de teléfono de ",
                PasswordResetNotSuccessful: "No se pudo cambiar la contraseña. Inténtalo de nuevo.",
                Enable: "Activar",
                Disable: "Desactivar",
                UnableToSaveCode: "No se puede guardar el código. ¡Comuníquese con el equipo de soporte!",
                InvalidCode: "Código no válido",
                ConfirmingLocation: "Confirmando la ubicación - ¡Espere!",
                GPSNotCaptured: "No se capturaron tus coordenadas GPS. ¡Inténtalo de nuevo con Actualizar GPS!",
                GPSNotCaptured2: "No se capturaron sus coordenadas GPS. Puede presionar 'Aceptar hora' para comenzar su visita, pero deje la aplicación abierta durante un máximo de 3 minutos para que podamos seguir intentando obtener su ubicación",
                GPSNotCaptured3: "Tus coordenadas GPS no fueron capturadas. ¡Inténtalo de nuevo!",
                TooEarlyToReport: "Es demasiado temprano para registrarse. Por favor, registre a la hora programada.",
                TooLateToReport: "Llegas demasiado tarde para fichar.",
                LocationNotCloseEnough: "Su ubicación no está lo suficientemente cerca de la casa del cliente. ¡Firme desde la casa del cliente e intente nuevamente usando Refresh GPS!",
                YourArrivalTimeIs: "Su hora de entrada es ",
                SomeoneElseIsAlreadyClocked: "Alguien más ya registró su entrada. Por favor, pídale que marque su salida para que usted pueda marcar su entrada.",
                YourDepartureTimeIs: "</br></br>Tu hora de salida es ",
                YourVisitDurationIs: "</br></br>La duración de la visita es ",
                YourExpectedDeparture: "Su hora de salida prevista es",
                ClientDocumentsReady: " Al confirmar su llegada, reconoce que ha leído los documentos del cliente.",
                OpenShiftDate: "</br></br>Fecha de turno abierto: ",
                OpenShiftTime: "</br></br>Hora de turno abierto: ",
                WeStillTryingConfirmLocation: "Aún estamos tratando de confirmar su ubicación. Seguiremos intentándolo hasta por 3 minutos.",
                YourExpectedDepartureTimeNotUntil: "Su hora de salida prevista es",
                CompleteFullySchedule: "Si desea completar su tiempo completamente programado, marque el reloj en",
                PleaseSetStatus: "¡Establezca un estado para todos los elementos!",
                CarePlanItemAlreadyExisit: "El elemento del plan de atención que desea agregar ya está agregado a la lista",
                DurationGreaterThan0: "¡La duración de la visita debe ser superior a 0 minutos!",
                MessageConfirmLogOut: "¿Está seguro de que desea cerrar la sesión?",
                Confirm: "Confirmar",
                Cancel: "Cancelar",
                PageAvailableOnlyOnline: "Esta página solo está disponible mientras está en línea.",
                SomethingWentWrong: "Algo salió mal, ¡inténtalo de nuevo!",
                EnrolledSuccessfully: "¡Inscrito satisfactoriamente!",
                SuccessfullPictureUpload: "Subió la imagen correctamente.",
                VisitMoved: "¡Visita movida hoy!",
                PatientConcernTooLong: "La preocupación del paciente es demasiado larga. ¡Por favor mantenga un máximo de 512 caracteres!",
                VisitHistoryOffline: "El historial de visitas solo está disponible si hay conexión a Internet",
                OnlyNetAccess: "¡Solo disponible cuando hay acceso a Internet! ",
                ErrorSavingSignature: "Error al guardar la firma. Vuelva a intentarlo o póngase en contacto con Ankota",
                ErrorSavingWorkerSignature: "Error al guardar la firma del trabajador. Vuelva a intentarlo o póngase en contacto con Ankota.",
                ErrorSavingPatientSignature: "Error al guardar la firma del paciente. Vuelva a intentarlo o póngase en contacto con Ankota.",
                CouldNotCreateFile: "No se pudo crear el archivo",
                NoRecording: "¡No hay grabación!",
                UploadedFile: "Archivo cargado correctamente",
                MarkWhileOffline: "¡No puede marcar un mensaje como leído mientras está desconectado!",
                Offline: "Estás desconectado",
                Syncing: "Sincronizando ... Espere",
                LoadingMessage: "Cargando ... Espere",
                Title: "Título",
                Message: "Mensaje",
                Date: "Fecha",
                DateAndTime: "Fecha & Hora",
                MarkAsRead: "Marcar como leído ",
                Call: "Llamar",
                Immediately: "inmediatamente.",
                HourShort: "h",
                MinShort: "m",
                Actions: "Acciones",
                UnblockUser: "Desbloquear usuario",
                Image: "Imagen",
                Document: "Documento",
                LoadingDocsWait: "Cargando documentos, espere",
                ProcessDocsWait: "Procesar documentos, espere",
                PleaseConnectToLogIn: "¡Conéctese a Internet para iniciar sesión!",
                AvailableShifsNoInternet: "¡Los turnos disponibles solo son accesibles si hay conexión a Internet!",
                ShiftAssignedToYou: "La oficina le programó para este turno. Si no puede hacerlo, comuníquese con la oficina.",
                ShiftNotAvailable: "El turno ya no está disponible.",
                InvalidUserOrPass: "Nombre de usuario o contraseña no válidos. Vuelva a intentarlo",
                UnexpectedErrorContactSupport: "¡Error inesperado! ¡Póngase en contacto con el servicio de asistencia!",
                FingerprintAuthError: "Hubo un error al procesar la autenticación de huellas digitales",
                EnrollAgain: "Algo salió mal, ¡inscríbase nuevamente!",
                UsernameEnrollmentError: "No hay registro para este nombre de usuario, ¡intente con un nombre de usuario diferente o inicie sesión con contraseña!",
                BiometricAuthentication: "Introduzca el nombre de usuario para la autenticación biométrica",
                InvalidCoordinates: "Coordenadas no válidas",
                SigningInPleaseWait: "Iniciando sesión, espere",
                PleaseWaitSearch: "Espere mientras buscamos sus asignaciones activas.",
                SignIn: "Iniciar sesión",
                UseBackup: "Usar copia de seguridad",
                FingerprintAuthentication: "Autenticación de huellas dactilares",
                PleaseEnrollYourProfile: "Por favor, registre su perfil",
                DoYouHave: "¿Tienes",
                Concerns: "preocupaciones",
                HRNotifications: "Notificaciones de RRHH",
                NoNotifications: "No hay notificaciones",
                Hi: "HOLA",
                Expected: "esperado",
                SelectLanguage: "Elija un idioma ...",
                ChangePassword: "Cambiar la contraseña",
                LoginErr: "Su información de inicio de sesión no es válida. Inténtalo de nuevo.",
                About: "Acerca de",
                Account: "Cuenta",
                UploadDocumentOrPicture: "Subir documento o imagen",
                Name: "Nombre",
                PickUpCases: "RECOGER CASOS",
                CaseOrderName: "Caso #:",
                TimeBetweenCases: "Tiempo entre casos:",
                TravelTime: "Tiempo de viaje",
                Status: "Estado",
                Language: "Idioma",
                AssignToMe: "Asignarme",
                AcceptCase: "Aceptar caso",
                DeclineCase: "Rechazar caso",
                SeeDetails: "Ver detalles",
                ConsumerNoShow: "Consumidor No Llegó",
                ReturnCase: "Devolver caso",
                LateCancellation: "Cancelación tardía",
                YouArePreferred: "ERES PREFERIDO",
                NoCasesToShow: "No hay casos para mostrar.",
                AssignedPatients: "CLIENTES ASIGNADOS",
                AvailableShifts: "Turnos Disponibles",
                NoAssignedPatients: "¡No tienes clientes asignados!",
                ReportTasks: "Informar de tareas",
                MyRegularSchedule: "Mi horario regular",
                BookingsPerWeek: "Reservas por semana",
                Slot: "Ranura",
                AddASlot: "Agregar una ranura",
                AddTimeoffConflict: "Agregar tiempo libre/conflicto",
                OverrideSchedule: "Anular programación",
                Type: "Tipo",
                OverwriteEmployeeCalendar: "Sobrescribir calendario de empleados",
                BlockedUsers: "Usuarios bloqueados",
                Chat: "Charla",
                LoadMoreUsers: "Cargar más usuarios",
                PasswordMustBe: "La contraseña debe ser",
                PasswordMustBeAtLeast: "La contraseña debe ser al menos",
                PasswordMustBeAtMost: "La contraseña debe ser como máximo",
                PasswordMustContainAtLeast: "La contraseña debe contener al menos",
                NumericCharacters: "caracteres numéricos",
                SpecialCharacters: "caracteres especiales",
                CharactersLong: "caracteres de longitud",
                PasswordRequirement: "La contraseña debe contener 3 de 4 tiposcaracteres numéricos inferiores, superiores, especiales.",
                CurrentPassword: "Contraseña actual",
                NewPassword: "Nueva contraseña",
                ReenterPassword: "Vuelva a ingresar la nueva contraseña",
                TypeMsg: "Escriba su mensaje aquí ...",
                To: "a",
                SentFileToYou: "te ha enviado un archivo, puedes descargarlo",
                Here: "aquí.",
                Hello: "Hola ",
                ClientView: "Vista del Cliente",
                ReportArrival: "Marcar la Entrada",
                ReportDeparture: "Marcar la Salida",
                Logout: "Cerrar Sesión",
                Completion: "Completado hoy",
                NoMatchedClients: "¡No hay clientes coincidentes! Por favor, contacte",
                ConfirmDeparture: "CONFIRMAR SALIDA",
                ArrivalDate: "Fecha de llegada",
                ArrivalTime: "Hora de llegada",
                DepartureDate: "Fecha de salida",
                DepartureTime: "Hora de salida",
                VisitDocuments: "Documentos de visita",
                Complete: "Completo",
                Incomplete: "Incompleto",
                NotStarted: "No iniciado",
                ProcessDocuments: "Documentos de proceso",
                OnlyOnline: "solo se puede hacer en línea",
                ConnectionOflline: "La conexión a Internet está desconectada",
                SaveIncomplete: "Guardar incompleto",
                ResetToNew: "Reiniciar a nuevo",
                PickerDisplay: "selectores de fecha / números y hora",
                ReportNoShow: "Informar No llegó",
                ReportCancelVisit: "Reportar Cancelar Visita",
                NotificationCenter: "CENTRO DE NOTIFICACIONES",
                Visits: "Visitas",
                Time: "Hora",
                Client: "Cliente",
                Location: "Ubicación",
                AcceptVisit: "Aceptar visita",
                DeclineVisit: "Rechazar visita",
                Messages: "Mensajes",
                Title2: "Título",
                Delete: "Eliminar",
                ViewDocsPatients: "Ver documentos de los siguientes pacientes:",
                ViewDocuments: "Ver documentos",
                Documents: "Documentos",
                PayrollHistory: "HISTORIAL DE NÓMINA",
                WeeklyHours: "HORAS SEMANALES",
                NoPayrollsToShow: "No hay nóminas para mostrar",
                PayrollSummary: "PAYROLL SUMMARY",
                WeeklySummary: "RESUMEN DE HORAS SEMANALES",
                GrossEarnings: "GANANCIAS BRUTAS",
                GrossEarnings2: "Ingresos brutos",
                TotalHourBreakdown: "Desglose total de horas",
                Regular: "Regular",
                Overtime: "Con el tiempo",
                TotalHoursWorked: "Total de horas trabajadas",
                VisitTime: "Hora de visita",
                Adjustments: "Ajustes",
                AdjustmentsReflect: "Los ajustes reflejan cambios en pagos anteriores.",
                ExpectedPayment: "Pago esperado antes de impuestos",
                HoursWorked: "Horas trabajadas",
                NumberofDays: "Número de días",
                NumberOfVisits: "Número de visitas",
                VisitHistory: "Historial de visitas",
                Trips: "Viajes",
                TripOptionQuestion: "¿Completó el transporte no médico en esta visita?",
                RefreshGPS: "Actualizar GPS",
                ClockIn: "sin reloj a tiempo",
                ClockOut: "sin tiempo de salida",
                CurrentArrival: "Hora de entrada",
                AcceptTime: "Entrar",
                ReportItems: "ARTÍCULOS DEL INFORME",
                AddBreak: "Agregar descanso",
                NA: "N/A",
                Set: "Establecer",
                NotSet: "No establecido ",
                AddAnotherItem: "Agregar otro elemento",
                NothingToAdd: "Nada para agregar",
                AddItem: "Agregar elemento",
                NoItemsToDisplay: "No hay elementos para mostrar",
                Next: "Siguiente",
                SelectVisitType: "Seleccionar tipo de visita",
                Settings: "AJUSTES",
                General: "General",
                Security: "Seguridad",
                NameUploadPicturesDocs: "Nombre, Subir fotos/documentos",
                ConsenttoReceiveTexts: "Consentimiento para recibir mensajes de texto",
                ChangePasswordFingerprintFaceID: "Cambiar contraseña, huella digital/Face ID",
                AddSlots: "Añadir ranuras",
                Availability: "Disponibilidad",
                ToSetAdditionalSettings: "Para establecer configuraciones adicionales, inicie sesión con las mismas credenciales en ",
                Authentication: "AUTENTICACIÓN",
                EnterSMSCode: "Ingrese el código que recibió por SMS:",
                Back: "Atrás",
                Code: "Código",
                MyVisits: "MIS VISITAS",
                Address: "Dirección",
                CreatedByPhone: "Creado por teléfono",
                ViewMoreDetails: "Ver más detalles",
                NoShow: "No Show",
                Tasks: "Tareas",
                CancelVisit: "Cancelar visita",
                UploadDocs: "Subir documentos",
                DocumentsAreLoading: "Los documentos se están cargando...",
                NoDocuments: "Sin documentos",
                Rework: "REHACER",
                OnHold: "COMPLETA VISITA EN ESPERA",
                PleaseSelectReason: "¡Por favor seleccione una razón!",
                PleaseSelectDocument: "¡Seleccione un documento!",
                NoVisitsToShow: "No hay visitas al programa",
                UploadTimesheets: "SUBIR HOJAS DE TIEMPO",
                UploadDocuments: "Subir documentos",
                EnterAdditionalNotes: "Introduzca notas adicionales aquí ...",
                VisitDirections: "INSTRUCCIONES DE VISITA",
                DriveTime: "Tiempo de conducción",
                PrecedingVisitEndTime: "Hora de finalización de la visita anterior",
                TimeBetweenVisits: "Tiempo entre visitas",
                VisitAddress: "Dirección de visita",
                LiveDirections: "Direcciones en vivo",
                VisitDetails: "DETALLES DE LA VISITA",
                ClientName: "Nombre del cliente",
                ServiceName: "Nombre del servicio",
                VisitDate: "Fecha de visita",
                VisitStatus: "Estado de la visita",
                PrimaryPhone: "Teléfono principal",
                SecondaryPhone: "Teléfono secundario",
                GetDirections: "Obtener direcciones",
                VisitNotes: "Notas de visita",
                Instructions: "Instrucciones",
                PleaseUseTheButton: "Utilice el botón de la parte inferior para tomar una foto de su hoja. Utilice el botón de reintento si la imagen no parece clara.",
                Keep: "Mantener",
                TakePicture: "Tomar foto",
                UploadOrTakePicture: "Subir o tomar una foto",
                RetakePicture: "Retomar imagen",
                AddPhoto2: "AÑADIR FOTO",
                VisitHistoryCaps: "HISTORIA DE VISITA",
                Completed: "completado",
                WorkerName: "Nombre del trabajador",
                Notes: "Notas",
                ResponseNotes: "Notas de respuesta",
                AddNotes: "Agregar notas",
                MoveVisitToday: "Mover visita hoy",
                ShowMore: "... Mostrar más",
                VisitType: "Tipo de visita",
                PleaseAsk: "Por favor pregunte ",
                ToConfirmThatTheyReceived: "para confirmar que recibieron su",
                ServiceToday: "servicio hoy",
                Yes: "Sí",
                No: "No",
                ToConfirmThatTheVisit: "para confirmar que las horas de visita eran de",
                ReportDeparture2: "RELOJ DE SALIDA",
                ToSignHere: "para firmar aquí",
                VoiceSignature: "Firma de voz",
                PleaseSignHere: "Por favor firme aquí",
                PleaseAskYour: "Por favor pregunte a su",
                ErrandMiles: "Millas de recados",
                AddPhoto: "Agregar foto",
                Clear: "Borrar",
                Accept: "Aceptar",
                NotAvailable: "No disponible",
                VisitConfirmation: "Confirmación de visita",
                RequestForConfirmation: "Diga su nombre y la fecha de hoy después de presionar Iniciar grabación para confirmar que recibió sus servicios para hoy",
                PlayRecording: "Reproducir grabación",
                StopPlayRecording: "Para Reproducir grabación",
                StartRecording: "Iniciar grabación",
                StopRecording: "Detener grabación",
                MonthView: "Vista de mes",
                WeekView: "Vista de semana",
                ArrSuccess: "Su llegada fue grabada con éxito en",
                ArrOffline: "Se ha registrado su llegada, pero no está conectado. Es posible que su oficina reciba una advertencia tardía.",
                ArrSuccessDeparture: "Su hora de salida prevista es",
                CurrentVisit: "Duración actual de la visita",
                Hours: "horas",
                Minutes: "minutos",
                ClockOutButton: "Salir",
                ConfirmLocation: "Aún estamos tratando de confirmar su ubicación. Seguiremos intentándolo hasta por 3 minutos.",
                ViewTasks: "Ver tareas",
                CurrentDeparture: "Hora actual de salida",
                Duration: "duración",
                Duration2: "Duración",
                ConfirmClockOut: "¿Estás seguro de que quieres sincronizar?",
                Only3OnHoldVisitsWillShowAtaTime: "Solo se mostrarán 3 visitas en espera a la vez",
                Submit: "Enviar",
                DepSuccess: "Su partida fue grabada con éxito en",
                VisitSuccesfullyClosed: "La visita se cerró con éxito",
                DepOffline: "Se ha registrado su salida pero no está conectado. Es posible que su oficina reciba una advertencia tardía.",
                PleaseOpenYourAnkotaApplater: " Abra su aplicación Ankota más tarde hoy cuando tenga mejor señal (cuando estás EN LÍNEA) para que los datos de su visita se puedan enviar a la oficina.",
                Home: "Casa",
                Save: "Guardar ",
                ReportMissedVisit: "Informe visita pérdida",
                ReportVisit: "Informe de visita",
                AddMissedVisitReason: "Seleccionar el motivo ",
                CorrectDatesTime: "Corrija las fechas/horas anteriores haciendo clic en ellas y desplazándose hasta la opción correcta.",
                ContigousVisitBlock: "Esta visita fue parte de un bloque de visitas. Ingrese su hora de inicio real y su hora de salida final para este bloque.",
                AddWorkerDocument: "Seleccionar documento ",
                ReportExpensesTitle: "Informe de gastos",
                ReportExpensesQuestion: "¿Tiene gastos que informar?",
                Amount: "La suma",
                Description: "La descripción",
                Company: "Empresa",
                NotesAndInfo: "Notas e información",
                InfoOnlyItems: "Elementos de solo información",
                NoNotesForVisit: "¡No hay notas para esta visita!",
                NoInfoForVisit: "¡No hay elementos de información en esta visita!",
                ContiguousVisits: "Visitas contiguas",
                Details: "Detalles",
                Signature: "Firma",
                GoToSign: "Mostrar pad",
                History: "Historia",
                NoNotesInHistory: "¡No hay notas en la historia!",
                CarePlanHistoryNotAvailableOffline: "¡El historial de elementos del plan de cuidados no está disponible en modo fuera de línea!",
                TheVisitIsAlreadySigned: "La visita ya está firmada. Puede continuar sin firma.",
                OfflineUptimeWarning: "Es posible que su dispositivo se haya reiniciado desde su último inicio de sesión en línea. Si es posible, inicie sesión en línea para actualizar su hora.",
                Phone: "Teléfono",
                Email: "Correo electrónico",
                OfflineModeWarning: "Su aplicación tiene problemas debido a una mala conexión y capturará sus datos sin conexión. La oficina se actualizará tan pronto como mejore su conexión de red.",
                OnlineModeWarning: "Su aplicación logró volver a conectarse al servidor. Los datos de su visita ahora se sincronizarán y procesarán en línea.",
                Refresh: "Actualizar",
                ResetMapsApp: "Restablecer aplicación de mapas",
                DefaultMapsAppWarning: "La aplicación de mapas predeterminada se ha restablecido. La próxima vez que inicie el navegador podrá elegir una nueva aplicación.",
                UseBingInstead: "Usar mapas de Bing",
                NoLocationWarning: "No se pudo capturar tu ubicación. Asegúrese de que su GPS esté encendido, de lo contrario, es posible que la aplicación de mapas elegida no pueda ubicar su posición. ¿Desea continuar de todos modos? ¡Es posible que deba ingresar su posición actual manualmente!",
                NoMapsWarning: "No se han encontrado aplicaciones de mapas en su dispositivo. En su lugar, se abrirán los mapas de Bing.",
                HoursLimitWarning: "</br><b><p style='color:Red'>Duración de la visita > 16 horas. ¿Está seguro?</p></b>",
                SlotChangeWarning: "Tiene visitas programadas durante este horario. Comuníquese con la oficina para solicitar su cambio de disponibilidad.",
                WorkerPhone: "Teléfono del trabajador",
                PleaseTurnOnGPS: "Su GPS está apagado. Permita que la aplicación capture su ubicación antes de continuar. Es posible que deba presionar el botón 'Actualizar GPS' después de permitir que se capture su ubicación.",
                NoGPSOnVisit: "La ubicación del GPS no se pudo detectar a tiempo. ¿Desea continuar sin coordenadas?",
                NoGPSPermission: "No puede usar esta aplicación porque no ha habilitado el uso compartido de la ubicación para la aplicación. Puede actualizar la configuración de su aplicación o eliminarla y reinstalarla. Si reinstala, cuando inicie sesión le preguntará si la aplicación puede usar su ubicación. Debe decir que sí para continuar.",
                SyncVisitWarning: "La visita no se pudo sincronizar con el servidor. ¡Por favor, inténtelo de nuevo más tarde!",
                CarePlanItemHistoryDisplayMode: "Modo de visualización del historial del plan de cuidados",
                Individually: "Individualmente",
                AllAtOnce: "De repente",
                GpsTimeLeft: "La aplicación está intentando obtener las coordenadas GPS. En caso de falla, el fichaje de entrada/salida estará disponible en un máximo de ",
                Seconds: "segundos",
                BlockUser: "Bloquear usuario",
                ServicePeriod: "Periodo de servicio",
                ServicePeriodStartDate: "Fecha de inicio del período de servicio",
                UseBy: "Usar por",
                TotalTime: "Tiempo Total",
                UsedTime: "Tiempo usado",
                RemainingTime: "Tiempo restante",
                AuthInfo: "Auth Info",
                YouMayWorkUpTo: "<br/><br/>Puede trabajar hasta",
                NoAuthorizedUnitsLeftWarning: "¡No puede iniciar una nueva visita para este paciente y tipo de visita porque quedan 0 minutos autorizados en la visita!",
            },
            "gu": { //Gujarati
                Nothing: "",
                Username: "ઇમેઇલ અથવા વપરાશકર્તા નામ",
                Password: "પાસવર્ડ",
                NewAppVersionAvailable: "નવું એપ્લિકેશન સંસ્કરણ ઉપલબ્ધ છે કૃપા કરીને અપડેટ કરો!",
                UserError: "કૃપા કરી માન્ય વપરાશકર્તા નામ દાખલ કરો.",
                PwError: "તમારા પાસવર્ડને 6 અક્ષરોથી વધુની જરૂર છે.",
                Login: "પ્રવેશ કરો",
                FaceID: "ફેસ આઈડી ",
                Fingerprint: "ફિંગરપ્રિન્ટ",
                PwForgot: "પાસવર્ડ ભૂલી ગયા છો",
                Version: "સંસ્કરણ",
                TitleApp: "મેનૂઝ ઘરની સંભાળ",
                Subtitle: "કેરજીવર પોર્ટલ",
                Monday: "સોમવાર",
                Tuesday: "મંગળવારે",
                Wednesday: "બુધવાર",
                Thursday: "ગુરુવાર",
                Friday: "શુક્રવાર",
                Saturday: "શનિવાર",
                Sunday: "રવિવાર",
                ViewMap: "નકશો જુઓ",
                NoteTooLong: "નોંધ ખૂબ લાંબી છે. કૃપા કરીને મહત્તમ 512 અક્ષરો જાળવો!",
                NoteTooLong4000characters: "નોંધ ખૂબ લાંબી છે. કૃપા કરીને મહત્તમ 4000 અક્ષરો જાળવો!",
                OfflinePassForgot: "તમે offlineફલાઇન છો. કૃપા કરીને તમારો પાસવર્ડ ફરીથી સેટ કરવા માટે નેટવર્કથી કનેક્ટ થાઓ.",
                ConfirmPassReset: "શું તમે ખરેખર તમારો પાસવર્ડ ફરીથી સેટ કરવા માંગો છો?",
                ConfirmShiftResponse: "શું તમે ખરેખર આ ઓપન શિફ્ટ માટે પ્રતિસાદ આપવા માંગો છો?",
                PatientName: "</br></br>દર્દીનું નામ: ",
                EmptyUsername: "કૃપા કરીને ખાતરી કરો કે તમારી પાસે વપરાશકર્તાનામ / ઇમેઇલ પૂર્ણ છે!",
                EmptyError: "તમારી પાસે ફાઇલ પર ફોન નંબર અથવા ઇમેઇલ નથી. તમારો પાસવર્ડ ફરીથી સેટ કરવા માટે કૃપા કરીને તમારી officeફિસનો સંપર્ક કરો.",
                PassResetSuccess: "તમારા ઇમેઇલ પર પાસવર્ડ રીસેટ ઇમેઇલ મોકલવામાં આવ્યો છે",
                PhoneError: "પાસવર્ડ રીસેટ ટેક્સ્ટ તમારા ફોન નંબર પર મોકલવામાં આવ્યો છે.",
                NewMessages: "તમારી પાસે નવા સંદેશા હોઈ શકે છે.",
                ReadNow: "હવે વાંચો",
                ReadLater: "પછી વાંચો",
                Ok: "બરાબર",
                Close: "બંધ",
                DeleteWorking: "શું તમે ખરેખર કામનો સમય કા deleteી નાખવા માંગો છો?",
                DeleteAdjustment: "શું તમે ખરેખર <b> ગોઠવણ કા deleteી નાખવા માંગો છો?",
                InitiatingCall: "ક callલ શરૂ કરી રહ્યાં છે ...",
                CallFailed: "ક Callલ નિષ્ફળ",
                CallCanceled: "ક Callલ રદ થયો",
                OngoingCall: "ચાલુ ક callલ ...",
                CallEnded: "ક Callલ સમાપ્ત થયો",
                IncomingCall: "ઇનકમિંગ ક callલ",
                ConnectingToCall: "કનેક્ટ થઈ રહ્યું છે ...",
                Rejected: "નામંજૂર ...",
                RejectionFailed: "અસ્વીકાર નિષ્ફળ ...",
                ChangePasswordOfflineWarning: "ઇન્ટરનેટ કનેક્શન હોય ત્યારે જ પાસવર્ડ બદલો!",
                PassBlank: "ફરીથી દાખલ કરો પાસવર્ડ ખાલી છે અથવા મેળ ખાતો નથી!",
                PleaseConnect: "લ logગ ઇન કરવા માટે કૃપા કરીને ઇન્ટરનેટથી કનેક્ટ થાઓ!",
                InvalidPassword: "વર્તમાન પાસવર્ડ અમાન્ય છે. મેહરબાની કરી ને ફરી થી પ્રયાસ કરો!",
                AcceptedChars: "સ્વીકૃત અક્ષરો એ અક્ષરો, સંખ્યાઓ અને નીચેના પ્રતીકો છે '.', '!'.",
                NewInvalidPass: "નવો પાસવર્ડ અમાન્ય. કૃપા કરીને ઉપરની જરૂરિયાતો તપાસો.",
                InvalidCurrentPassword: "અમાન્ય વર્તમાન પાસવર્ડ!",
                PasswordMustBeDifferent: "નવો પાસવર્ડ તમારા છેલ્લા 3 પાસવર્ડ્સથી ભિન્ન હોવો જોઈએ. કૃપા કરી કોઈ નવો પાસવર્ડ અજમાવો.",
                PasswordsDoNotMatch: "પાસવર્ડ્સ મેળ ખાતા નથી!",
                PassBlockedWord1: "નવા પાસવર્ડમાં અવરોધિત શબ્દ છે",
                PassBlockedWord2: "પાસવર્ડમાં અવરોધિત શબ્દો હોવા જોઈએ નહીં.",
                PasswordResetSuccess: "તમે તમારો પાસવર્ડ સફળતાપૂર્વક બદલી નાખ્યો છે. મહેરબાની કરીને લ .ગિન કરો.",
                AgreeToReceiveInformationalMessages: "હું મારા ફોન નંબર પર માહિતીપ્રદ સંદેશાઓ/સૂચના પ્રાપ્ત કરવા માટે સંમત છું ",
                PasswordResetNotSuccessful: "પાસવર્ડ બદલી શકાયો નથી. મહેરબાની કરીને ફરીથી પ્રયતન કરો.",
                Enable: "સક્ષમ કરો",
                Disable: "અક્ષમ કરો",
                UnableToSaveCode: "કોડ સાચવવામાં અસમર્થ. સપોર્ટ ટીમનો સંપર્ક કરો!",
                InvalidCode: "અમાન્ય કોડ",
                ConfirmingLocation: "પુષ્ટિ સ્થાન - કૃપા કરીને રાહ જુઓ!",
                GPSNotCaptured: "તમારા જીપીએસ કોઓર્ડિનેટ્સ કબજે કર્યાં નથી. રીફ્રેશ જીપીએસનો ઉપયોગ કરીને ફરીથી પ્રયાસ કરો!",
                GPSNotCaptured2: "તમારા જીપીએસ કોઓર્ડિનેટ્સ કબજે કર્યાં નથી તમારી મુલાકાત શરૂ કરવા માટે તમે 'સ્વીકારો સમય' દબાવો, પરંતુ કૃપા કરીને એપ્લિકેશનને 3 મિનિટ સુધી ખુલ્લી મુકો જેથી અમે તમારું સ્થાન મેળવવાનો પ્રયાસ કરી શકીએ.",
                GPSNotCaptured3: "તમારા જીપીએસ કોઓર્ડિનેટ્સ કબજે કર્યાં નથી મેહરબાની કરી ને ફરી થી પ્રયાસ કરો!",
                TooEarlyToReport: "તમે ઘડિયાળમાં આવવા માટે ખૂબ વહેલા છો. કૃપા કરીને તમારા નિર્ધારિત સમયે ઘડિયાળ કરો.",
                TooLateToReport: "તમે ઘડિયાળમાં આવવામાં ખૂબ મોડું કર્યું છે.",
                LocationNotCloseEnough: "તમારું સ્થાન ગ્રાહકના ઘરની પૂરતું નજીક નથી. કૃપા કરીને ક્લાયન્ટના ઘરેથી ઘડિયાળમાં જાઓ અને રિફ્રેશ જીપીએસનો ઉપયોગ કરીને ફરી પ્રયાસ કરો!",
                YourArrivalTimeIs: "તમારો ઘડિયાળનો સમય છે",
                SomeoneElseIsAlreadyClocked: "અન્ય કોઈ પહેલેથી જ ઘડિયાળમાં છે. કૃપા કરીને તેમને ઘડિયાળ બહાર આવવા માટે કહો જેથી કરીને તમે ઘડિયાળમાં જઈ શકો.",
                YourDepartureTimeIs: "</br></br> તમારા પ્રસ્થાનનો સમય છે ",
                YourVisitDurationIs: "</br></br> મુલાકાત સમયગાળો છે ",
                YourExpectedDeparture: "તમારો અપેક્ષિત પ્રસ્થાનનો સમય છે",
                ClientDocumentsReady: " તમારા આગમનની પુષ્ટિ કરીને, તમે સ્વીકારો છો કે તમે ક્લાયન્ટના દસ્તાવેજો વાંચ્યા છે.",
                OpenShiftDate: "</br></br>ઓપન શિફ્ટ તારીખ: ",
                OpenShiftTime: "</br></br>ઓપન શિફ્ટ સમય: ",
                WeStillTryingConfirmLocation: "અમે હજી પણ તમારા સ્થાનની પુષ્ટિ કરવાનો પ્રયાસ કરી રહ્યા છીએ. અમે 3 મિનિટ સુધી પ્રયત્ન કરીશું.",
                YourExpectedDepartureTimeNotUntil: "તમારો અપેક્ષિત પ્રસ્થાન સમય છે",
                CompleteFullySchedule: "જો તમે તમારો સંપૂર્ણ નિર્ધારિત સમય પૂર્ણ કરવા માંગતા હો, તો કૃપા કરીને ઘડિયાળમાં જાવ",
                PleaseSetStatus: "કૃપા કરીને બધી વસ્તુઓ માટે એક સ્થિતિ સેટ કરો!",
                CarePlanItemAlreadyExisit: "તમે જે કેર પ્લાન આઇટમ ઉમેરવા માંગો છો તે પહેલેથી જ સૂચિમાં ઉમેરવામાં આવી છે",
                DurationGreaterThan0: "મુલાકાતની અવધિ 0 મિનિટથી વધુ હોવી જોઈએ!",
                MessageConfirmLogOut: "શું તમે ખરેખર લ logગ આઉટ કરવા માંગો છો?",
                Confirm: "પુષ્ટિ કરો",
                Cancel: "રદ કરો",
                PageAvailableOnlyOnline: "આ પૃષ્ઠ ફક્ત whileનલાઇન હોવા પર જ ઉપલબ્ધ છે.",
                SomethingWentWrong: "કંઈક ખોટું થયું, કૃપા કરીને ફરીથી પ્રયાસ કરો!",
                EnrolledSuccessfully: "સફળતાપૂર્વક નોંધાયેલ!",
                SuccessfullPictureUpload: "સફળતાપૂર્વક ચિત્ર અપલોડ કર્યું.",
                VisitMoved: "મુલાકાત આજે ખસેડી!",
                PatientConcernTooLong: "દર્દીની ચિંતા ખૂબ લાંબી છે. કૃપા કરીને મહત્તમ 512 અક્ષરો જાળવવા ઉમેરો!",
                VisitHistoryOffline: "ઇન્ટરનેટ કનેક્શન હોય તો જ મુલાકાત ઇતિહાસ ઉપલબ્ધ છે.",
                OnlyNetAccess: "જ્યારે ત્યાં ઇન્ટરનેટ accessક્સેસ હોય ત્યારે જ ઉપલબ્ધ!",
                ErrorSavingSignature: "સહી સાચવવામાં ભૂલ. કૃપા કરી ફરીથી પ્રયત્ન કરો અથવા અંકોટાનો સંપર્ક કરો.",
                ErrorSavingWorkerSignature: "કાર્યકરની સહી સાચવવામાં ભૂલ. કૃપા કરી ફરીથી પ્રયત્ન કરો અથવા અંકોટાનો સંપર્ક કરો.",
                ErrorSavingPatientSignature: "દર્દીની સહી સાચવવામાં ભૂલ. કૃપા કરી ફરીથી પ્રયત્ન કરો અથવા અંકોટાનો સંપર્ક કરો.",
                CouldNotCreateFile: "ફાઇલ બનાવી શકાઈ નથી",
                NoRecording: "કોઈ રેકોર્ડિંગ નથી!",
                UploadedFile: "સફળતાપૂર્વક અપલોડ કરેલી ફાઇલ.",
                MarkWhileOffline: "તમે offlineફલાઇન હો ત્યારે સંદેશને વાંચેલા તરીકે ચિહ્નિત કરી શકતા નથી !,",
                Offline: "તમે offlineફલાઇન છો",
                Syncing: "સિંક કરી રહ્યું છે ... કૃપા કરી પ્રતીક્ષા કરો",
                LoadingMessage: "લોડ કરી રહ્યું છે ... કૃપા કરી પ્રતીક્ષા કરો",
                Title: "શીર્ષક",
                Message: "સંદેશ",
                Date: "તારીખ",
                DateAndTime: "તારીખ સમય",
                MarkAsRead: "વાંચો તરીકે ચિહ્નિત કરો ",
                Call: "બોલાવો",
                Immediately: "તરત.",
                HourShort: "એચ",
                MinShort: "મી",
                Actions: "ક્રિયાઓ",
                UnblockUser: "વપરાશકર્તાને અનાવરોધિત કરો,",
                Image: "છબી",
                Document: "દસ્તાવેજ",
                LoadingDocsWait: "દસ્તાવેજો લોડ કરી રહ્યું છે, કૃપા કરી પ્રતીક્ષા કરો",
                ProcessDocsWait: "પ્રક્રિયા દસ્તાવેજો, કૃપા કરીને રાહ જુઓ",
                PleaseConnectToLogIn: "લ logગ ઇન કરવા માટે કૃપા કરીને ઇન્ટરનેટથી કનેક્ટ થાઓ!",
                AvailableShifsNoInternet: "જો ત્યાં ઇન્ટરનેટ કનેક્શન હોય તો જ ઉપલબ્ધ શિફ્ટ્સ સુલભ છે!",
                ShiftNotAvailable: "શિફ્ટ હવે ઉપલબ્ધ નથી.",
                ShiftAssignedToYou: "ઓફિસે તમને આ શિફ્ટ માટે સુનિશ્ચિત કર્યા છે. જો તમે તે કરી શકતા નથી, તો કૃપા કરીને ઑફિસનો સંપર્ક કરો!",
                InvalidUserOrPass: "અમાન્ય વપરાશકર્તાનામ અથવા પાસવર્ડ. મેહરબાની કરી ને ફરી થી પ્રયાસ કરો.",
                UnexpectedErrorContactSupport: "અનપેક્ષિત ભૂલ! આધાર સંપર્ક કરો!",
                FingerprintAuthError: "ફિંગરપ્રિન્ટ પ્રમાણીકરણની પ્રક્રિયા કરતી વખતે ભૂલ આવી હતી",
                EnrollAgain: "કંઈક ખોટું થયું, કૃપા કરી ફરીથી નોંધણી કરો!",
                UsernameEnrollmentError: "આ વપરાશકર્તા નામ માટે કોઈ નોંધણી નથી, કૃપા કરીને કોઈ અલગ વપરાશકર્તાનામનો પ્રયાસ કરો અથવા પાસવર્ડ દ્વારા લ loginગિન કરો!",
                BiometricAuthentication: "બાયોમેટ્રિક પ્રમાણીકરણ માટે કૃપા કરીને વપરાશકર્તા નામ દાખલ કરો.",
                InvalidCoordinates: "અમાન્ય કોઓર્ડિનેટ્સ",
                SigningInPleaseWait: "સાઇન ઇન કરી રહ્યું છે, કૃપા કરીને રાહ જુઓ",
                PleaseWaitSearch: "કૃપા કરીને રાહ જુઓ જ્યારે અમે તમારી સક્રિય સોંપણીઓ શોધીશું.",
                SignIn: "સાઇન ઇન",
                UseBackup: "બેકઅપ વાપરો",
                FingerprintAuthentication: "ફિંગરપ્રિન્ટ પ્રમાણીકરણ",
                PleaseEnrollYourProfile: "કૃપા કરીને તમારી પ્રોફાઇલની નોંધણી કરો",
                DoYouHave: "તારી જોડે છે",
                Concerns: "ચિંતા",
                HRNotifications: "એચઆર સૂચનાઓ",
                NoNotifications: "કોઈ સૂચનાઓ નથી.",
                Hi: "એચ.આઈ.",
                Expected: "અપેક્ષિત",
                SelectLanguage: "કોઈ ભાષા પસંદ કરો ...",
                ChangePassword: "પાસવર્ડ બદલો",
                LoginErr: "લ Loginગિન અમાન્ય. મેહરબાની કરી ને ફરી થી પ્રયાસ કરો.",
                About: "વિશે",
                Account: "ખાતું",
                UploadDocumentOrPicture: "દસ્તાવેજ અથવા ચિત્ર અપલોડ કરો",
                Name: "નામ",
                PickUpCases: "કેસ ચૂંટો",
                CaseOrderName: "કેસ#:",
                TimeBetweenCases: "કેસો વચ્ચેનો સમય:",
                TravelTime: "પ્રવાસ નો સમય",
                Status: "સ્થિતિ",
                Language: "ભાષા",
                AssignToMe: "મને સોંપો",
                AcceptCase: "કેસ સ્વીકારો",
                DeclineCase: "કેસ નકારો",
                SeeDetails: "વિગતો જુઓ",
                ConsumerNoShow: "ગ્રાહક નો શો",
                ReturnCase: "રીટર્ન કેસ",
                LateCancellation: "અંતમાં રદ",
                YouArePreferred: "તમે પસંદ કરો છો",
                NoCasesToShow: "બતાવવા માટે કોઈ કેસ નથી.",
                NoAssignedPatients: "તમારી પાસે અસાઇન ક્લાયંટ નથી!",
                ReportTasks: "રિપોર્ટ ટાસ્ક",
                MyRegularSchedule: "મારું નિયમિત સમયપત્રક",
                BookingsPerWeek: "દર અઠવાડિયે બુકિંગ",
                Slot: "સ્લોટ",
                AddASlot: "એક સ્લોટ ઉમેરો",
                AddTimeoffConflict: "સમય બંધ/વિરોધ ઉમેરો",
                OverrideSchedule: "સમયપત્રકને ઓવરરાઇડ કરો",
                Type: "પ્રકાર",
                OverwriteEmployeeCalendar: "કર્મચારી કેલેન્ડરને ફરીથી લખો",
                BlockedUsers: "અવરોધિત વપરાશકર્તાઓ",
                Chat: "ગપસપ",
                LoadMoreUsers: "વધુ વપરાશકર્તાઓ લોડ કરો",
                PasswordMustBe: "પાસવર્ડ હોવો જ જોઇએ",
                PasswordMustBeAtLeast: "પાસવર્ડ ઓછામાં ઓછો હોવો જોઈએ",
                PasswordMustBeAtMost: "પાસવર્ડ વધુમાં વધુ હોવો જોઈએ",
                PasswordMustContainAtLeast: "પાસવર્ડમાં ઓછામાં ઓછો હોવો આવશ્યક છે",
                NumericCharacters: "આંકડાકીય અક્ષરો",
                SpecialCharacters: "ખાસ પાત્રો",
                CharactersLong: "અક્ષરો લાંબા",
                PasswordRequirement: "પાસવર્ડમાં 3 માંથી 4 પ્રકારો સહેલા, ઉપલા, વિશેષ, આંકડાકીય અક્ષરો હોવા આવશ્યક છે.",
                CurrentPassword: "અત્યારનો પાસવર્ડ",
                NewPassword: "નવો પાસવર્ડ",
                ReenterPassword: "નવો પાસવર્ડ ફરીથી દાખલ કરો",
                TypeMsg: "તમારો સંદેશ અહીં લખો ...",
                To: "પ્રતિ",
                SentFileToYou: "તમને ફાઇલ મોકલી છે, તમે તેને ડાઉનલોડ કરી શકો છો",
                Here: "અહીં.",
                Hello: "નમસ્તે ",
                ClientView: "ક્લાયંટ વ્યુ",
                ReportArrival: "ઘડિયાળ માં",
                ReportDeparture: "ક્લોક આઉટ",
                Logout: "લૉગ આઉટ",
                Completion: "આજે પૂર્ણ",
                NoMatchedClients: "કોઈ મેળ ખાતા ગ્રાહકો! મહેરબાની કરીને સંપર્ક કરો",
                ConfirmDeparture: "પ્રસ્થાન પ્રસ્થાન",
                ArrivalDate: "આવવાની તારીખ",
                ArrivalTime: "આગમન સમય",
                DepartureDate: "જવા ની તારીખ",
                DepartureTime: "પ્રસ્થાન સમય",
                VisitDocuments: "દસ્તાવેજોની મુલાકાત લો",
                Complete: "પૂર્ણ",
                Incomplete: "અધૂરું",
                NotStarted: "શરૂ કરી નથી",
                ProcessDocuments: "પ્રક્રિયા દસ્તાવેજો",
                OnlyOnline: "ફક્ત doneનલાઇન કરી શકાય છે",
                ConnectionOflline: "ઇન્ટરનેટ કનેક્શન isફલાઇન છે",
                SaveIncomplete: "અપૂર્ણ સાચવો",
                ResetToNew: "ફરીથી સેટ કરો",
                PickerDisplay: "તારીખ / નંબરો સમય ચૂંટનારા",
                ReportNoShow: "રિપોર્ટ નો શો",
                ReportCancelVisit: "મુલાકાત રદ કરવાની જાણ કરો",
                NotificationCenter: "સૂચક કેન્દ્ર",
                Visits: "મુલાકાત",
                Time: "સમય",
                Client: "ગ્રાહક",
                Location: "સ્થાન",
                AcceptVisit: "મુલાકાત સ્વીકારો",
                DeclineVisit: "મુલાકાત નકારો",
                Messages: "સંદેશાઓ",
                Title2: "શીર્ષક",
                Delete: "કા .ી નાખો",
                ViewDocsPatients: "નીચેના દર્દીઓ માટે દસ્તાવેજો જુઓ:",
                ViewDocuments: "દસ્તાવેજો જુઓ",
                Documents: "દસ્તાવેજો",
                PayrollHistory: "પેરોલ ઇતિહાસ",
                WeeklyHours: "સાપ્તાહિક કલાકો",
                NoPayrollsToShow: "બતાવવા માટે કોઈ પેરોલ નથી.",
                PayrollSummary: "પેરોલ સારાંશ",
                WeeklySummary: "સાપ્તાહિક કલાકોનો સારાંશ",
                GrossEarnings: "ગ્રોસ કમાણી",
                GrossEarnings2: "કુલ આવક",
                TotalHourBreakdown: "કુલ કલાક બ્રેકડાઉન",
                Regular: "નિયમિત",
                Overtime: "ઓવરટાઇમ",
                TotalHoursWorked: "કુલ કલાક કામ કર્યું",
                VisitTime: "મુલાકાતનો સમય",
                Adjustments: "ગોઠવણો",
                AdjustmentsReflect: "ગોઠવણો અગાઉના ચુકવણીઓમાં ફેરફારને પ્રતિબિંબિત કરે છે.",
                ExpectedPayment: "કર પહેલાં અપેક્ષિત ચુકવણી",
                HoursWorked: "કલાક કામ કર્યું",
                NumberofDays: "દિવસોની સંખ્યા",
                NumberOfVisits: "મુલાકાતની સંખ્યા",
                VisitHistory: "ઇતિહાસ ની મુલાકાત લો",
                Trips: "સફરો",
                TripOptionQuestion: "શું તમે આ મુલાકાત પર બિન-તબીબી પરિવહન પૂર્ણ કર્યું છે?",
                RefreshGPS: "રીફ્રેશજી.પી.એસ.",
                ClockIn: "સમય નથી ઘડિયાળ",
                ClockOut: "સમય બહાર નહીં",
                CurrentArrival: "ઘડિયાળમાં સમય",
                AcceptTime: "ઘડિયાળ માં",
                ReportItems: "રિપોર્ટ આઈટમ્સ",
                AddBreak: "વિરામ ઉમેરો",
                NA: "એન / એ",
                Set: "સેટ કરો",
                NotSet: "નોટસેટ",
                AddAnotherItem: "બીજી આઇટમ ઉમેરો",
                NothingToAdd: "ઉમેરવા માટે કંઈ નથી",
                AddItem: "આઇટમ ઉમેરો",
                NoItemsToDisplay: "પ્રદર્શિત કરવા માટે કોઈ આઇટમ્સ નથી.",
                Next: "આગળ",
                SelectVisitType: "મુલાકાત પ્રકાર પસંદ કરો",
                Settings: "સેટિંગ્સ",
                Availability: "ઉપલબ્ધતા",
                General: "સામાન્ય",
                Security: "સુરક્ષા",
                NameUploadPicturesDocs: "નામ, તસવીરો/દસ્તાવેજો અપલોડ કરો",
                ConsenttoReceiveTexts: "ટેક્સ્ટ્સ પ્રાપ્ત કરવા માટે સંમતિ",
                ChangePasswordFingerprintFaceID: "પાસવર્ડ બદલો, અંગુઠા છાપ/ફેસ આઈડી",
                AddSlots: "સ્લોટ્સ ઉમેરો",
                ToSetAdditionalSettings: "વધારાની સેટિંગ્સ સેટ કરવા માટે, કૃપા કરીને અહીં સમાન ઓળખપત્રોનો ઉપયોગ કરીને લ logગ ઇન કરો",
                Authentication: "પ્રમાણિતતા",
                EnterSMSCode: "તમે એસએમએસ દ્વારા પ્રાપ્ત કરેલ કોડ દાખલ કરો:",
                Back: "પાછળ",
                Code: "કોડ",
                MyVisits: "મારી મુલાકાત",
                Address: "સરનામું",
                CreatedByPhone: "ફોન દ્વારા બનાવેલ",
                ViewMoreDetails: "વધુ વિગતો જુઓ",
                NoShow: "શો નહીં",
                Tasks: "કાર્યો",
                CancelVisit: "મુલાકાત રદ કરો",
                UploadDocs: "ડ Uploadક્સ અપલોડ કરો",
                DocumentsAreLoading: "દસ્તાવેજો લોડ થઈ રહ્યાં છે...",
                NoDocuments: "કોઈ દસ્તાવેજો નથી",
                Rework: "બદલો",
                OnHold: "હોલ્ડ વિઝિટ પર પૂર્ણ કરો",
                PleaseSelectReason: "કૃપા કરી કોઈ કારણ પસંદ કરો!",
                PleaseSelectDocument: "કૃપા કરીને એક દસ્તાવેજ પસંદ કરો!",
                NoVisitsToShow: "બતાવવા માટે કોઈ મુલાકાત નથી",
                UploadTimesheets: "ટાઇમશીટ્સ અપલોડ કરો",
                UploadDocuments: "દસ્તાવેજો અપલોડ કરો",
                EnterAdditionalNotes: "અહીં વધારાની નોંધો દાખલ કરો ...",
                VisitDirections: "ડાયરેક્શનની મુલાકાત લો",
                DriveTime: "ડ્રાઇવ સમય",
                PrecedingVisitEndTime: "પૂર્વ મુલાકાતની સમાપ્તિ સમય",
                TimeBetweenVisits: "મુલાકાત વચ્ચેનો સમય",
                VisitAddress: "સરનામું ની મુલાકાત લો",
                LiveDirections: "જીવંત દિશા નિર્દેશો",
                VisitDetails: "વિગતોની મુલાકાત લો",
                ClientName: "ગ્રાહકનું નામ",
                ServiceName: "સેવા નામ",
                VisitDate: "મુલાકાત તારીખ",
                VisitStatus: "સ્થિતિની મુલાકાત લો",
                PrimaryPhone: "પ્રાથમિક ફોન",
                SecondaryPhone: "ગૌણ ફોન",
                GetDirections: "દિશા - નિર્દેશો મેળવો",
                VisitNotes: "નોંધો ની મુલાકાત લો",
                Instructions: "સૂચનાઓ",
                PleaseUseTheButton: "કૃપા કરીને તમારી શીટનું ચિત્ર લેવા માટે નીચેના બટનનો ઉપયોગ કરો. જો ચિત્ર અસ્પષ્ટ લાગતું હોય તો ફરી પ્રયાસ કરો બટનનો ઉપયોગ કરો.",
                Keep: "રાખવું",
                TakePicture: "ચિત્ર લો",
                UploadOrTakePicture: "અપલોડ કરો અથવા ચિત્ર લો",
                RetakePicture: "ચિત્ર ફરીથી લો",
                AddPhoto2: "ફોટો ઉમેરો",
                VisitHistoryCaps: "ઇતિહાસની મુલાકાત લો",
                Completed: "પૂર્ણ",
                WorkerName: "કામદારનું નામ",
                Notes: "નોંધો",
                ResponseNotes: "પ્રતિભાવ નોંધો",
                AddNotes: "નોંધો ઉમેરો",
                MoveVisitToday: "આજે મુલાકાત ખસેડો",
                ShowMore: "... વધારે બતાવ",
                VisitType: "મુલાકાત પ્રકાર",
                PleaseAsk: "મહેરબાની કરી ને પૂછો ",
                ToConfirmThatTheyReceived: "ખાતરી કરવા માટે કે તેઓ તેમના પ્રાપ્ત થયા છે",
                ServiceToday: "આજે સેવા",
                Yes: "હા",
                No: "ના",
                ToConfirmThatTheVisit: "પુષ્ટિ કરવા માટે કે મુલાકાતનો સમય હતો",
                ReportDeparture2: "ક્લોક આઉટ",
                ToSignHere: "અહીં સહી કરવા માટે",
                VoiceSignature: "અવાજ સહી",
                PleaseSignHere: "કૃપા કરીને અહીં સહી કરો",
                PleaseAskYour: "કૃપા કરીને તમારા પૂછો",
                ErrandMiles: "એરંડ માઇલ્સ",
                AddPhoto: "ફોટો ઉમેરો",
                Clear: "ચોખ્ખુ",
                Accept: "સ્વીકારો",
                NotAvailable: "ઉપલબ્ધ નથી",
                VisitConfirmation: "પુષ્ટિ મુલાકાત",
                RequestForConfirmation: "કૃપા કરીને તમે આજે તમારી સેવાઓ પ્રાપ્ત કરી છે તેની પુષ્ટિ કરવા માટે પ્રારંભ રેકોર્ડિંગને દબાવ્યા પછી તમારું નામ અને આજની તારીખ કહો.",
                PlayRecording: "રેકોર્ડિંગ રમો",
                StopPlayRecording: "પ્લે રેકોર્ડિંગ રોકો",
                StartRecording: "રેકોર્ડિંગ પ્રારંભ કરો",
                StopRecording: "રેકોર્ડિંગ બંધ કરો",
                MonthView: "મહિનો દૃશ્ય",
                WeekView: "અઠવાડિયું દૃશ્ય",
                ArrSuccess: "તમારું આગમન અહીં સફળતાપૂર્વક નોંધાયું હતું",
                ArrOffline: "તમારું આગમન રેકોર્ડ કરવામાં આવ્યું છે પરંતુ તમે offlineફલાઇન છો. તમારી officeફિસમાં મોડી ચેતવણી મળી શકે છે.",
                ArrSuccessDeparture: "તમારો અપેક્ષિત પ્રસ્થાનનો સમય છે",
                CurrentVisit: "વર્તમાન મુલાકાત સમયગાળો",
                Hours: "કલાક",
                Minutes: "મિનિટ",
                ClockOutButton: "ઘડિયાળ બહાર",
                ConfirmLocation: "અમે હજી પણ તમારા સ્થાનની પુષ્ટિ કરવાનો પ્રયાસ કરી રહ્યા છીએ. અમે 3 મિનિટ સુધી પ્રયત્ન કરીશું.",
                ViewTasks: "કાર્યો જુઓ",
                CurrentDeparture: "વર્તમાન પ્રસ્થાન સમય",
                Duration: "અવધિ",
                Duration2: "અવધિ",
                ConfirmClockOut: "શું તમે ખરેખર બહાર નીકળવું માંગો છો?",
                Only3OnHoldVisitsWillShowAtaTime: "એક સમયમાં ફક્ત 3 વખત પર વિરામ પર વીજિટ્સ બતાવવામાં આવશે.",
                Submit: "સબમિટ કરો",
                DepSuccess: "તમારું પ્રસ્થાન સફળતાપૂર્વક નોંધાયું હતું",
                VisitSuccesfullyClosed: "મુલાકાત સફળતાપૂર્વક બંધ કરવામાં આવી હતી",
                DepOffline: "તમારું પ્રસ્થાન રેકોર્ડ કરવામાં આવ્યું છે પરંતુ તમે offlineફલાઇન છો. તમારી officeફિસમાં મોડી ચેતવણી મળી શકે છે.",
                PleaseOpenYourAnkotaApplater: " કૃપા કરીને આજે રાત્રે મોડી રાત્રે જ્યારે તમારો સિગ્નલ સારો હોય (જ્યારે તમે ઓનલાઈન હોવ) ત્યારે તમારી અંકોટા એપ ખોલો જેથી તમારો મુલાકાત ડેટા ઓફિસમાં મોકલી શકાય.",
                Home: "ઘર",
                Save: "સંગ્રહો",
                AssignedPatients: "અસાઇન કરેલ ગ્રાહકો",
                AvailableShifts: "ઉપલબ્ધ શિફ્ટ્સ",
                ReportMissedVisit: "અહેવાલ ચૂકી મુલાકાત",
                ReportVisit: "રિપોર્ટ વિઝિટ",
                AddMissedVisitReason: "કારણ પસંદ કરો ",
                CorrectDatesTime: "ઉપરોક્ત તારીખો/સમય તેના પર ક્લિક કરીને અને સાચા વિકલ્પ પર સ્ક્રોલ કરીને સુધારો.",
                ContigousVisitBlock: "આ મુલાકાત મુલાકાતોના બ્લોકનો એક ભાગ હતી. કૃપા કરીને આ બ્લોક માટે તમારો વાસ્તવિક પ્રારંભ સમય અને તમારો અંતિમ ઘડિયાળનો સમય દાખલ કરો.",
                AddWorkerDocument: "દસ્તાવેજ પસંદ કરો ",
                ReportExpensesTitle: "રિપોર્ટ ખર્ચ",
                ReportExpensesQuestion: "શું તમારી પાસે જાણ કરવા માટે ખર્ચ છે?",
                Amount: "રકમ",
                Description: "વર્ણન",
                Company: "કંપની",
                NotesAndInfo: "નોંધો અને માહિતી",
                InfoOnlyItems: "માહિતી માત્ર આઇટમ્સ",
                NoNotesForVisit: "આ મુલાકાત માટે કોઈ નોંધ નથી!",
                NoInfoForVisit: "આ મુલાકાત પર કોઈ માહિતી આઇટમ્સ નથી!",
                ContiguousVisits: "સતત મુલાકાતો",
                Details: "વિગતો",
                Signature: "સહી",
                GoToSign: "પેડ બતાવો",
                History: "ઇતિહાસ",
                NoNotesInHistory: "ઇતિહાસમાં કોઈ નોંધ નથી!",
                CarePlanHistoryNotAvailableOffline: "કેર પ્લાન આઇટમ ઇતિહાસ ઓફલાઇન મોડમાં ઉપલબ્ધ નથી!",
                TheVisitIsAlreadySigned: "મુલાકાત પહેલાથી જ સહી થયેલ છે. તમે સહી વગર ચાલુ રાખી શકો છો.",
                OfflineUptimeWarning: "તમારા છેલ્લા ઓનલાઈન લોગિનથી તમારું ઉપકરણ પુનઃપ્રારંભ થઈ શકે છે. જો શક્ય હોય તો તમારો સમય અપડેટ કરવા માટે કૃપા કરીને ઑનલાઇન લૉગિન કરો.",
                Phone: "ફોન",
                Email: "ઈમેલ",
                OfflineModeWarning: "તમારી એપ્લિકેશનને ખરાબ કનેક્શનને કારણે મુશ્કેલી આવી રહી છે અને તે તમારો ડેટા ઑફલાઇન કૅપ્ચર કરશે. તમારું નેટવર્ક કનેક્શન સુધરતાની સાથે જ ઓફિસ અપડેટ કરવામાં આવશે.",
                OnlineModeWarning: "તમારી એપ્લિકેશન સર્વર સાથે ફરીથી કનેક્ટ થવામાં વ્યવસ્થાપિત છે. તમારો વિઝિટ ડેટા હવે સિંક્રનાઇઝ થશે અને ઓનલાઈન પ્રોસેસ થશે.",
                Refresh: "તાજું કરો",
                ResetMapsApp: "નકશા એપ્લિકેશન રીસેટ કરો",
                DefaultMapsAppWarning: "ડિફૉલ્ટ નકશા એપ્લિકેશન રીસેટ કરવામાં આવી છે. આગલી વખતે જ્યારે તમે નેવિગેટર લોંચ કરશો ત્યારે તમે નવી એપ્લિકેશન પસંદ કરી શકશો.",
                UseBingInstead: "Bing Maps નો ઉપયોગ કરો",
                NoLocationWarning: "તમારું સ્થાન કેપ્ચર કરી શકાયું નથી. ખાતરી કરો કે તમારું GPS ચાલુ છે, અન્યથા તમારી પસંદ કરેલ નકશા એપ્લિકેશન તમારી સ્થિતિ શોધી શકશે નહીં. શું તમે કોઈપણ રીતે આગળ વધવા માંગો છો? તમારે તમારી વર્તમાન સ્થિતિ મેન્યુઅલી ઇનપુટ કરવી પડશે!",
                NoMapsWarning: "તમારા ઉપકરણ પર કોઈ નકશા એપ્લિકેશન મળી નથી. તેના બદલે Bing નકશા ખોલવામાં આવશે.",
                HoursLimitWarning: "</br><b><p style='color:Red'>મુલાકાતનો સમયગાળો > 16 કલાક. શું તમને ખાતરી છે?</p></b>",
                SlotChangeWarning: "તમે આ સમયના સ્લોટ દરમિયાન મુલાકાતો સુનિશ્ચિત કરી છે. કૃપા કરીને તમારી ઉપલબ્ધતામાં ફેરફારની વિનંતી કરવા માટે ઓફિસનો સંપર્ક કરો.",
                WorkerPhone: "કાર્યકર ફોન",
                PleaseTurnOnGPS: "તમારું GPS બંધ છે. કૃપા કરીને ક્લોક ઇન કરતા પહેલા એપ્લિકેશનને તમારું સ્થાન મેળવવાની મંજૂરી આપો.",
                NoGPSOnVisit: "જીપીએસ સ્થાન સમયસર શોધી શકાયું નથી. શું તમે કોઓર્ડિનેટ્સ વિના ચાલુ રાખવા માંગો છો?",
                NoGPSPermission: "તમે આ એપ્લિકેશનનો ઉપયોગ કરી શકતા નથી કારણ કે તમે એપ્લિકેશન માટે સ્થાન શેરિંગ સક્ષમ કર્યું નથી. તમે કાં તો તમારી એપ્લિકેશન સેટિંગ્સ અપડેટ કરી શકો છો અથવા એપ્લિકેશનને કાઢી નાખીને ફરીથી ઇન્સ્ટોલ કરી શકો છો. જો તમે પુનઃસ્થાપિત કરો છો, જ્યારે તમે લોગ ઇન કરશો ત્યારે તે પૂછશે કે શું એપ્લિકેશન તમારા સ્થાનનો ઉપયોગ કરી શકે છે. તમારે આગળ વધવા માટે હા કહેવી પડશે.",
                SyncVisitWarning: "મુલાકાત સર્વર સાથે સમન્વયિત કરી શકાઈ નથી. પછીથી ફરી પ્રયત્ન કરો!",
                CarePlanItemHistoryDisplayMode: "કેર પ્લાન હિસ્ટ્રી ડિસ્પ્લે મોડ",
                Individually: "વ્યક્તિગત રીતે",
                AllAtOnce: "બધા એક જ સમયે",
                GpsTimeLeft: "એપ્લિકેશન GPS કોઓર્ડિનેટ્સ મેળવવાનો પ્રયાસ કરી રહી છે. નિષ્ફળતાના કિસ્સામાં, ક્લોકિંગ ઇન/આઉટ મહત્તમમાં ઉપલબ્ધ કરાવવામાં આવશે ",
                Seconds: "સેકન્ડ",
                BlockUser: "વપરાશકર્તાને અવરોધિત",
                ServicePeriod: "સેવાનો સમયગાળો",
                ServicePeriodStartDate: "સેવાનો સમયગાળો શરૂ થવાની તારીખ",
                UseBy: "દ્વારા ઉપયોગ કરો",
                TotalTime: "કુલ સમય",
                UsedTime: "વપરાયેલ સમય",
                RemainingTime: "બાકી સમય",
                AuthInfo: "Auth Info",
                YouMayWorkUpTo: "<br/><br/>સુધી કામ કરી શકે છે",
                NoAuthorizedUnitsLeftWarning: "તમે આ દર્દી અને મુલાકાતના પ્રકાર માટે નવી મુલાકાત શરૂ કરી શકતા નથી કારણ કે મુલાકાતમાં 0 અધિકૃત મિનિટ બાકી છે!",
            },
            "hi": { //Hindi
                Nothing: "",
                Username: "ईमेल या उपयोगकर्ता का नाम",
                Password: "पासवर्ड",
                NewAppVersionAvailable: "नया एप्लिकेशन संस्करण उपलब्ध है कृपया अपडेट करें!",
                UserError: "एक मान्य उपयोगकर्ता नाम दर्ज करें।",
                PwError: "आपके पासवर्ड 6 से अधिक वर्णों का होना ज़रूरी है।",
                Login: "लॉग इन करें",
                FaceID: "फेस आईडी ",
                Fingerprint: "फिंगरप्रिंट",
                PwForgot: "पासवर्ड भूल गए",
                Version: "संस्करण",
                TitleApp: "मानोस होम केयर",
                Subtitle: "देखभालकरता पोर्टल",
                Monday: "सोमवार",
                Tuesday: "मंगलवार",
                Wednesday: "बुधवार",
                Thursday: "गुरूवार",
                Friday: "शुक्रवार",
                Saturday: "शनिवार",
                Sunday: "रविवार",
                ViewMap: "मानचित्र",
                NoteTooLong: "नोट बहुत लंबा है। कृपया अधिकतम 512 वर्ण में सिमित रखें!",
                NoteTooLong4000characters: "नोट बहुत लंबा है। कृपया अधिकतम 4000 वर्ण में सिमित रखें!",
                OfflinePassForgot: "आप ऑफलाइन हैं। कृपया अपना पासवर्ड रीसेट करने के लिए किसी नेटवर्क से कनेक्ट करें।",
                ConfirmPassReset: "क्या आप वाकई अपना पासवर्ड रीसेट करना चाहते हैं?",
                ConfirmShiftResponse: "क्या आप वाकई इस खुली पारी के लिए जवाब देना चाहते हैं?",
                PatientName: "</br></br>रोगी का नाम: ",
                EmptyUsername: "कृपया सुनिश्चित करें कि आपके पास उपयोगकर्ता नाम/ईमेल पूर्ण है!",
                EmptyError: "आपके पास फ़ाइल पर फ़ोन नंबर या ईमेल नहीं है। अपने पासवर्ड को रीसेट करवाने के लिए कृपया अपने कार्यालय से संपर्क करें।",
                PassResetSuccess: "आपके ईमेल पर एक पासवर्ड रीसेट ईमेल भेजा गया है",
                PhoneError: "आपके फ़ोन नंबर पर एक पासवर्ड रीसेट टेक्स्ट भेजा गया है।",
                NewMessages: "आपके पास एक नया संदेश आया होगा।",
                ReadNow: "अभी पढ़ें",
                ReadLater: "बाद में पढ़ें",
                Ok: "ठीक है",
                Close: "बंद करे",
                DeleteWorking: "क्या आप वाकई में काम के घंटे को हटाना चाहते हैं?",
                DeleteAdjustment: "क्या आप वाकई में समायोजन <b> हटाना चाहते हैं?",
                InitiatingCall: "कॉल शुरू किया जा रहा है...",
                CallFailed: "कॉल विफल रहा है",
                CallCanceled: "कॉल रद्द हुआ है",
                OngoingCall: "कॉल जारी है ...",
                CallEnded: "कॉल समाप्त",
                IncomingCall: "इनकमिंग कॉल",
                ConnectingToCall: "कनेक्ट हो रहा है ...",
                Rejected: "अस्वीकृत ...",
                RejectionFailed: "अस्वीकृति विफल रही है...",
                ChangePasswordOfflineWarning: "इंटरनेट कनेक्शन उपलब्ध होने पर ही पासवर्ड बदला जा सकता है!",
                PassBlank: "पुन: दर्ज पासवर्ड रिक्त है या मेल नहीं खा रहा है!",
                PleaseConnect: "कृपया लॉग इन करने के लिए इंटरनेट से कनेक्ट करें!",
                InvalidPassword: "वर्तमान पासवर्ड अमान्य है। कृपया पुन: प्रयास करें!",
                AcceptedChars: "स्वीकृत वर्ण अक्षर, संख्याएँ और निम्नलिखित प्रतीक हैं '.', '!'।",
                NewInvalidPass: "नया पासवर्ड अमान्य है। कृपया उपरोक्त आवश्यकताओं की जांच करें।",
                InvalidCurrentPassword: "अमान्य वर्तमान पासवर्ड!",
                PasswordMustBeDifferent: "नया पासवर्ड आपके पिछले 3 पासवर्ड से अलग होना चाहिए। कृपया एक अलग नया पासवर्ड आज़माएं।",
                PasswordsDoNotMatch: "पासवर्ड मेल नहीं खा रहे हैं!",
                PassBlockedWord1: "नए पासवर्ड में प्रतिबंधित शब्द है",
                PassBlockedWord2: "पासवर्ड में प्रतिबंधित शब्द नहीं होने चाहिए।",
                PasswordResetSuccess: "आपने सफलतापूर्वक अपना पासवर्ड बदल दिया है। कृपया लॉगिन करें।",
                AgreeToReceiveInformationalMessages: "मैं अपने फ़ोन नंबर पर सूचनात्मक संदेश/सूचनाएँ प्राप्त करने के लिए सहमत हूँ ",
                PasswordResetNotSuccessful: "पासवर्ड नहीं बदला जा सका. कृपया पुन: प्रयास करें।",
                Enable: "चालू करें",
                Disable: "बंद करें",
                UnableToSaveCode: "कोड सेव करने में असमर्थ। कृपया सहायता टीम से संपर्क करें!",
                InvalidCode: "अमान्य कोड",
                ConfirmingLocation: "ठिकाने की पुष्टि हो रही है - कृपया प्रतीक्षा करें!",
                GPSNotCaptured: "आपके GPS कोऑर्डिनेट्स प्राप्त नहीं हुए हैं। कृपया GPS रीफ़्रेश करके पुनः प्रयास करें!",
                GPSNotCaptured2: "आपके GPS कोऑर्डिनेट्स प्राप्त नहीं हुए हैं। अपनी यात्रा शुरू करने के लिए आप 'एक्सेप्ट टाइम' दबा सकते हैं, लेकिन कृपया ऐप को 3 मिनट तक खुला छोड़ दें ताकि हम आपकी लोकेशन प्राप्त करने के लिए प्रयासरत रहें।",
                GPSNotCaptured3: "आपके GPS कोऑर्डिनेट्स प्राप्त नहीं हुए हैं। कृपया पुन: प्रयास करें!",
                TooEarlyToReport: "आप घड़ी में आने के लिए बहुत जल्दी हैं। कृपया अपने निर्धारित समय पर घड़ी करें।",
                TooLateToReport: "आपको घड़ी लगाने में बहुत देर हो चुकी है।",
                LocationNotCloseEnough: "आपका स्थान ग्राहक के घर के काफी करीब नहीं है। कृपया ग्राहक के घर से घड़ी में आएं और रीफ़्रेश GPS का उपयोग करके पुन: प्रयास करें!",
                YourArrivalTimeIs: "आपका घड़ी का समय है",
                SomeoneElseIsAlreadyClocked: "किसी और को पहले ही क्लॉक इन कर लिया गया है। कृपया उन्हें क्लॉक आउट करने के लिए कहें ताकि आप क्लॉक इन कर सकें.",
                YourDepartureTimeIs: "</br></br>आपके जाने का समय है ",
                YourVisitDurationIs: "</br></br>विज़िट की अवधि है ",
                YourExpectedDeparture: "आपका अपेक्षित प्रस्थान समय है",
                ClientDocumentsReady: " अपने आगमन की पुष्टि करके, आप यह स्वीकार कर रहे हैं कि आपने क्लाइंट दस्तावेज़ पढ़ लिए हैं।",
                OpenShiftDate: "</br></br> ओपन शिफ्ट दिनांक: ",
                OpenShiftTime: "</br></br>ओपन शिफ्ट टाइम: ",
                WeStillTryingConfirmLocation: "हम अभी भी आपकी लोकेशन की पुष्टि करने के लिए प्रयासरत हैं। हम 3 मिनट तक कोशिश करते रहेंगे। ",
                YourExpectedDepartureTimeNotUntil: "आपका अपेक्षित प्रस्थान समय है",
                CompleteFullySchedule: "यदि आप अपना पूर्ण रूप से निर्धारित समय पूर्ण करना चाहते हैं, तो कृपया लॉग आउट करें",
                PleaseSetStatus: "कृपया सभी आइटमों के लिए एक स्टेटस निर्धारित करें!",
                CarePlanItemAlreadyExisit: "जिस देखभाल योजना आइटम को आप जोड़ना चाहते हैं वह पहले से ही सूची में जोड़ा गया है",
                DurationGreaterThan0: "विज़िट की अवधि 0 मिनट से अधिक होनी चाहिए!",
                MessageConfirmLogOut: "क्या आप लॉग आउट करना चाहते हैं?",
                Confirm: "पुष्टि करें",
                Cancel: "रद्द करें",
                PageAvailableOnlyOnline: "यह पृष्ठ केवल ऑनलाइन रहते हुए उपलब्ध है।",
                SomethingWentWrong: "कुछ त्रुटियां हुईं हैं। कृपया पुन: प्रयास करें!",
                EnrolledSuccessfully: "सफलतापूर्वक दाखिला हुआ है!",
                SuccessfullPictureUpload: "सफलतापूर्वक तस्वीर अपलोड हुई है।",
                VisitMoved: "विज़िट आज निर्धारित है!",
                PatientConcernTooLong: "रोगी की समस्याएँ लंबी है। कृपया अधिकतम 512 वर्ण बरकरार रख उल्लेख करें!",
                VisitHistoryOffline: "विज़िट हिस्ट्री केवल इंटरनेट कनेक्शन होने पर ही उपलब्ध है।",
                OnlyNetAccess: "इंटरनेट पहुँच होने पर ही उपलब्ध है!",
                ErrorSavingSignature: "हस्ताक्षर सेव करने में त्रुटि। कृपया पुनः प्रयास करें या Ankota से संपर्क करें।",
                ErrorSavingWorkerSignature: "कार्यकर्ता के हस्ताक्षर सहेजने में त्रुटि कृपया पुनः प्रयास करें या अंकोता से संपर्क करें।",
                ErrorSavingPatientSignature: "मरीज़ के हस्ताक्षर को सेव करने में त्रुटि। कृपया पुनः प्रयास करें या Ankota से संपर्क करें।",
                CouldNotCreateFile: "फ़ाइल बनाने में विफलता",
                NoRecording: "रिकॉर्डिंग उपलब्ध नहीं!",
                UploadedFile: "सफलतापूर्वक फ़ाइल अपलोड की गई है।",
                MarkWhileOffline: "यदि आप ऑफ़लाइन हैं तो आप किसी संदेश को रेड (रीड) चिन्हित नहीं कर सकते हैं!",
                Offline: "आप ऑफलाइन हैं",
                Syncing: "सिंक हो रहा है ... कृपया प्रतीक्षा करें",
                LoadingMessage: "लोड हो रहा है ...  कृपया प्रतीक्षा करें",
                Title: "शीर्षक",
                Message: "संदेश",
                Date: "तारीख",
                DateAndTime: "दिनांक समय",
                MarkAsRead: "पढ़े हुए चिन्हित करना (मार्क एज़ रेड)",
                Call: "कॉल",
                Immediately: "तुरंत",
                HourShort: "एच",
                MinShort: "एम",
                Actions: "कार्रवाई",
                UnblockUser: "उपयोगकर्ता को अनब्लॉक करें,",
                Image: "तस्वीर",
                Document: "कागज़ात",
                LoadingDocsWait: "दस्तावेज़ लोड हो रहा है, कृपया प्रतीक्षा करें",
                ProcessDocsWait: "दस्तावेज प्रक्रिया में है, कृपया प्रतीक्षा करें",
                PleaseConnectToLogIn: "लॉग इन करने के लिए कृपया इंटरनेट से कनेक्ट करें!",
                AvailableShifsNoInternet: "उपलब्ध शिफ्ट केवल इंटरनेट कनेक्शन होने पर ही उपलब्ध है!",
                ShiftNotAvailable: "शिफ्ट अब उपलब्ध नहीं है।",
                ShiftAssignedToYou: "कार्यालय ने आपको इस पारी के लिए निर्धारित किया है। यदि आप ऐसा नहीं कर सकते हैं, तो कृपया कार्यालय से संपर्क करें!",
                InvalidUserOrPass: "अमान्य उपयोगकर्ता नाम या पासवर्ड। कृपया पुन: प्रयास करें।",
                UnexpectedErrorContactSupport: "अप्रत्याशित त्रुटि! कृपया सहायता से संपर्क करें!",
                FingerprintAuthError: "फिंगरप्रिंट प्रमाणीकरण संसाधित करते समय एक त्रुटि हुई है",
                EnrollAgain: "कुछ ठीक नहीं है, कृपया फिर से दर्ज करें!",
                UsernameEnrollmentError: "इस उपयोगकर्ता नाम से कोई दर्ज नहीं है, कृपया एक अलग उपयोगकर्ता नाम या पासवर्ड द्वारा लॉगिन करने का प्रयास करें!",
                BiometricAuthentication: "कृपया बायोमेट्रिक प्रमाणीकरण के लिए उपयोगकर्ता नाम दर्ज करें।",
                InvalidCoordinates: "अमान्य निर्देशांक (कोऑर्डिनटस)",
                SigningInPleaseWait: "साइन इन हो रहा है, कृपया प्रतीक्षा करें",
                PleaseWaitSearch: "जब तक हम आपके सक्रिय असाइनमेंट की खोज करते हैं, कृपया प्रतीक्षा करें।",
                SignIn: "साइन इन करें",
                UseBackup: "बैकअप का उपयोग करें",
                FingerprintAuthentication: "फिंगरप्रिंट प्रमाणीकरण",
                PleaseEnrollYourProfile: "कृपया अपना प्रोफ़ाइल दर्ज करें",
                DoYouHave: "क्या आपके पास है",
                Concerns: "चिंताओं",
                HRNotifications: "मानव संसाधन सूचनाएं",
                NoNotifications: "कोई सूचनाएं नहीं।",
                Hi: "नमस्ते",
                Expected: "अपेक्षित ",
                SelectLanguage: "एक भाषा चुनें ...",
                ChangePassword: "पासवर्ड बदलें",
                LoginErr: "अवैध लॉगिन। कृपया पुन: प्रयास करें।",
                About: "बारे में",
                Account: "खाता",
                UploadDocumentOrPicture: "दस्तावेज़ या चित्र अपलोड करें",
                Name: "नाम",
                PickUpCases: "पिक अप मामले",
                CaseOrderName: "मामला#:",
                TimeBetweenCases: "मामलों के बीच का समय:",
                TravelTime: "यात्रा का समय",
                Status: "स्टेटस",
                Language: "भाषा",
                AssignToMe: "मुझे नियुक्त",
                AcceptCase: "मामला स्वीकार करें",
                DeclineCase: "मामला अस्वीकार करें",
                SeeDetails: "विवरण देखें",
                ConsumerNoShow: "ग्राहक अनुपस्थित",
                ReturnCase: "मामला वापसी",
                LateCancellation: "देर से रद्द ",
                YouArePreferred: "आप पसंद हैं",
                NoCasesToShow: "दिखाने के लिए कोई मामला नहीं।",
                NoAssignedPatients: "आपके पास असाइन किए गए क्लाइंट नहीं हैं!",
                ReportTasks: "रिपोर्ट कार्य",
                MyRegularSchedule: "मेरी नियमित कार्य सूची",
                BookingsPerWeek: "प्रति सप्ताह बुकिंग",
                Slot: "स्लॉट (निर्धारित समय)",
                AddASlot: "एक स्लॉट जोड़ें",
                AddTimeoffConflict: "अवकाश/संघर्ष का समय जोड़ें",
                OverrideSchedule: "निर्धारित समय को उल्लंघन (ओवरराइड) करें",
                Type: "प्रकार",
                OverwriteEmployeeCalendar: "कर्मचारी कैलेंडर को ओवर राइट (अधिलेखित) करें",
                BlockedUsers: "प्रतिबंधित उपयोगकर्ता",
                Chat: "चैट",
                LoadMoreUsers: "अधिक उपयोगकर्ता लोड करें",
                PasswordMustBe: "पासवर्ड _____ होने चाहिए ",
                PasswordMustBeAtLeast: "पासवर्ड कम से कम______ होने चाहिए ",
                PasswordMustBeAtMost: "पासवर्ड सबसे अधिक _______ होने चाहिए",
                PasswordMustContainAtLeast: "पासवर्ड में कम से कम ______होने चाहिए ",
                NumericCharacters: "अंकीय वर्ण ",
                SpecialCharacters: "विशेष वर्ण",
                CharactersLong: "__ वर्ण तक लम्बे ",
                PasswordRequirement: "पासवर्ड में 4 में से 3 प्रकार के होने चाहिए, लोअर, अप्पर,विशेष (स्पेशल), संख्यात्मक वर्ण (केरेक्टर्स)।",
                CurrentPassword: "वर्तमान पासवर्ड",
                NewPassword: "नया पासवर्ड",
                ReenterPassword: "नया पासवर्ड पुनः दर्ज करें",
                TypeMsg: "अपना संदेश यहां टाइप करें...",
                To: "प्रति",
                SentFileToYou: "ने आपको एक फ़ाइल भेजी है, आप इसे डाउनलोड कर सकते हैं",
                Here: "यहां।",
                Hello: "नमस्ते ",
                ClientView: "ग्राहक व्यू",
                ReportArrival: "समय पर्",
                ReportDeparture: "काम समाप्त करना",
                Logout: "लॉग आउट करें",
                Completion: "आज पूर्ण हुआ",
                NoMatchedClients: "कोई मेल खाता हुआ ग्राहक नहीं! कृपया संपर्क करें",
                ConfirmDeparture: "प्रस्थान की पुष्टि करें ",
                ArrivalDate: "आगमन की तारीख",
                ArrivalTime: "आगमन का समय",
                DepartureDate: "प्रस्थान की तारीख",
                DepartureTime: "प्रस्थान का समय",
                VisitDocuments: "विज़िट दस्तावेज़ ",
                Complete: "पूर्ण",
                Incomplete: "अपूर्ण",
                NotStarted: "शुरू नही हुआ",
                ProcessDocuments: "दस्तावेज की प्रक्रिया",
                OnlyOnline: "केवल ऑनलाइन किया जा सकता है",
                ConnectionOflline: "इंटरनेट कनेक्शन ऑफ़लाइन है",
                SaveIncomplete: "अपूर्ण को सेव करें",
                ResetToNew: "नए में रिसेट करें",
                PickerDisplay: "तारीख/संख्या समय चुनने वाले",
                ReportNoShow: "रिपोर्ट नं दिखाएं",
                ReportCancelVisit: "यात्रा रद्द करने की रिपोर्ट करें",
                NotificationCenter: "अधिसूचना केंद्र",
                Visits: "विज़िट",
                Time: "समय",
                Client: "ग्राहक",
                Location: "ठिकाना",
                AcceptVisit: "विज़िट स्वीकार करें",
                DeclineVisit: "विज़िट रद्द करें",
                Messages: "संदेश",
                Title2: "शीर्षक",
                Delete: "डिलीट करें",
                ViewDocsPatients: "निम्नलिखित मरीज़ों के दस्तावेज़ देखें:",
                ViewDocuments: "दस्तावेज़ देखें",
                Documents: "दस्तावेज़",
                PayrollHistory: "वेतन विवरण",
                WeeklyHours: "साप्ताहिक घंटे",
                NoPayrollsToShow: "दिखाने के लिए कोई वेतन नहीं है।",
                PayrollSummary: "वेतन सारांश",
                WeeklySummary: "साप्ताहिक घंटों का सारांश",
                GrossEarnings: "कुल कमाई",
                GrossEarnings2: "कुल कमाई",
                TotalHourBreakdown: "कुल घंटे का ब्यौरा",
                Regular: "नियमित",
                Overtime: "अधिक समय तक",
                TotalHoursWorked: "कुल कार्य घंटे",
                VisitTime: "यात्रा का समय",
                Adjustments: "समायोजन",
                AdjustmentsReflect: "समायोजन पिछले भुगतानों में परिवर्तन को दर्शाते हैं।",
                ExpectedPayment: "कर से पहले अपेक्षित भुगतान",
                HoursWorked: "कामकाजी घंटे ",
                NumberofDays: "दिनों की संख्या",
                NumberOfVisits: "भेटों की संख्या",
                VisitHistory: "इतिहास पर जाएँ",
                Trips: "दौरे",
                TripOptionQuestion: "क्या आपने इस दौरे पर गैर-चिकित्सा यात्रा किए?",
                RefreshGPS: "GPS रिफ्रेश करें",
                ClockIn: "क्लॉक इन समय उपलब्ध नहीं",
                ClockOut: "क्लॉक आउट समय उपलब्ध नहीं ",
                CurrentArrival: "घड़ी का समय",
                AcceptTime: "समय पर्",
                ReportItems: "आइटम की रिपोर्ट करें",
                AddBreak: "ब्रेक जोड़ें",
                NA: "N/A (लागू नहीं)",
                Set: "निर्धारित ",
                NotSet: "निर्धारित नहीं",
                AddAnotherItem: "एक और आइटम जोड़ें",
                NothingToAdd: "जोड़ने के लिए कुछ भी नहीं है",
                AddItem: "आइटम जोडें",
                NoItemsToDisplay: "प्रदर्शित करने के लिए कोई आइटम नहीं है।",
                Next: "अगला",
                SelectVisitType: "विजिट का प्रकार चुनें",
                Settings: "सेटिंग (समायोजन)",
                Availability: "उपलब्धता",
                General: "सामान्य",
                Security: "सुरक्षा",
                NameUploadPicturesDocs: "नाम, तस्वीरें/दस्तावेज़ अपलोड करें",
                ConsenttoReceiveTexts: "पाठ प्राप्त करने की सहमति",
                ChangePasswordFingerprintFaceID: "पासवर्ड बदलें, फिंगरप्रिंट/फेस आईडी",
                AddSlots: "स्लॉट्स जोड़ें",
                ToSetAdditionalSettings: "अतिरिक्त सेटिंग्स निर्धारित करने के लिए, कृपया वही विवरणों का उपयोग करके लॉग इन करें",
                Authentication: "प्रमाणीकरण",
                EnterSMSCode: "SMS के माध्यम से आपको प्राप्त कोड दर्ज करें:",
                Back: "पीछे",
                Code: "कोड",
                MyVisits: "मेरे दौरे",
                Address: "पता",
                CreatedByPhone: "फोन द्वारा निर्मित",
                ViewMoreDetails: "अधिक विवरण देखें",
                NoShow: "अनुपस्थित हुए ",
                Tasks: "कार्य",
                CancelVisit: "दौरा रद्द करें",
                UploadDocs: "कागज़ात अपलोड करें",
                DocumentsAreLoading: "दस्तावेज़ लोड हो रहे हैं...",
                NoDocuments: "कोई दस्तावेज़ नहीं",
                Rework: "पुन: कार्य करें",
                OnHold: "होल्ड विज़िट पर पूरा करें",
                PleaseSelectReason: "कृपया कोई कारण चुनें!",
                PleaseSelectDocument: "कृपया एक दस्तावेज़ चुनें!",
                NoVisitsToShow: "दिखने के लिए कोई दौरे नहीं",
                UploadTimesheets: "टाइमशीट अपलोड करें",
                UploadDocuments: "दस्तावेज़ अपलोड करें",
                EnterAdditionalNotes: "यहां अतिरिक्त टिप्पणियां दर्ज करें ...",
                VisitDirections: "निरीक्षण देखें",
                DriveTime: "ड्राइव का समय",
                PrecedingVisitEndTime: "पिछले विज़िट समाप्ति समय ",
                TimeBetweenVisits: "दौरों के बीच का समय",
                VisitAddress: "पता पर जाएँ",
                LiveDirections: "लाइव डायरेक्शन",
                VisitDetails: "विवरण देखें",
                ClientName: "ग्राहक का नाम",
                ServiceName: "सेवा का नाम",
                VisitDate: "विज़िट की तारीख",
                VisitStatus: "विज़िट स्टेटस",
                PrimaryPhone: "मुख्य फोन",
                SecondaryPhone: "अतिरिक्त फोन",
                GetDirections: "दिशा-निर्देश प्राप्त करें",
                VisitNotes: "नोट्स पर जाएँ",
                Instructions: "निर्देश",
                PleaseUseTheButton: "कृपया अपनी शीट की तस्वीर लेने के लिए नीचे दिए गए बटन का उपयोग करें। यदि चित्र अस्पष्ट दिखाई देता है, तो रिट्राय बटन का उपयोग करें।",
                Keep: "रखें ",
                TakePicture: "तस्वीर ले लें",
                UploadOrTakePicture: "अपलोड करें या चित्र लें",
                RetakePicture: "पुन: तस्वीर लें",
                AddPhoto2: "फ़ोटो जोड़ें",
                VisitHistoryCaps: "इतिहास देखें",
                Completed: "पूर्ण हुआ",
                WorkerName: "कार्यकर्ता का नाम",
                Notes: "नोट्स (टिप्पणियाँ)",
                ResponseNotes: "प्रतिक्रिया नोटs",
                AddNotes: "नोट्स जोड़ें",
                MoveVisitToday: "आज ही विज़िट परिवर्तन करें",
                ShowMore: "... अधिक दिखाएं",
                VisitType: "विज़िट का प्रकार ",
                PleaseAsk: "कृपया पूछें ",
                ToConfirmThatTheyReceived: "यह पुष्टि करने के लिए कि उन्होंने प्राप्त किए हैं",
                ServiceToday: "आज की सेवा ",
                Yes: "हाँ",
                No: "नहीं ",
                ToConfirmThatTheVisit: "पुष्टि करने के लिए कि विज़िट का समय _____ से ",
                ReportDeparture2: "काम समाप्त करना",
                ToSignHere: "यहाँ हस्ताक्षर करने के लिए",
                VoiceSignature: "बोली (वॉइस) हस्ताक्षर",
                PleaseSignHere: "कृपया यहाँ हस्ताक्षर करें",
                PleaseAskYour: "कृपया अपने _____ से पूछें ",
                ErrandMiles: "एरंड माइल्स",
                AddPhoto: "फ़ोटो जोड़ें",
                Clear: "साफ़ करें",
                Accept: "स्वीकार करें",
                NotAvailable: "उपलब्ध नहीं है",
                VisitConfirmation: "विज़िट की पुष्टि ",
                RequestForConfirmation: "कृपया पुष्टि करने के लिए कि आज आपने अपनी सेवाएं प्राप्त की है स्टार्ट रिकॉर्डिंग दबाने के बाद अपना नाम और आज की तारीख दर्ज करें।",
                PlayRecording: "रिकॉर्डिंग प्ले करें",
                StopPlayRecording: "रिकॉर्डिंग प्ले बंद करें",
                StartRecording: "रिकॉर्डिंग शुरू करें",
                StopRecording: "रिकॉर्डिंग बंद करें",
                MonthView: "महीना गत अवलोकन (व्यू)",
                WeekView: "सप्ताह गत अवलोकन (व्यू)",
                ArrSuccess: "आपका आगमन सफलतापूर्वक _____ पर दर्ज किया गया था",
                ArrOffline: "आपका आगमन दर्ज किया गया है लेकिन आप ऑफ़लाइन हैं। आपके कार्यालय को देर से चेतावनी मिल सकती है।",
                ArrSuccessDeparture: "आपका अपेक्षित प्रस्थान समय है ____",
                CurrentVisit: "वर्तमान विज़िट की अवधि",
                Hours: "घंटे",
                Minutes: "मिनट",
                ClockOutButton: "क्लॉक आउट ",
                ConfirmLocation: "हम अभी भी आपकी लोकेशन की पुष्टि करने का प्रयास कर रहे हैं। हम 3 मिनट तक प्रयास करते रहेंगे।",
                ViewTasks: "कार्य देखें",
                CurrentDeparture: "वर्तमान प्रस्थान समय",
                Duration: "समयावधि",
                Duration2: "समयावधि",
                ConfirmClockOut: "क्या आप निश्चित हैं कि आप क्लॉक आउट करना चाहते हैं? ",
                Only3OnHoldVisitsWillShowAtaTime: "केवल 3 विलंबित यात्राओं को एक समय में दिखाया जाएगा।",
                Submit: "दर्ज करें (सब्मिट)",
                DepSuccess: "आपका प्रस्थान सफलतापूर्वक ______ पर दर्ज किया गया था",
                VisitSuccesfullyClosed: "विज़िट सफलतापूर्वक बंद कर दी गई",
                DepOffline: "आपका प्रस्थान रिकॉर्ड किया गया है लेकिन आप ऑफ़लाइन हैं। आपके कार्यालय को देर से चेतावनी मिल सकती है।",
                PleaseOpenYourAnkotaApplater: " જ્યારે તમારી પાસે સારો સિગ્નલ હોય (જ્યારે તમે ઓનલાઈન હોવ) ત્યારે કૃપા કરીને તમારી અંકોટા એપ ખોલો જેથી તમારો મુલાકાત ડેટા ઓફિસમાં મોકલી શકાય.",
                Home: "घर",
                Save: "सेव करें",
                AssignedPatients: "असाइन किए गए ग्राहक",
                AvailableShifts: "उपलब्ध शिफ्ट",
                ReportMissedVisit: "मिस्ड विज़िट की रिपोर्ट करें",
                ReportVisit: "रिपोर्ट विज़िट",
                AddMissedVisitReason: "कारण चुनें ",
                CorrectDatesTime: "उपरोक्त तिथियों/समयों पर क्लिक करके और सही विकल्प तक स्क्रॉल करके उन्हें ठीक करें।",
                ContigousVisitBlock: "यह यात्रा यात्राओं के एक ब्लॉक का हिस्सा थी। कृपया इस ब्लॉक के लिए अपना वास्तविक प्रारंभ समय और अपना अंतिम क्लॉक-आउट समय दर्ज करें।",
                AddWorkerDocument: "दस्तावेज़ का चयन करें ",
                ReportExpensesTitle: "व्यय",
                ReportExpensesQuestion: "क्या आपके पास रिपोर्ट करने के लिए खर्च हैं?",
                Amount: "रकम",
                Description: "विवरण",
                Company: "कंपनी",
                NotesAndInfo: "नोट्स और जानकारी",
                InfoOnlyItems: "जानकारी केवल आइटम",
                NoNotesForVisit: "इस यात्रा के लिए कोई नोट नहीं हैं!",
                NoInfoForVisit: "इस विज़िट के बारे में कोई जानकारी नहीं है!",
                ContiguousVisits: "लगातार दौरे",
                Details: "विवरण",
                Signature: "हस्ताक्षर",
                GoToSign: "पैड दिखाएं",
                History: "इतिहास",
                NoNotesInHistory: "इतिहास में कोई नोट नहीं!",
                CarePlanHistoryNotAvailableOffline: "केयर प्लान आइटम इतिहास ऑफ़लाइन मोड में उपलब्ध नहीं है!",
                TheVisitIsAlreadySigned: "दौरे पर पहले ही हस्ताक्षर हो चुके हैं। आप बिना हस्ताक्षर के जारी रख सकते हैं।",
                OfflineUptimeWarning: "हो सकता है कि आपका डिवाइस आपके पिछले ऑनलाइन लॉगिन के बाद से फिर से चालू हो गया हो। यदि संभव हो तो कृपया अपना समय अपडेट करने के लिए ऑनलाइन लॉगिन करें।",
                Phone: "फ़ोन",
                Email: "ईमेल",
                OfflineModeWarning: "खराब कनेक्शन के कारण आपके एप्लिकेशन में समस्या आ रही है और यह आपके डेटा को ऑफ़लाइन कैप्चर करेगा। आपके नेटवर्क कनेक्शन में सुधार होते ही कार्यालय को अपडेट कर दिया जाएगा।",
                OnlineModeWarning: "आपका एप्लिकेशन सर्वर से पुन: कनेक्ट करने में कामयाब रहा। आपका विज़िट डेटा अब सिंक्रनाइज़ और ऑनलाइन संसाधित किया जाएगा।.",
                Refresh: "ताज़ा करना",
                ResetMapsApp: "मैप्स ऐप रीसेट करें",
                DefaultMapsAppWarning: "डिफॉल्ट मैप्स ऐप को रीसेट कर दिया गया है। अगली बार जब आप नेविगेटर लॉन्च करेंगे तो आप एक नया एप्लिकेशन चुनने में सक्षम होंगे।",
                UseBingInstead: "बिंग मैप्स का प्रयोग करें",
                NoLocationWarning: "आपका स्थान कैप्चर नहीं किया जा सका. सुनिश्चित करें कि आपका GPS चालू है, अन्यथा आपका चुना हुआ मैप्स एप्लिकेशन आपकी स्थिति का पता लगाने में सक्षम नहीं हो सकता है। क्या आप वैसे भी आगे बढ़ना चाहते हैं? आपको अपनी वर्तमान स्थिति को मैन्युअल रूप से इनपुट करना पड़ सकता है!",
                NoMapsWarning: "आपके डिवाइस पर कोई मैप एप्लिकेशन नहीं मिला है। इसके बजाय बिंग मानचित्र खोले जाएंगे।",
                HoursLimitWarning: "</br><b><p style='color:Red'>यात्रा की अवधि> 16 घंटे। क्या आपको यकीन है?</p></b>",
                SlotChangeWarning: "आपने इस समय स्लॉट के दौरान विज़िट निर्धारित की हैं। कृपया अपने उपलब्धता परिवर्तन का अनुरोध करने के लिए कार्यालय से संपर्क करें।",
                WorkerPhone: "कार्यकर्ता फोन",
                PleaseTurnOnGPS: "आपका जीपीएस बंद है। कृपया आगे बढ़ने से पहले एप्लिकेशन को आपके स्थान पर कब्जा करने दें। अपने स्थान को कैप्चर करने की अनुमति देने के बाद आपको 'रिफ्रेश जीपीएस' बटन दबाने की आवश्यकता हो सकती है।",
                NoGPSOnVisit: "जीपीएस लोकेशन का समय पर पता नहीं चल सका। क्या आप निर्देशांक के बिना जारी रखना चाहते हैं?",
                NoGPSPermission: "आप इस ऐप का उपयोग नहीं कर सकते क्योंकि आपने ऐप के लिए स्थान साझाकरण सक्षम नहीं किया है। आप या तो अपनी ऐप सेटिंग्स को अपडेट कर सकते हैं या ऐप को हटाकर पुनः इंस्टॉल कर सकते हैं। यदि आप पुनः इंस्टॉल करते हैं, तो जब आप लॉग इन करेंगे तो यह पूछेगा कि क्या ऐप आपके स्थान का उपयोग कर सकता है। आगे बढ़ने के लिए आपको हां कहना होगा।",
                SyncVisitWarning: "विज़िट को सर्वर के साथ सिंक्रनाइज़ नहीं किया जा सका। बाद में पुन: प्रयास करें!",
                CarePlanItemHistoryDisplayMode: "देखभाल योजना इतिहास प्रदर्शन मोड",
                Individually: "व्यक्तिगत रूप से",
                AllAtOnce: "यकायक",
                GpsTimeLeft: "एप्लिकेशन GPS निर्देशांक प्राप्त करने का प्रयास कर रहा है। विफलता के मामले में, क्लॉकिंग इन/आउट अधिकतम में उपलब्ध कराया जाएगा ",
                Seconds: "सेकंड",
                BlockUser: "खंड उपयोगकर्ता",
                ServicePeriod: "सेवा अवधि",
                ServicePeriodStartDate: "सेवा अवधि प्रारंभ तिथि",
                UseBy: "द्वारा उपयोग",
                TotalTime: "कुल समय",
                UsedTime: "बिताया समय",
                RemainingTime: "शेष समय",
                AuthInfo: "Auth Info",
                YouMayWorkUpTo: "<br/><br/>आप तक काम कर सकते हैं",
                NoAuthorizedUnitsLeftWarning: "आप इस रोगी और विज़िट प्रकार के लिए एक नई यात्रा शुरू नहीं कर सकते क्योंकि यात्रा के लिए 0 अधिकृत मिनट शेष हैं!",
            },
            "ru": { //Russian
                Nothing: "",
                Username: "Электронная почта или Имя пользователя",
                Password: "Пароль",
                NewAppVersionAvailable: "Доступна новая версия приложения. Обновите его!",
                UserError: "Пожалуйста, введите правильное имя пользователя.",
                PwError: "Ваш пароль должен содержать более 6 символов.",
                Login: "Авторизоваться",
                FaceID: "Лицо ID",
                Fingerprint: "Отпечаток пальца",
                PwForgot: "забыли пароль",
                Version: "Версия",
                TitleApp: "МАНОС ДОМАШНИЙ УХОД?",
                Subtitle: "Портал для сиделок",
                Monday: "Понедельник",
                Tuesday: "Вторник",
                Wednesday: "Среда",
                Thursday: "Четверг",
                Friday: "Пятница",
                Saturday: "Суббота",
                Sunday: "Воскресенье",
                ViewMap: "Посмотреть карту",
                NoteTooLong: "Примечание слишком длинное. Пожалуйста, используйте не более 512 символов!",
                NoteTooLong4000characters: "Примечание слишком длинное. Пожалуйста, используйте не более 4000 символов!",
                OfflinePassForgot: "Вы не в сети. Пожалуйста, подключитесь к сети, чтобы сбросить пароль.",
                ConfirmPassReset: "Вы уверены, что хотите сбросить пароль?",
                ConfirmShiftResponse: "Вы уверены, что хотите ответить на эту открытую смену?",
                PatientName: "</br></br>Имя пациента: ",
                EmptyUsername: "Пожалуйста, убедитесь в том, что вы ввели имя пользователя / адрес электронной почты!",
                EmptyError: "В системе нет Вашего номера телефона или адреса электронной почты. Обратитесь в офис, чтобы поменять пароль.",
                PassResetSuccess: "На вашу электронную почту было отправлено письмо для сброса пароля",
                PhoneError: "На ваш номер телефона отправлено сообщение для сброса пароля.",
                NewMessages: "У вас могут быть новые сообщения.",
                ReadNow: "Прочитать сейчас",
                ReadLater: "Прочитать позже",
                Ok: "ОК",
                Close: "Закрыть",
                DeleteWorking: "Вы уверены, что хотите удалить рабочий час?",
                DeleteAdjustment: "Вы действительно хотите удалить корректировку <b>",
                InitiatingCall: "Инициация звонка ...",
                CallFailed: "Вызов не удался",
                CallCanceled: "Вызов отменен",
                OngoingCall: "Текущий вызов ...",
                CallEnded: "Вызов окончен",
                IncomingCall: "Входящий вызов",
                ConnectingToCall: "Подключение ...",
                Rejected: "Отклоненный ...",
                RejectionFailed: "Не удалось отклонить ...",
                ChangePasswordOfflineWarning: "Смена пароля доступна только при наличии интернет-соединения!",
                PassBlank: "Введите пароль еще раз. Он отсутствует или не совпадает!",
                PleaseConnect: "Пожалуйста, подключитесь к Интернету, чтобы войти в систему!",
                InvalidPassword: "Текущий пароль недействителен. Пожалуйста, попробуйте еще раз!",
                AcceptedChars: "Допустимые символы - это буквы, цифры и символы '.', '!'.",
                NewInvalidPass: "Новый пароль недействителен. Пожалуйста, проверьте требования к паролю, указанные выше.",
                InvalidCurrentPassword: "Неверный текущий пароль!",
                PasswordMustBeDifferent: "Новый пароль должен отличаться от последних 3 паролей. Пожалуйста, попробуйте другой пароль.",
                PasswordsDoNotMatch: "Пароли не соответствуют!",
                PassBlockedWord1: "Новый пароль содержит заблокированное слово",
                PassBlockedWord2: "Пароль не должен содержать заблокированных слов.",
                PasswordResetSuccess: "Вы успешно изменили ваш пароль. Пожалуйста, войдите в систему.",
                AgreeToReceiveInformationalMessages: "Я согласен получать информационные сообщения/уведомления на мой номер телефона от ",
                PasswordResetNotSuccessful: "Не удалось изменить пароль. Пожалуйста, попробуйте еще раз.",
                Enable: "Подключить",
                Disable: "Отключить",
                UnableToSaveCode: "Не удалось сохранить код. Обратитесь в службу поддержки!",
                InvalidCode: "Неверный код",
                ConfirmingLocation: "Подтверждаем местоположение - пожалуйста, подождите!",
                GPSNotCaptured: "Ваши координаты GPS не зафиксировались. Пожалуйста, попробуйте еще раз, используя кнопку Обновить GPS!",
                GPSNotCaptured2: "Ваши координаты GPS не зафиксированы. Вы можете нажать «Принять время», чтобы начать посещение, но не выходите из приложения  в течение следующих 3 минут, чтобы мы могли продолжить попытки определить ваше местоположение.",
                GPSNotCaptured3: "Ваши координаты GPS не зафиксированы. Пожалуйста, попробуйте еще раз!",
                TooEarlyToReport: "Вы пришли слишком рано. Пожалуйста, приходите в назначенное время.",
                TooLateToReport: "Вы слишком поздно, чтобы включить часы.",
                LocationNotCloseEnough: "Ваше местоположение находится недостаточно близко к дому клиента. Пожалуйста, войдите из дома клиента и повторите попытку, используя Refresh GPS!",
                YourArrivalTimeIs: "Ваше рабочее время",
                SomeoneElseIsAlreadyClocked: "Кто-то еще уже зарегистрирован. Пожалуйста, попросите их выйти, чтобы вы могли войти.",
                YourDepartureTimeIs: "</br></br>Ваше время отправления ",
                YourVisitDurationIs: "</br></br>Продолжительность посещения ",
                YourExpectedDeparture: "  Ваше ожидаемое время отправления:",
                ClientDocumentsReady: " Подтверждая свое прибытие, вы подтверждаете, что ознакомились с документами клиента.",
                OpenShiftDate: "</br></br>Дата открытия смены: ",
                OpenShiftTime: "</br></br>Время открытия смены: ",
                WeStillTryingConfirmLocation: "  Мы все еще пытаемся подтвердить ваше местоположение. Мы будем продолжать попытки в течение 3 минут.",
                YourExpectedDepartureTimeNotUntil: "Ожидаемое время отправления",
                CompleteFullySchedule: "Для того, чтобы завершить работу согласно запланированного графика, необходимо доработать оставшиеся",
                PleaseSetStatus: "Установите статус для всех элементов!",
                CarePlanItemAlreadyExisit: "Элемент плана медицинского обслуживания, который вы хотите добавить, уже добавлен в список.",
                DurationGreaterThan0: "Продолжительность посещения должна быть больше 0 минут!",
                MessageConfirmLogOut: "Вы действительно хотите выйти?",
                Confirm: "Подтвердить",
                Cancel: "Отмена",
                PageAvailableOnlyOnline: "Эта страница доступна только в режиме онлайн.",
                SomethingWentWrong: "Что-то пошло не так. Пожалуйста, попробуйте еще раз!",
                EnrolledSuccessfully: "Вы зарегистрированы!",
                SuccessfullPictureUpload: "Изображение загружено успешно.",
                VisitMoved: "Посещение перенесено!",
                PatientConcernTooLong: "Описание состояния пациента слишком длинное. Пожалуйста, используйте не более 512 символов!",
                VisitHistoryOffline: "История посещений доступна только при наличии подключения к Интернету.",
                OnlyNetAccess: "Доступно только при наличии доступа в Интернет!",
                ErrorSavingSignature: "Ошибка при сохранении подписи. Пожалуйста, попробуйте еще раз или свяжитесь с Ankota.",
                ErrorSavingWorkerSignature: "Ошибка при сохранении подписи работника. Пожалуйста, попробуйте еще раз или свяжитесь с Ankota.",
                ErrorSavingPatientSignature: "Ошибка при сохранении подписи пациента. Пожалуйста, попробуйте еще раз или свяжитесь с Ankota.",
                CouldNotCreateFile: "Не удалось создать файл",
                NoRecording: "Нет записи!",
                UploadedFile: "Файл загружен успешно.",
                MarkWhileOffline: "Вы не можете пометить сообщение как прочитанное, пока находитесь в автономном режиме!,",
                Offline: "Вы не в сети",
                Syncing: "Синхронизация ... пожалуйста, подождите",
                LoadingMessage: "Загрузка, пожалуйста, подождите",
                Title: "Заголовок",
                Message: "Сообщение",
                Date: "Дата",
                DateAndTime: "Дата и время",
                MarkAsRead: "Пометить, как прочитанное",
                Call: "Вызов",
                Immediately: "немедленно.",
                HourShort: "час",
                MinShort: "м",
                Actions: "Действия",
                UnblockUser: "Разблокировать пользователя,",
                Image: "Изображение",
                Document: "Документ",
                LoadingDocsWait: "Документы загружаются, пожалуйста, подождите",
                ProcessDocsWait: "Документы обрабатываются,  пожалуйста, подождите",
                PleaseConnectToLogIn: "Пожалуйста, подключитесь к Интернету, чтобы войти в систему!",
                AvailableShifsNoInternet: "Доступные смены доступны только при наличии подключения к Интернету!",
                ShiftNotAvailable: "Смена больше недоступна.",
                ShiftAssignedToYou: "Офис назначил вас на эту смену. Если вы не можете это сделать, пожалуйста, свяжитесь с офисом!",
                InvalidUserOrPass: "Неправильное имя пользователя или пароль. Пожалуйста, попробуйте еще раз.",
                UnexpectedErrorContactSupport: "Непредвиденная ошибка! Обратитесь в службу поддержки!",
                FingerprintAuthError: "Произошла ошибка во время аутентификации отпечатка пальца.",
                EnrollAgain: "Что-то пошло не так, зарегистрируйтесь снова!",
                UsernameEnrollmentError: "Пользователь с таким именем не зарегистрирован. Попробуйте другое имя пользователя или войдите по паролю!",
                BiometricAuthentication: "Пожалуйста, введите имя пользователя для биометрической аутентификации.",
                InvalidCoordinates: "Неверные координаты",
                SigningInPleaseWait: "Вход в систему, пожалуйста, подождите",
                PleaseWaitSearch: "Подождите, пока мы ищем ваши активные задания.",
                SignIn: "Войти",
                UseBackup: "Использовать резервную копию",
                FingerprintAuthentication: "Аутентификация по отпечатку пальца",
                PleaseEnrollYourProfile: "Пожалуйста, зарегистрируйте свой профиль",
                DoYouHave: "У тебя есть",
                Concerns: "Обеспокоенность",
                HRNotifications: "Уведомления от отдела кадров",
                NoNotifications: "Уведомлений нет.",
                Hi: "ДОБРЫЙ ДЕНЬ",
                Expected: "ожидаемо",
                SelectLanguage: "Выберите язык ...",
                ChangePassword: "Поменять пароль",
                LoginErr: "Логин недействителен. Пожалуйста, попробуйте еще раз.",
                About: "Подробнее",
                Account: "Электронный кабинет",
                UploadDocumentOrPicture: "Загрузить документ или изображение",
                Name: "Имя",
                PickUpCases: "ВЗЯТЬ КЕЙСЫ",
                CaseOrderName: "Кейс#:",
                TimeBetweenCases: "Время между кейсами:",
                TravelTime: "Время в пути",
                Status: "Статус",
                Language: "Язык",
                AssignToMe: "Закрепить за мной",
                AcceptCase: "Принять кейс",
                DeclineCase: "Отклонить кейс",
                SeeDetails: "Смотрите подробности",
                ConsumerNoShow: "Неявка клиента",
                ReturnCase: "Возврат кейса",
                LateCancellation: "Поздняя отмена",
                YouArePreferred: "ПРЕДПОЧИТАЮТ ВАС ",
                NoCasesToShow: "Нет кейсов.",
                NoAssignedPatients: "У вас нет назначенных клиентов!",
                ReportTasks: "Отчет о работе",
                MyRegularSchedule: "Мое регулярное расписание",
                BookingsPerWeek: "Визитов в неделю",
                Slot: "Временной интервал",
                AddASlot: "Добавить временной интервал",
                AddTimeoffConflict: "Добавить свободное время/конфликт",
                OverrideSchedule: "Перестроить расписание",
                Type: "Тип",
                OverwriteEmployeeCalendar: "Изменить рабочий календарь",
                BlockedUsers: "Заблокированные пользователи",
                Chat: "Чат",
                LoadMoreUsers: "Загрузить больше пользователей",
                PasswordMustBe: "Пароль должен быть",
                PasswordMustBeAtLeast: "Пароль должен быть не менее",
                PasswordMustBeAtMost: "Пароль должен быть не более",
                PasswordMustContainAtLeast: "Пароль должен содержать не менее",
                NumericCharacters: "числовых символов",
                SpecialCharacters: "специальных символов",
                CharactersLong: "знаков.",
                PasswordRequirement: "Пароль должен содержать 3 из 4 типов нижних, верхних, специальных символов и цифр.",
                CurrentPassword: "Текущий пароль",
                NewPassword: "Новый пароль",
                ReenterPassword: "Введите новый пароль еще раз",
                TypeMsg: "Напечатайте ваше сообщение здесь...",
                To: "кому",
                SentFileToYou: "отправил вам файл, вы можете его скачать",
                Here: "здесь.",
                Hello: "Здравствуйте ",
                ClientView: "Просмотр клиента",
                ReportArrival: "часы в",
                ReportDeparture: "ЧАСЫ ИЗ",
                Logout: "Выйти",
                Completion: "Завершено Сегодня",
                NoMatchedClients: "Нет подходящих клиентов! Пожалуйста, свяжитесь с",
                ConfirmDeparture: "ПОДТВЕРДИТЬ ОТПРАВЛЕНИЕ",
                ArrivalDate: "Дата прибытия",
                ArrivalTime: "Время прибытия",
                DepartureDate: "Дата отправления",
                DepartureTime: "Время отправления",
                VisitDocuments: "Документы Посещения",
                Complete: "Завершенный",
                Incomplete: "Незавершенный",
                NotStarted: "Не начато",
                ProcessDocuments: "Обработка Документов",
                OnlyOnline: "  можно сделать только в режиме онлайн",
                ConnectionOflline: "Нет интернет-соединения",
                SaveIncomplete: "Сохранить в незавершенном виде",
                ResetToNew: "Поменять на новый",
                PickerDisplay: "выбор даты / числа, времени",
                ReportNoShow: "Сообщить о неявке",
                ReportCancelVisit: "Сообщить об отмене визита",
                NotificationCenter: "ЦЕНТР УВЕДОМЛЕНИЙ",
                Visits: "Посещения",
                Time: "Время",
                Client: "Клиент",
                Location: "Местоположение",
                AcceptVisit: "Принять посещение",
                DeclineVisit: "Отклонить посещение",
                Messages: "Сообщения",
                Title2: "Заголовок",
                Delete: "Удалить",
                ViewDocsPatients: "Просмотреть документы для следующих пациентов:",
                ViewDocuments: "Просмотр документов",
                Documents: "Документы",
                PayrollHistory: "ВСЕ ЗАРПЛАТНЫЕ ВЕДОМОСТИ",
                WeeklyHours: "ЧАСЫ РАБОТЫ В НЕДЕЛЮ",
                NoPayrollsToShow: "Нет данных о заработной плате.",
                PayrollSummary: "ОТЧЕТ ПО ЗАРПЛАТЕ",
                WeeklySummary: "ОБЗОР НЕДЕЛЬНЫХ ЧАСОВ",
                GrossEarnings: "СУММАРНЫЙ ДОХОД",
                GrossEarnings2: "Суммарный доход",
                TotalHourBreakdown: "Общая разбивка часов",
                Regular: "Обычный",
                Overtime: "Через некоторое время",
                VisitTime: "Время посещения",
                TotalHoursWorked: "Общее количество отработанных часов",
                Adjustments: "Корректировки",
                AdjustmentsReflect: "Корректировки отражают изменения предыдущих выплат.",
                ExpectedPayment: "Ожидаемая зарплата до вычета налогов",
                HoursWorked: "Отработанные часы",
                NumberofDays: "Количество дней",
                NumberOfVisits: "Количество посещений",
                VisitHistory: "История посещений",
                Trips: "Поездки",
                TripOptionQuestion: "Использовали ли Вы немедицинский транспорт во время посещения?",
                RefreshGPS: "Обновить GPS",
                ClockIn: "отсутствует время начала работы",
                ClockOut: "отсутствует время завершения работы",
                CurrentArrival: "Время работы",
                AcceptTime: "Часы в",
                ReportItems: "ПОДРОБНЫЙ ОТЧЕТ  ",
                AddBreak: "Добавить перерыв",
                NA: "Нет сведений",
                Set: "Установлено",
                NotSet: "Не установлено",
                AddAnotherItem: "Добавить еще один элемент",
                NothingToAdd: "Нечего добавить",
                AddItem: "Добавить элемент",
                NoItemsToDisplay: "Нет элементов для отображения.",
                Next: "Следующий",
                SelectVisitType: "Выберите тип посещения",
                Settings: "НАСТРОЙКИ",
                Availability: "Доступность",
                General: "Общий",
                Security: "Безопасность",
                NameUploadPicturesDocs: "Имя, загрузить фотографии/документы",
                ConsenttoReceiveTexts: "Согласие на получение текстовых сообщений",
                ChangePasswordFingerprintFaceID: "Сменить пароль, отпечаток пальца/Face ID",
                AddSlots: "Добавить слоты",
                ToSetAdditionalSettings: "Чтобы установить дополнительные настройки, войдите в систему с теми же учетными данными на странице",
                Authentication: "АУТЕНТИФИКАЦИЯ",
                EnterSMSCode: "Введите код, который вы получили в SMS:",
                Back: "Назад",
                Code: "Код",
                MyVisits: "МОИ ПОСЕЩЕНИЯ",
                Address: "Адрес",
                CreatedByPhone: "Создано по телефону",
                ViewMoreDetails: "Посмотреть больше деталей",
                NoShow: "Неявка",
                Tasks: "Задачи",
                CancelVisit: "Отменить визит",
                UploadDocs: "Загрузить документы",
                DocumentsAreLoading: "Документы загружаются...",
                NoDocuments: "Нет документов",
                Rework: "ПЕРЕДЕЛАТЬ",
                OnHold: "ЗАВЕРШИТЬ ВИЗИТ",
                PleaseSelectReason: "Пожалуйста, выберите причину!",
                PleaseSelectDocument: "Пожалуйста, выберите документ!",
                NoVisitsToShow: "Нет посещений  ",
                UploadTimesheets: "ЗАГРУЗИТЬ ТАБЕЛЬ",
                UploadDocuments: "Загрузить документы",
                EnterAdditionalNotes: "Укажите дополнительные примечания здесь...",
                VisitDirections: "КАК ДОБРАТЬСЯ",
                DriveTime: "Время в пути",
                PrecedingVisitEndTime: "Время окончания предыдущего посещения",
                TimeBetweenVisits: "Время между посещениями",
                VisitAddress: "Адрес клиента",
                LiveDirections: "Навигация в реальном времени",
                VisitDetails: "ДЕТАЛИ ПОСЕЩЕНИЯ",
                ClientName: "Имя клиента",
                ServiceName: "Наименование услуги",
                VisitDate: "Дата посещения",
                VisitStatus: "Статус посещения",
                PrimaryPhone: "Основной номер телефона",
                SecondaryPhone: "Дополнительный номер телефона",
                GetDirections: "Построить маршрут",
                VisitNotes: "Примечания к посещению",
                Instructions: "Инструкции",
                PleaseUseTheButton: "Пожалуйста, используйте кнопку внизу, чтобы сфотографировать свой лист. Используйте кнопку повтора, если изображение кажется нечетким.",
                Keep: "Оставить",
                TakePicture: "Сфотографировать",
                UploadOrTakePicture: "Загрузить или сделать снимок",
                RetakePicture: "Сфотографировать повторно",
                AddPhoto2: "ДОБАВИТЬ ФОТО",
                VisitHistoryCaps: "ИСТОРИЯ ПОСЕЩЕНИЙ",
                Completed: "завершено  ",
                WorkerName: "Имя работника",
                Notes: "Примечания   ",
                ResponseNotes: "Примечания к ответу",
                AddNotes: "Добавить примечания",
                MoveVisitToday: "Перенести визит сегодня",
                ShowMore: "... Показать больше",
                VisitType: "Тип посещения",
                PleaseAsk: "Пожалуйста, попросите ",
                ToConfirmThatTheyReceived: "клиента подтвердить, что он получил",
                ServiceToday: "сегодня услуги ",
                Yes: "Да",
                No: "Нет",
                ToConfirmThatTheVisit: "чтобы подтвердить, что время посещения было с",
                ReportDeparture2: "ЧАСЫ ИЗ",
                ToSignHere: "расписаться здесь",
                VoiceSignature: "Голосовая подпись",
                PleaseSignHere: "Пожалуйста, распишитесь здесь",
                PleaseAskYour: "Пожалуйста, спросите у своего",
                ErrandMiles: "Миль в пути",
                AddPhoto: "Добавить фото",
                Clear: "Очистить",
                Accept: "Принять",
                NotAvailable: "Недоступен",
                VisitConfirmation: "Подтверждение посещения",
                RequestForConfirmation: "После нажатия кнопки «Начать запись» произнесите свое имя и сегодняшнюю дату, чтобы подтвердить, что вы сегодня получили услуги.",
                PlayRecording: "Воспроизвести запись",
                StopPlayRecording: "Остановить воспроизведение записи",
                StartRecording: "Начать запись",
                StopRecording: "Остановить запись",
                MonthView: "Просмотр по месяцам",
                WeekView: "Просмотр по неделям",
                ArrSuccess: "Ваше прибытие было успешно зарегистрировано в",
                ArrOffline: "Факт прибытия зарегистрирован, но вы не в сети. В офис может прийти уведомление об опоздании.",
                ArrSuccessDeparture: "Ожидаемое время отправления:",
                CurrentVisit: "Текущая продолжительность посещения",
                Hours: "часов",
                Minutes: "минут",
                ClockOutButton: "Завершить рабочие часы",
                ConfirmLocation: "Мы все еще пытаемся подтвердить ваше местоположение. Мы будем продолжать попытки в течение 3 минут.",
                ViewTasks: "Просмотр Задач",
                CurrentDeparture: "Текущее время отправления",
                Duration: "продолжительность",
                Duration2: "Продолжительность",
                ConfirmClockOut: "Вы уверены, что хотите закончить работу?",
                Only3OnHoldVisitsWillShowAtaTime: "В любой момент будет показано только 3 приостановленных визита.",
                Submit: "Отправить",
                DepSuccess: "Ваше отправление было успешно зарегистрировано в",
                VisitSuccesfullyClosed: "Визит успешно закрыт",
                DepOffline: "Факт отправления зарегистрирован, но вы не в сети. В офис может прийти уведомление об опоздании.",
                PleaseOpenYourAnkotaApplater: " Пожалуйста, откройте приложение Ankota позднее сегодня, когда у вас будет лучший сигнал (когда вы будете в сети), чтобы данные о вашем посещении могли быть отправлены в офис.",
                Home: "Главная",
                Save: "Сохранить",
                AssignedPatients: "НАЗНАЧЕННЫЕ КЛИЕНТЫ",
                AvailableShifts: "Доступные смены",
                ReportMissedVisit: "Сообщить о пропущенном посещении",
                ReportVisit: "Сообщить о посещении",
                AddMissedVisitReason: "Выберите причину",
                CorrectDatesTime: "Исправьте даты/время, указанные выше, щелкнув их и прокрутив до нужного варианта.",
                ContigousVisitBlock: "Этот визит был частью блока визитов. Введите фактическое время начала и конечное время ухода для этого блока.",
                AddWorkerDocument: "Выберите документ ",
                ReportExpensesTitle: "Отчет о расходах",
                ReportExpensesQuestion: "У вас есть расходы, чтобы отчитаться?",
                Amount: "Количество",
                Description: "Описание",
                Company: "Компания",
                NotesAndInfo: "Примечания и информация",
                InfoOnlyItems: "Только информация",
                NoNotesForVisit: "Для этого визита нет заметок!",
                NoInfoForVisit: "Информации об этом посещении нет!",
                ContiguousVisits: "Смежные посещения",
                Details: "Подробности",
                Signature: "Подпись",
                GoToSign: "Показать панель",
                History: "История",
                NoNotesInHistory: "Никаких заметок в истории!",
                CarePlanHistoryNotAvailableOffline: "История элементов плана медицинского обслуживания недоступна в автономном режиме!",
                TheVisitIsAlreadySigned: "Визит уже подписан. Вы можете продолжить без подписи.",
                OfflineUptimeWarning: "Ваше устройство могло быть перезагружено с момента вашего последнего входа в систему. Если возможно, пожалуйста, войдите в систему, чтобы обновить свое время.",
                Phone: "Телефон",
                Email: "Эл. адрес",
                OfflineModeWarning: "У вашего приложения проблемы из-за плохого соединения, и оно будет собирать ваши данные в автономном режиме. Офис будет обновлен, как только ваше сетевое соединение улучшится.",
                OnlineModeWarning: "Вашему приложению удалось повторно подключиться к серверу. Данные о посещениях теперь будут синхронизированы и обработаны онлайн.",
                Refresh: "Обновить",
                ResetMapsApp: "Сбросить приложение Карты",
                DefaultMapsAppWarning: "Приложение карт по умолчанию было сброшено. При следующем запуске навигатора вы сможете выбрать новое приложение.",
                UseBingInstead: "Используйте карты Bing",
                NoLocationWarning: "Не удалось зафиксировать ваше местоположение. Убедитесь, что ваш GPS включен, иначе выбранное вами картографическое приложение не сможет определить ваше местоположение. Вы все равно хотите продолжить? Возможно, вам придется ввести свое текущее положение вручную!",
                NoMapsWarning: "На вашем устройстве не найдено картографических приложений. Вместо этого будут открыты карты Bing.",
                HoursLimitWarning: "</br><b><p style='color:Red'>Продолжительность визита > 16 часов. Уверены ли вы?</p></b>",
                SlotChangeWarning: "У вас запланированы визиты на этот временной интервал. Пожалуйста, свяжитесь с офисом, чтобы запросить изменение вашей доступности.",
                WorkerPhone: "Рабочий телефон",
                PleaseTurnOnGPS: "Ваш GPS выключен. Прежде чем продолжить, разрешите приложению определить ваше местоположение. Возможно, вам придется нажать кнопку «Обновить GPS» после того, как ваше местоположение будет захвачено.",
                NoGPSOnVisit: "Местоположение GPS не может быть определено вовремя. Хотите продолжить без координат?",
                NoGPSPermission: "Вы не можете использовать это приложение, потому что вы не включили совместное использование местоположения для приложения. Вы можете либо обновить настройки приложения, либо удалить и переустановить приложение. Если вы переустановите приложение, при входе в систему оно спросит, может ли приложение использовать ваше местоположение. Вы должны сказать да, чтобы продолжить.",
                SyncVisitWarning: "Посещение не удалось синхронизировать с сервером. Пожалуйста, попробуйте позже!",
                CarePlanItemHistoryDisplayMode: "Режим отображения истории плана ухода",
                Individually: "Индивидуально",
                AllAtOnce: "Все сразу",
                GpsTimeLeft: "Приложение пытается получить GPS-координаты. В случае сбоя синхронизация входа/выхода будет доступна максимум через ",
                Seconds: "секунды",
                BlockUser: "Заблокировать пользователя",
                ServicePeriod: "Период обслуживания",
                ServicePeriodStartDate: "Дата начала периода обслуживания",
                UseBy: "Использовать по",
                TotalTime: "Общее время",
                UsedTime: "Использованное время",
                RemainingTime: "Оставшееся время",
                AuthInfo: "Auth Info",
                YouMayWorkUpTo: "<br/><br/>Вы можете работать до",
                NoAuthorizedUnitsLeftWarning: "Вы не можете начать новый визит для этого пациента и типа визита, потому что на визит осталось 0 авторизованных минут!",
            },
            "vi": { //Vietnamese
                Nothing: "",
                Username: "Email hoặc tên đăng nhập",
                Password: "Mật khẩu",
                NewAppVersionAvailable: "Phiên bản ứng dụng mới đã có, vui lòng cập nhật!",
                UserError: "Vui lòng nhập đúng tên đăng nhập",
                PwError: "Mật khẩu phải trên 6 ký tự",
                Login: "Đăng nhập",
                FaceID: "ID khuôn mặt",
                Fingerprint: "Dấu vân tay",
                PwForgot: "Quên mật khẩu?",
                Version: "Phiên bản",
                TitleApp: "CHĂM SÓC NHÀ MANOS",
                Subtitle: "Cổng thông tin dành cho Nhân Viên Chăm Sóc",
                Monday: "Thứ Hai",
                Tuesday: "Thứ Ba",
                Wednesday: "Thứ Tư",
                Thursday: "Thứ Năm",
                Friday: "Thứ Sáu",
                Saturday: "Thứ Bảy",
                Sunday: "Chủ Nhật",
                ViewMap: "Xem bản đồ",
                NoteTooLong: "Ghi chú quá dài. Vui lòng duy trì tối đa 512 ký tự!",
                NoteTooLong4000characters: "Ghi chú quá dài. Vui lòng duy trì tối đa 4000 ký tự!",
                OfflinePassForgot: "Bạn đang ngoại tuyến. Vui lòng kết nối internet để đặt lại mật khẩu.",
                ConfirmPassReset: "Bạn có chắc chắn muốn đặt lại mật khẩu của mình không?",
                ConfirmShiftResponse: "Bạn có chắc chắn muốn trả lời cho ca mở này không?",
                PatientName: "</br></br>Tên bệnh nhân: ",
                EmptyUsername: "Hãy chắc chắn bạn đã nhập tên đăng nhập/ email!",
                EmptyError: "Số điện thoại và email của bạn không có trên hệ thống. Vui lòng liên lạc văn phòng để cài đặt lại mật khẩu",
                PassResetSuccess: "Một email cài đặt lại mật khẩu đã được gửi đến hộp thư của bạn",
                PhoneError: "Một tin nhắn cài đặt lại mật khẩu đã được gửi đến số điện thoại của bạn",
                NewMessages: "Bạn có tin nhắn mới",
                ReadNow: "Xem ngay",
                ReadLater: "Xem sau",
                Ok: "Ok",
                Close: "Đóng",
                DeleteWorking: "Bạn có chắc chắn muốn xóa giờ làm việc không?",
                DeleteAdjustment: "Bạn có chắc chắn muốn xóa điều chỉnh không <b>",
                InitiatingCall: "Thực hiện cuộc gọi …",
                CallFailed: "Cuộc gọi không thành công",
                CallCanceled: "Cuộc gọi bị hủy",
                OngoingCall: "Đang gọi …",
                CallEnded: "Cuộc gọi kết thúc",
                IncomingCall: "Cuộc gọi đến",
                ConnectingToCall: "Kết nối …",
                Rejected: "Từ chối …",
                RejectionFailed: "Từ chối không thành công …",
                ChangePasswordOfflineWarning: "Thay đổi mật khẩu chỉ khả dụng khi có kết nối internet!",
                PassBlank: "Nhập lại mật khẩu bị bỏ trống hoặc mật khẩu không đúng!",
                PleaseConnect: "Vui lòng kết nối internet để đăng nhập!",
                InvalidPassword: "Mật khẩu hiện tại không đúng. Vui lòng thử lại!",
                AcceptedChars: "Các ký tự được chấp nhận bao gồm chữ cái, con số, và các ký tự đặc biệt như dấu chấm\".\" , chấm than \"!\"",
                NewInvalidPass: "Mật khẩu mới không hợp lệ. Vui lòng kiểm tra yêu cầu đặt mật khẩu trên",
                InvalidCurrentPassword: "Mật khẩu hiện tại không hợp lệ!",
                PasswordMustBeDifferent: "Mật khẩu mới phải khác 3 mật khẩu gần đây nhất. Vui lòng thử lại mật khẩu mới!",
                PasswordsDoNotMatch: "Mật khẩu không đúng!",
                PassBlockedWord1: "Mật khẩu mới chứa các ký tự bị chặn",
                PassBlockedWord2: "Mật khẩu không được chứa các ký tự bị chặn",
                PasswordResetSuccess: "Thay đổi mật khẩu thành công. Vui lòng đăng nhập lại",
                AgreeToReceiveInformationalMessages: "Tôi đồng ý nhận tin nhắn/thông báo thông tin trên số điện thoại của tôi từ ",
                PasswordResetNotSuccessful: "Không thể thay đổi mật khẩu. Vui lòng thử lại.",
                Enable: "Kích hoạt",
                Disable: "Vô hiệu",
                UnableToSaveCode: "Không thể lưu mã. Vui lòng liên lạc nhóm kỹ thuật!",
                InvalidCode: "Mã không hợp lệ",
                ConfirmingLocation: "Xác nhận địa điểm - Vui lòng đợi!",
                GPSNotCaptured: "Tọa độ GPS của bạn không được ghi nhận. Vui lòng thử lại bằng cách refresh GPS!",
                GPSNotCaptured2: "Tọa độ GPS của bạn không được ghi nhận. Bạn có thể nhấn 'Chấp Nhận Thời Gian' để bắt đầu chuyến thăm của mình, nhưng vui lòng để ứng dụng mở trong tối đa 3 phút để chúng tôi có thể tiếp tục tìm kiếm vị trí của bạn.",
                GPSNotCaptured3: "Tọa độ GPS của bạn không được ghi nhận. Vui lòng thử lại!",
                TooEarlyToReport: "Bạn còn quá sớm để đăng ký. Vui lòng truy cập vào thời gian đã định của bạn.",
                TooLateToReport: "Bạn đã quá muộn để theo dõi.",
                LocationNotCloseEnough: "Vị trí của bạn không đủ gần nhà của khách hàng. Vui lòng đồng hồ từ nhà của khách hàng và thử lại bằng cách sử dụng Làm mới GPS!",
                YourArrivalTimeIs: "Thời gian trong đồng hồ của bạn là ",
                SomeoneElseIsAlreadyClocked: "Một người khác đã được theo dõi. Vui lòng yêu cầu họ bấm giờ để bạn có thể theo dõi.",
                YourDepartureTimeIs: "</br></br>Thời gian khởi hành của bạn là ",
                YourVisitDurationIs: "</br></br>Thời lượng truy cập là ",
                YourExpectedDeparture: "Giờ đi dự kiến của bạn là",
                ClientDocumentsReady: " Bằng cách xác nhận việc bạn đến, bạn thừa nhận rằng bạn đã đọc các tài liệu của khách hàng.",
                OpenShiftDate: "</br> </br>Mở Ngày thay đổi:",
                OpenShiftTime: "</br></br>Mở thời gian thay đổi: ",
                WeStillTryingConfirmLocation: "Chúng tôi đang cố gắng xác nhận vị trí của bạn. Chúng tôi sẽ thực hiện tối đa trong vòng 3 phút",
                YourExpectedDepartureTimeNotUntil: "Thời gian khởi hành dự kiến của bạn là",
                CompleteFullySchedule: "Nếu bạn muốn hoàn thành đầy đủ lịch trình làm việc hôm nay, vui lòng bấm hết giờ lúc",
                PleaseSetStatus: "Mục Chương trình chăm sóc bạn muốn thêm đã được thêm vào danh sách",
                CarePlanItemAlreadyExisit: "The Care plan item you want to add is already added to the list",
                DurationGreaterThan0: "Thời lượng truy cập phải lớn hơn 0 phút!",
                MessageConfirmLogOut: "Bạn có chắc chắn muốn thoát?",
                Confirm: "Xác nhận",
                Cancel: "Hủy",
                PageAvailableOnlyOnline: "Trang này chỉ khả dụng khi trực tuyến.",
                SomethingWentWrong: "Đã xảy ra lỗi, vui lòng thử lại!",
                EnrolledSuccessfully: "Đăng ký thành công!",
                SuccessfullPictureUpload: "Tải ảnh thành công!",
                VisitMoved: "Chuyến viếng thăm đã chuyển hôm nay!",
                PatientConcernTooLong: "Ghi chú quá dài. Vui lòng duy trì tối đa 512 ký tự!",
                VisitHistoryOffline: "Lịch sử chuyến viếng thăm chỉ thể hiện khi được kết nối internet.",
                OnlyNetAccess: "Chỉ khả dụng khi có kết nối ineternet!",
                ErrorSavingSignature: "Xảy ra lỗi khi lưu chữ ký. Thử lại hoặc liên hệ Ankota",
                ErrorSavingWorkerSignature: "Xảy ra lỗi khi lưu chữ ký nhân viên. Thử lại hoặc liên hệ Ankota",
                ErrorSavingPatientSignature: "Xảy ra lỗi khi lưu chữ ký bệnh nhân. Thử lại hoặc liên hệ Ankota",
                CouldNotCreateFile: "Không thể tạo file",
                NoRecording: "Không ghi lại!",
                UploadedFile: "File tải lên thành công",
                MarkWhileOffline: "Bạn không thể đánh dấu một tin nhắn là đã đọc khi đang ngoại tuyến!",
                Offline: "Bạn đang ngoại tuyến",
                Syncing: "Đồng bộ…Vui lòng chờ",
                LoadingMessage: "Đang tải…Vui lòng chờ",
                Title: "Tiêu đề",
                Message: "Tin nhắn",
                Date: "Ngày",
                DateAndTime: "Ngày giờ",
                MarkAsRead: "Đánh dấu đã đọc",
                Call: "Gọi",
                Immediately: "Ngay tức thì",
                HourShort: "",
                MinShort: "",
                Actions: "Hành động",
                UnblockUser: "Mở khóa người dùng",
                Image: "Hình ảnh",
                Document: "Tài liệu",
                LoadingDocsWait: "Đang tải, vui lòng chờ",
                ProcessDocsWait: "Đang xử lý hồ sơ, vui lòng chờ",
                PleaseConnectToLogIn: "Vui lòng kết nối internet để đăng nhập!",
                AvailableShifsNoInternet: "Ca có sẵn chỉ có thể truy cập nếu có kết nối internet!",
                ShiftNotAvailable: "Ca không còn nữa.",
                ShiftAssignedToYou: "Văn phòng đã lên lịch cho bạn ca này. Nếu bạn không làm được, vui lòng liên hệ với văn phòng!",
                InvalidUserOrPass: "Tên đăng nhập và mật khẩu sai. Vui lòng thử lại",
                UnexpectedErrorContactSupport: "Đã xảy ra lỗi! Vui lòng liên hệ kỹ thuật!",
                FingerprintAuthError: "Đã xảy ra lỡi khi xác thực dấu vân tay",
                EnrollAgain: "Đã xảy ra sự cố, vui lòng đăng ký lại!",
                UsernameEnrollmentError: "Tên đăng nhập này chưa có trên hệ thống, vui lòng thử tên đăng nhập khác hoặc đăng nhập lại với mật khẩu!",
                BiometricAuthentication: "Vui lòng nhập tên đăng nhập để xác thực dấu vân tay.",
                InvalidCoordinates: "Tọa độ không hợp lệ",
                SigningInPleaseWait: "Đang đăng nhập, vui lòng chờ",
                PleaseWaitSearch: "Vui lòng đợi trong khi chúng tôi tìm kiếm các bài tập đang hoạt động của bạn.",
                SignIn: "Đăng nhập",
                UseBackup: "Sử dụng sao lưu",
                FingerprintAuthentication: "Xác Thực Dấu Vân Tay",
                PleaseEnrollYourProfile: "Vui lòng đăng ký hồ sơ của bạn",
                DoYouHave: "Vấn đề thân",
                Concerns: "đang quan tâm",
                HRNotifications: "Thông báo từ bộ phận nhân sự",
                NoNotifications: "Không có thông báo",
                Hi: "Xin chào",
                Expected: "Mong đợi",
                SelectLanguage: "Chọn ngôn ngữ…",
                ChangePassword: "Đổi mật khẩu",
                LoginErr: "Đăng nhập không hợp lệ. Vui lòng thử lại",
                About: "Thông Tin",
                Account: "Tài khoản",
                UploadDocumentOrPicture: "Tải lên tài liệu hoặc hình ảnh",
                Name: "Tên",
                PickUpCases: "CHỌN CASE",
                CaseOrderName: "Case số",
                TimeBetweenCases: "Thời gian giữa các Case:",
                TravelTime: "Thời gian di chuyển",
                Status: "Tình trạng",
                Language: "Ngôn ngữ",
                AssignToMe: "Chỉ định cho tôi",
                AcceptCase: "Chấp nhận Case",
                DeclineCase: "Từ chối Case",
                SeeDetails: "Xem chi tiết",
                ConsumerNoShow: "Không thể hiện khách hàng",
                ReturnCase: "Trả lại Case",
                LateCancellation: "Hủy Bị Chậm",
                YouArePreferred: "BẠN ĐƯỢC ƯU ĐÃI",
                NoCasesToShow: "Không có case nào ",
                NoAssignedPatients: "Bạn không có khách hàng được chỉ định!",
                ReportTasks: "Báo Cáo Nhiệm Vụ",
                MyRegularSchedule: "Lịch trình thường xuyên của tôi",
                BookingsPerWeek: "Booking Mỗi Tuần",
                Slot: "Chỗ",
                AddASlot: "Thêm chỗ",
                AddTimeoffConflict: "Thêm thời gian nghỉ/xung đột",
                OverrideSchedule: "Lịch trình bị trùng lắp",
                Type: "Kiểu",
                OverwriteEmployeeCalendar: "Thời khóa biểu nhân viên bị trùng lắp",
                BlockedUsers: "Người dùng bị khóa",
                Chat: "Chat",
                LoadMoreUsers: "Tải thêm người dùng",
                PasswordMustBe: "Mật khẩu phải có",
                PasswordMustBeAtLeast: "Mật khẩu ít nhất phải có",
                PasswordMustBeAtMost: "Mật khẩu tối đa phải có",
                PasswordMustContainAtLeast: "Mật khẩu phải chứa ít nhất",
                NumericCharacters: "các ký tự số",
                SpecialCharacters: "các ký tự đặc biệt",
                CharactersLong: "ký tự dài",
                PasswordRequirement: "Mật khẩu phải chứa ít nhất 3 trong số 4 ký tự là chữ hoa, chữ thường, con số và các ký tự đặc biệt ",
                CurrentPassword: "Mât khẩu hiện tại",
                NewPassword: "Mật khẩu mới",
                ReenterPassword: "Nhập lại mật khẩu mới",
                TypeMsg: "Nhập tin nhắn của bạn tại đây…",
                To: "đến",
                SentFileToYou: "Mới gửi file cho bạn, bạn có thể tải về",
                Here: "Tại đây",
                Hello: "Xin chào ",
                ClientView: "Chế độ xem khách hàng",
                ReportArrival: "Đồng hồ trong",
                ReportDeparture: "HẾT GIỜ",
                Logout: "Thoát",
                Completion: "Hoàn tất hôm nay",
                NoMatchedClients: "Thông tin khách hàng không khớp! Vui lòng liên lạc",
                ConfirmDeparture: "XÁC NHẬN GIỜ ĐI",
                ArrivalDate: "Ngày đến",
                ArrivalTime: "Thời gian đến",
                DepartureDate: "Ngày đi",
                DepartureTime: "Thời gian đi",
                VisitDocuments: "Tài liệu chuyến viếng thăm",
                Complete: "Hoàn thành",
                Incomplete: "Chưa hoàn thành",
                NotStarted: "Chưa bắt đầu",
                ProcessDocuments: "Xử Lý Tài Liệu",
                OnlyOnline: "Chỉ hoàn tất khi bạn đang trực tuyến",
                ConnectionOflline: "Không có kết nối internet",
                SaveIncomplete: "Lưu chưa hoàn tất",
                ResetToNew: "Reset để làm mới",
                PickerDisplay: "Bộ chọn ngày/ thời gian",
                ReportNoShow: "Không Thể Hiện Báo Cáo",
                ReportCancelVisit: "Báo cáo Hủy chuyến thăm",
                NotificationCenter: "TRUNG TÂM THÔNG BÁO",
                Visits: "Các Chuyến Viếng Thăm",
                Time: "Giờ",
                Client: "Thân Chủ",
                Location: "Địa Điểm",
                AcceptVisit: "Chấp Nhận Viếng Thăm",
                DeclineVisit: "Từ Chối Viếng Thăm",
                Messages: "Tin nhắn",
                Title2: "Tiêu đề",
                Delete: "Xóa",
                ViewDocsPatients: "Xem tài liệu của những bệnh nhân sau đây:",
                ViewDocuments: "Xem Tài Liệu",
                Documents: "Tài liệu",
                PayrollHistory: "LỊCH SỬ BẢNG LƯƠNG",
                WeeklyHours: "GIỜ LÀM VIỆC HÀNG TUẦN",
                NoPayrollsToShow: "Không thể hiện bảng lương",
                PayrollSummary: "TỔNG HỢP BẢNG LƯƠNG",
                WeeklySummary: "TÓM TẮT GIỜ LÀM VIỆC HÀNG TUẦN",
                GrossEarnings: "TỔNG THU NHẬP",
                GrossEarnings2: "Tổng thu nhập",
                TotalHourBreakdown: "Tổng số giờ phân tích",
                Regular: "Thường xuyên",
                Overtime: "Tăng ca",
                TotalHoursWorked: "Tổng số giờ làm việc",
                VisitTime: "Thời gian thăm quan",
                Adjustments: "Điều chỉnh",
                AdjustmentsReflect: "Các điều chỉnh phản ánh những thay đổi đối với các khoản thanh toán trước đó.",
                ExpectedPayment: "Thanh toán dự kiến ​​trước thuế",
                HoursWorked: "Số Giờ Làm Việc",
                NumberofDays: "Số ngày",
                NumberOfVisits: "Số Các Chuyến Viếng Thăm",
                VisitHistory: "Lịch Sử Viếng Thăm",
                Trips: "Các Chuyến Đi",
                TripOptionQuestion: "Bạn có hoàn thành việc vận chuyển không phải mục đích y tế trong chuyến viếng thăm này?",
                RefreshGPS: "Refresh GPS",
                ClockIn: "Không có giờ clock in",
                ClockOut: "Không có giờ clock out",
                CurrentArrival: "Đồng hồ trong thời gian",
                AcceptTime: "Đồng hồ trong",
                ReportItems: "MỤC BÁO CÁO",
                AddBreak: "Thêm ngắt",
                NA: "Không áp dụng",
                Set: "Cài đặt",
                NotSet: "Chưa cài đặt",
                AddAnotherItem: "Thêm Mục Khác",
                NothingToAdd: "Không có gì để bổ sung",
                AddItem: "Thêm Mục",
                NoItemsToDisplay: "Không Thể Hiện Mục",
                Next: "Kế tiếp",
                SelectVisitType: "Chọn Kiểu Chuyến Viếng Thăm",
                Settings: "CÀI ĐẶT",
                Availability: "Khả dụng",
                General: "Chung",
                Security: "An ninh",
                NameUploadPicturesDocs: "Tên, Tải lên ảnh/tài liệu",
                ConsenttoReceiveTexts: "Đồng ý nhận tin nhắn",
                ChangePasswordFingerprintFaceID: "Thay đổi mật khẩu, vân tay/Face ID",
                AddSlots: "Thêm khe",
                ToSetAdditionalSettings: "Để thiết lập thêm cài đặt , vui lòng đăng nhập bằng chính thông tin đăng nhập tại",
                Authentication: "XÁC THỰC",
                EnterSMSCode: "Nhập mã bạn nhận được qua SMS:",
                Back: "Trở lại",
                Code: "Mã",
                MyVisits: "CHUYẾN VIẾNG THĂM CỦA TÔI",
                Address: "Địa chỉ",
                CreatedByPhone: "Được tạo bằng điện thoại",
                ViewMoreDetails: "Xem Thêm Chi Tiết",
                NoShow: "Không Thể hiện",
                Tasks: "Nhiệm vụ",
                CancelVisit: "Hủy chuyến thăm",
                UploadDocs: "Tải Lên Tài Liệu",
                DocumentsAreLoading: "Tài liệu đang tải...",
                NoDocuments: "Không có tài liệu",
                Rework: "LÀM LẠI",
                OnHold: "HOÀN THÀNH VÀO HOLD THAM QUAN",
                PleaseSelectReason: "Vui lòng chọn một lý do!",
                PleaseSelectDocument: "Vui lòng chọn một tài liệu!",
                NoVisitsToShow: "Không thể hiện chuyến viếng thăm",
                UploadTimesheets: "TẢI TIMESHEETS",
                UploadDocuments: "Tải lên tài liệu",
                EnterAdditionalNotes: "Nhập thêm ghi chú  tại đây…",
                VisitDirections: "HƯỚNG DẪN ",
                DriveTime: "Giờ lái xe",
                PrecedingVisitEndTime: "Thời gian kết thúc viếng thăm",
                TimeBetweenVisits: "Thời gian giữa các chuyến viếng thăm",
                VisitAddress: "Địa chỉ viếng thăm",
                LiveDirections: "Hướng Dẫn Chỉ Đường \"Live\"",
                VisitDetails: "CHI TIẾT CHUYẾN VIẾNG THĂM",
                ClientName: "Tên Thân Chủ",
                ServiceName: "Tên Dịch Vụ",
                VisitDate: "Ngày làm việc",
                VisitStatus: "Tình Trạng Viếng Thăm",
                PrimaryPhone: "Số Điện Thoại Chính",
                SecondaryPhone: "Số Điện Thoại Phụ",
                GetDirections: "Nhận Hướng Dẫn Chỉ Đường",
                VisitNotes: "Ghi chú ngày làm việc",
                Instructions: "Hướng Dẫn",
                PleaseUseTheButton: "Vui lòng nhấn vào nút phía dưới để chụp. Thử bấm lại nếu hình ảnh chưa được rõ nét.",
                Keep: "Giữ",
                TakePicture: "Chụp",
                UploadOrTakePicture: "Tải lên hoặc chụp ảnh",
                RetakePicture: "Chụp lại",
                AddPhoto2: "THÊM ẢNH",
                VisitHistoryCaps: "LỊCH SỬ VIẾNG THĂM",
                Completed: "Hoàn thành",
                WorkerName: "Tên Nhân Viên",
                Notes: "Ghi chú",
                ResponseNotes: "Ghi chú phản hồi",
                AddNotes: "Thêm ghi chú",
                MoveVisitToday: "Thêm chuyến thăm viếng hôm nay",
                ShowMore: "…Thông tin nhiều hơn",
                VisitType: "Loại Viếng Thăm",
                PleaseAsk: "Thân ",
                ToConfirmThatTheyReceived: "để xác nhận họ đã nhận",
                ServiceToday: "dịch vụ hôm nay",
                Yes: "Có",
                No: "Không",
                ToConfirmThatTheVisit: "để xác nhận thời gian viếng thăm là từ",
                ReportDeparture2: "HẾT GIỜ",
                ToSignHere: "ký tên tại đây",
                VoiceSignature: "Ký bằng giọng nói",
                PleaseSignHere: "Chăm sóc viên ký tên tại đây",
                PleaseAskYour: "Vui lòng hỏi",
                ErrandMiles: "Errand Miles",
                AddPhoto: "Thêm hình ảnh",
                Clear: "Xóa",
                Accept: "Chấp nhận",
                NotAvailable: "Không khả dụng",
                VisitConfirmation: "Xác Nhận Chuyến Viếng Thăm",
                RequestForConfirmation: "Vui lòng nhấn \"Start Recording\" và nói tên của bạn cùng với ngày làm việc để xác nhận bạn đã được cung cấp dịch vụ hôm nay",
                PlayRecording: "Bật bản ghi âm",
                StopPlayRecording: "Dừng ghi thu âm",
                StartRecording: "Bắt đầu ghi âm",
                StopRecording: "Dừng ghi âm",
                MonthView: "Xem Tháng",
                WeekView: "Xem Ngày",
                ArrSuccess: "Giờ đến của bạn đã được ghi nhận thành công tại",
                ArrOffline: "Giờ đến của bạn đã được ghi âm, nhưng bạn đang ngoại tuyến. Văn phòng của bạn sẽ nhận được cảnh báo trễ",
                ArrSuccessDeparture: "Thời gian đi dự kiến của bạn là",
                CurrentVisit: "Thời gian làm việc của bạn đến thời điểm hiện tại là",
                Hours: "Giờ",
                Minutes: "Phút",
                ClockOutButton: "Bấm Hết Giờ",
                ConfirmLocation: "Chúng tôi đang cố gắng xác nhận vị trí của bạn. Chúng tôi sẽ tiến hành trong tối đa 3 phút",
                ViewTasks: "Xem Nhiệm Vụ",
                CurrentDeparture: "Thời gian đi hiện tại",
                Duration: "Thời lượng",
                Duration2: "Thời lượng",
                ConfirmClockOut: "Bạn chắc chắn có muốn bấm hết giờ",
                Only3OnHoldVisitsWillShowAtaTime: "Chỉ có 3 lượt thăm Đang giữ ở một thời điểm.",
                Submit: "Submit",
                DepSuccess: "Giờ đi của bạn đã được ghi nhận thành công",
                VisitSuccesfullyClosed: "Lượt truy cập đã được đóng thành công",
                DepOffline: "Giờ đi của bạn đã được ghi âm, nhưng bạn đang ngoại tuyến. Văn phòng của bạn sẽ nhận được cảnh báo trễ",
                PleaseOpenYourAnkotaApplater: " Vui lòng mở ứng dụng Ankota của bạn vào cuối ngày hôm nay khi tín hiệu tốt hơn (khi bạn TRỰC TUYẾN) để dữ liệu chuyến thăm của bạn có thể được gửi đến văn phòng.",
                Home: "Trang chủ",
                Save: "Lưu",
                AssignedPatients: "KHÁCH HÀNG ĐƯỢC ĐĂNG KÝ",
                AvailableShifts: "Ca có sẵn",
                ReportMissedVisit: "Báo cáo Chuyến thăm bị Bỏ lỡ",
                ReportVisit: "Báo cáo chuyến thăms",
                AddMissedVisitReason: "Chọn lý do ",
                CorrectDatesTime: "Sửa ngày/giờ ở trên bằng cách nhấp vào chúng và cuộn đến tùy chọn chính xác.",
                ContigousVisitBlock: "Chuyến thăm này là một phần của khối chuyến thăm. Vui lòng nhập thời gian bắt đầu thực tế và thời gian kết thúc cuối cùng của bạn cho khối này.",
                AddWorkerDocument: "Chọn tài liệu ",
                ReportExpensesTitle: "Báo cáo chi phí",
                ReportExpensesQuestion: "Bạn có chi phí để báo cáo không?",
                Amount: "Số tiền",
                Description: "Sự miêu tả",
                Company: "Công ty",
                NotesAndInfo: "Ghi chú và Thông tin",
                InfoOnlyItems: "Thông tin Chỉ các mục",
                NoNotesForVisit: "Không có ghi chú cho chuyến thăm này!",
                NoInfoForVisit: "Không có mục thông tin về chuyến thăm này!",
                ContiguousVisits: "Lượt truy cập liền kề",
                Details: "Chi tiết",
                Signature: "Chữ ký",
                GoToSign: "Hiển thị pad",
                History: "Môn lịch sử",
                NoNotesInHistory: "Không có ghi chú nào trong lịch sử!",
                CarePlanHistoryNotAvailableOffline: "Lịch sử mục của kế hoạch chăm sóc không khả dụng ở chế độ ngoại tuyến!",
                TheVisitIsAlreadySigned: "Chuyến thăm đã được ký kết. Bạn có thể tiếp tục mà không cần chữ ký.",
                OfflineUptimeWarning: "Thiết bị của bạn có thể đã được khởi động lại kể từ lần đăng nhập trực tuyến cuối cùng của bạn. Nếu có thể, vui lòng đăng nhập trực tuyến để cập nhật thời gian của bạn.",
                Phone: "Điện thoại",
                Email: "E-mail",
                OfflineModeWarning: "Ứng dụng của bạn đang gặp sự cố do kết nối kém và sẽ lấy dữ liệu của bạn ngoại tuyến. Văn phòng sẽ được cập nhật ngay sau khi kết nối mạng của bạn được cải thiện.",
                OnlineModeWarning: "Ứng dụng của bạn được quản lý để kết nối lại với máy chủ. Dữ liệu chuyến thăm của bạn bây giờ sẽ được đồng bộ hóa và xử lý trực tuyến.",
                Refresh: "Làm mới",
                ResetMapsApp: "Đặt lại ứng dụng Bản đồ",
                DefaultMapsAppWarning: "Ứng dụng bản đồ mặc định đã được đặt lại. Lần tới khi khởi chạy trình điều hướng, bạn sẽ có thể chọn một ứng dụng mới.",
                UseBingInstead: "Sử dụng Bản đồ Bing",
                NoLocationWarning: "Không thể nắm bắt vị trí của bạn. Đảm bảo rằng GPS của bạn đã được bật, nếu không ứng dụng bản đồ bạn đã chọn có thể không xác định được vị trí của bạn. Bạn có muốn tiếp tục không? Bạn có thể phải nhập vị trí hiện tại của mình theo cách thủ công!",
                NoMapsWarning: "Không có ứng dụng bản đồ nào được tìm thấy trên thiết bị của bạn. Thay vào đó, bản đồ Bing sẽ được mở.",
                HoursLimitWarning: "</br><b><p style='color:Red'>Thời lượng truy cập> 16 giờ. Bạn có chắc không?</p></b>",
                SlotChangeWarning: "Bạn đã lên lịch đến thăm trong khoảng thời gian này. Vui lòng liên hệ với văn phòng để yêu cầu thay đổi tình trạng còn trống của bạn.",
                WorkerPhone: "Điện thoại công nhân",
                PleaseTurnOnGPS: "GPS của bạn bị tắt. Vui lòng cho phép ứng dụng nắm bắt vị trí của bạn trước khi tiếp tục. Bạn có thể cần nhấn nút 'Làm mới GPS' sau khi cho phép ghi lại vị trí của mình.",
                NoGPSOnVisit: "Vị trí GPS không thể được phát hiện kịp thời. Bạn có muốn tiếp tục mà không có tọa độ?",
                NoGPSPermission: "Bạn không thể sử dụng ứng dụng này vì bạn chưa bật tính năng chia sẻ vị trí cho ứng dụng. Bạn có thể cập nhật cài đặt ứng dụng của mình hoặc xóa và cài đặt lại ứng dụng. Nếu bạn cài đặt lại, khi bạn đăng nhập, nó sẽ hỏi ứng dụng có thể sử dụng vị trí của bạn không. Bạn phải nói có để tiếp tục.",
                SyncVisitWarning: "Không thể đồng bộ hóa lượt truy cập với máy chủ. Vui lòng thử lại sau!",
                CarePlanItemHistoryDisplayMode: "Chế độ hiển thị lịch sử kế hoạch chăm sóc",
                Individually: "Cá nhân",
                AllAtOnce: "Tất cả trong một",
                GpsTimeLeft: "Ứng dụng đang cố gắng lấy tọa độ GPS. Trong trường hợp không thành công, tính năng nhập / xuất đồng hồ sẽ được cung cấp tối đa ",
                Seconds: "giây",
                BlockUser: "Chặn người dùng",
                ServicePeriod: "Chu kỳ dịch vụ",
                ServicePeriodStartDate: "Ngày bắt đầu thời hạn dịch vụ",
                UseBy: "Sử dụng bởi",
                TotalTime: "Tổng thời gian",
                UsedTime: "Thời gian đã sử dụng",
                RemainingTime: "Thời gian còn lại",
                AuthInfo: "Auth Info",
                YouMayWorkUpTo: "<br/><br/>Bạn có thể làm việc đến",
                NoAuthorizedUnitsLeftWarning: "Bạn không thể bắt đầu một cuộc thăm khám mới cho bệnh nhân và loại thăm khám này vì chỉ còn 0 phút được phép cho cuộc thăm khám!",
            },
            "ko": { //Korean
                Nothing: "",
                Monday: "월요일",
                Tuesday: "화요일",
                Wednesday: "수요일",
                Thursday: "목요일",
                Friday: "금요일",
                Saturday: "토요일",
                Sunday: "일요일",
                ViewMap: "지도보기",
                NoteTooLong: "메모가 너무 깁니다. 최대 512자를 유지 하십시오!",
                NoteTooLong4000characters: "메모가 너무 깁니다. 최대 4000자를 유지 하십시오!",
                OfflinePassForgot: "지금 연결 되어 있지 않습니다. 비밀번호를 재설정 하려면 네트워크에 연결하세요.",
                ConfirmPassReset: "비밀번호를 재설정하시겠습니까?",
                ConfirmShiftResponse: "이 공개 교대 근무에 응답하시겠습니까?",
                PatientName: "</br></br>환자 이름: ",
                EmptyUsername: "아이디 / 이메일을 작성했는지 확인하십시오!",
                EmptyError: "등록 된 전화 번호 나 이메일이 없습니다. 사무실에 연락하여 비밀번호를 재설정 하도록 하십시오.",
                PassResetSuccess: "비밀번호 재설정 이메일이 귀하의 이메일로 전송 되었습니다.",
                PhoneError: "비밀번호 재설정 문자가 전화 번호로 전송되었습니다.",
                NewMessages: "새 메세지가 있습니다.",
                ReadNow: "지금 읽기",
                ReadLater: "나중에 읽기",
                Ok: "확인",
                Close: "닫기",
                DeleteWorking: "근무 시간을 삭제 하시겠습니까?",
                DeleteAdjustment: "조정을 삭제 하시겠습니까 <b>",
                InitiatingCall: "통화 시작 중 ...",
                CallFailed: "통화 실패",
                CallCanceled: "통화가 취소 되었습니다.",
                OngoingCall: "진행중인 통화 ...",
                CallEnded: "통화 종료",
                IncomingCall: "수신 전화",
                ConnectingToCall: "연결 중 ...",
                Rejected: "거부 됨 …",
                RejectionFailed: "거부 실패 ...",
                ChangePasswordOfflineWarning: "인터넷이 연결되어 있을 때만 비밀번호를 변경할 수 있습니다!",
                PassBlank: "재 입력 비밀번호가 비어 있거나 일치하지 않습니다!",
                PleaseConnect: "로그인 하려면 인터넷에 연결하세요!",
                InvalidPassword: "현재 비밀번호가 유효하지 않습니다. 다시 시도하십시오!",
                AcceptedChars: "허용되는 문자는 문자, 숫자 및 다음 기호입니다. ','! '.",
                NewInvalidPass: "새 비밀번호가 유효하지 않습니다. 위의 요구 사항을 확인하십시오.",
                InvalidCurrentPassword: "현재 비밀번호가 잘못 되었습니다!",
                PasswordMustBeDifferent: "새 비밀번호는 이전의 3개 사용한 적 있는 비밀번호와 달러야 합니다. 다른 새 비밀번호를 시도 하십시오.",
                PasswordsDoNotMatch: "비밀번호가 일치하지 않습니다!",
                PassBlockedWord1: "새 비밀번호에 차단 된 단어가 있습니다.",
                PassBlockedWord2: "비밀번호에는 차단 된 단어가 포함되지 않아야 합니다.",
                PasswordResetSuccess: "비밀번호를 성공적으로 변경했습니다. 로그인 해주세요.",
                AgreeToReceiveInformationalMessages: "내 전화번호로 정보 메시지/알림을 받는 데 동의합니다 ",
                PasswordResetNotSuccessful: "비밀번호를 변경할 수 없습니다. 다시 시도해 주세요.",
                Enable: "활성화",
                Disable: "비활성화",
                UnableToSaveCode: "코드를 저장할 수 없습니다. 지원팀에 문의하세요!",
                InvalidCode: "유효하지 않은 코드",
                ConfirmingLocation: "위치 확인-잠시만 기다려주십시오!",
                GPSNotCaptured: "GPS 좌표가 캡처되지 않았습니다. GPS 새로 고침을 하여 다시 시도하십시오!",
                GPSNotCaptured2: "GPS 좌표가 캡처되지 않았습니다. '시간 수락'을 눌러 방문을 시작할 수 있지만 앱을 최대 3 분 동안 열어 두어 계속 위치를 알아낼 수 있도록 하십시오.",
                GPSNotCaptured3: "GPS 좌표가 캡처되지 않았습니다. 다시 시도하십시오!",
                TooEarlyToReport: "당신은 너무 일찍 도착합니다. 당신의 예정된 시간에 도착하세요.",
                TooLateToReport: "시간을 맞추기에는 너무 늦었습니다.",
                LocationNotCloseEnough: "귀하의 위치가 고객의 집과 충분히 가깝지 않습니다. 클라이언트의 집에서 시계를 확인하고 새로 고침 GPS를 사용하여 다시 시도하십시오!",
                YourArrivalTimeIs: "귀하의 체크인 시간은",
                SomeoneElseIsAlreadyClocked: "다른 사람이 이미 로그인되어 있습니다. 로그인할 수 있도록 시간을 종료하도록 요청하세요.",
                YourExpectedDeparture: " 예상 출발 시간은",
                ClientDocumentsReady: " 귀하의 도착을 확인함으로써 귀하는 고객 문서를 읽었음을 인정하는 것입니다.",
                OpenShiftDate: "</br></br> 오픈 시프트 날짜: ",
                OpenShiftTime: "</br></br>오픈 시프트 시간: ",
                WeStillTryingConfirmLocation: " 귀하의 위치를 ​​확인하는 중입니다. 최대 3 분 동안 계속 시도합니다.",
                YourExpectedDepartureTimeNotUntil: "예상 출발 시간은 ",
                CompleteFullySchedule: "예정된 스케줄을 완료 하려면 다음과 같은 시간 후 clock out을 해주십시오",
                PleaseSetStatus: "모든 항목에 상태를 설정 하십시오!",
                CarePlanItemAlreadyExisit: "The Care plan item you want to add is already added to the list",
                MessageConfirmLogOut: "로그아웃 하시겠습니까?",
                Confirm: "확인",
                Cancel: "취소",
                PageAvailableOnlyOnline: "이 페이지는 온라인 상태에서만 사용할 수 있습니다.",
                SomethingWentWrong: "문제가 발생했습니다. 다시 시도하십시오!",
                EnrolledSuccessfully: "등록 되었습니다!",
                SuccessfullPictureUpload: "사진을 성공적으로 업로드 했습니다.",
                VisitMoved: "오늘 방문이 이동 했습니다!",
                PatientConcernTooLong: "멤버의 노트가 너무 깁니다. 최대 512 자를 유지 해주십시오!",
                VisitHistoryOffline: "방문 기록은 인터넷이 연결된 경우에만 사용할 수 있습니다.",
                OnlyNetAccess: "인터넷 접속이있을 때만 가능합니다!",
                ErrorSavingSignature: "서명 저장하는 중에 오류가 발생했습니다. 다시 시도하거나 Ankota에 문의하십시오.",
                ErrorSavingWorkerSignature: "직원서명을 저장하는 중에 오류가 발생했습니다. 다시 시도하거나 Ankota에 문의하십시오.",
                ErrorSavingPatientSignature: "멤버 서명을 저장하는 중에 오류가 발생했습니다. 다시 시도하거나 Ankota에 문의하십시오.",
                CouldNotCreateFile: "파일을 생성 할 수 없습니다",
                NoRecording: "녹음이 없습니다!",
                UploadedFile: "성공적으로 업로드 된 파일.",
                MarkWhileOffline: "오프라인 상태에서는 메세지를 읽은 상태로 표시 할 수 없습니다!,",
                Offline: "지금 접속이 안되어 있습니다",
                Syncing: "동기화 중 ... 잠시만 기다려 주세요",
                LoadingMessage: "로딩 중... 잠시만 기다려 주세요",
                Title: "제목",
                Message: "메세지",
                Date: "날짜",
                DateAndTime: "날짜 시간",
                MarkAsRead: "읽은 상태로 표시",
                Call: "통화",
                Immediately: "바로",
                HourShort: "시간",
                MinShort: "분",
                Actions: "작용",
                UnblockUser: "사용자 차단 해제,",
                Image: "이미지",
                Document: "문서",
                LoadingDocsWait: "문서를 로딩 하는 중 입니다. 잠시 기다려 주십시오.",
                ProcessDocsWait: "문서를 진행 하십시오. 잠시 기다려 주십시오.",
                PleaseConnectToLogIn: "로그인 하려면 인터넷에 연결 하십시오!",
                AvailableShifsNoInternet: "사용 가능한 교대는 인터넷 연결이 있는 경우에만 액세스할 수 있습니다!",
                ShiftNotAvailable: "교대는 더 이상 사용할 수 없습니다.",
                ShiftAssignedToYou: "사무실에서 이 교대 근무를 예약했습니다. 어려우시면 사무실로 연락주세요!",
                InvalidUserOrPass: "사용자 이름 또는 비밀번호가 잘못 되었습니다. 다시 시도하십시오.",
                UnexpectedErrorContactSupport: "예상치 못한 에러! 지원팀에 문의하세요!",
                FingerprintAuthError: "지문 인증을 처리하는 동안 오류가 발생했습니다.",
                EnrollAgain: "문제가 발생했습니다. 다시 등록 하십시오!",
                UsernameEnrollmentError: "이 아이디는 등록되어 있지 않습니다. 다른 아이디로 시도하거나 비밀번호로 로그인 하십시오!",
                BiometricAuthentication: "생체 인증을 위한 아이디를 입력하십시오.",
                InvalidCoordinates: "잘못된 좌표",
                SigningInPleaseWait: "로그인 중 입니다. 잠시 기다려주세요",
                SignIn: "로그인",
                UseBackup: "백업 사용",
                FingerprintAuthentication: "지문 인증",
                PleaseEnrollYourProfile: "프로필을 등록하십시오",
                DoYouHave: "멤버에 대한 걱정이 있으시면  입력해주세요. ",
                Concerns: "우려",
                HRNotifications: "HR 알림",
                NoNotifications: "알림이 없습니다.",
                Hi: "안녕하세요",
                Expected: "예상함",
                SelectLanguage: "언어 선택 ...",
                TitleApp: "홈케어",
                Subtitle: "간병인 포털",
                Username: "아이디",
                Password: "비밀번호 ",
                UserError: "유효한 아이디를 입력 하세요.",
                PwError: "비밀번호는 6 자 이상이 필요합니다.",
                Login: "로그인",
                PwForgot: "비밀번호를 잊으셨나요",
                ChangePassword: "비밀번호 변경",
                LoginErr: "로그인이 잘못 되었습니다. 다시 시도하십시오.",
                About: "약",
                Version: "버젼",
                Account: "계정",
                UploadDocumentOrPicture: "문서 또는 사진 업로드",
                Name: "이름",
                PickUpCases: "픽업 케이스",
                CaseOrderName: "케이스#:",
                TimeBetweenCases: "케이스 사이의 시간 :",
                TravelTime: "왕래 시간",
                Status: "현황",
                Language: "언어",
                AssignToMe: "나에게 지정",
                AcceptCase: "케이스 수락",
                DeclineCase: "케이스 거부",
                SeeDetails: "자세히 보기",
                ConsumerNoShow: "멤버가 나타나지 않음 ",
                ReturnCase: "케이스 리턴",
                LateCancellation: "늦은 취소",
                YouArePreferred: "귀하를 선호 합니다.",
                NoCasesToShow: "표시 할 케이스가 없습니다.",
                AssignedPatients: "할당된 클라이언트",
                AvailableShifts: "사용 가능한 교대",
                NoAssignedPatients: "할당된 클라이언트가 없습니다!",
                ReportTasks: "일 보고",
                MyRegularSchedule: "나의 정규 스케줄",
                BookingsPerWeek: "주 당 예약",
                Slot: "시간대(slot)",
                AddASlot: "시간대(slot) 추가",
                AddTimeoffConflict: "휴가/갈등 추가",
                OverrideSchedule: "일정 무시",
                Type: "유형",
                OverwriteEmployeeCalendar: "직원 달력 덮어 쓰기",
                BlockedUsers: "차단 된 사용자",
                Chat: "채팅",
                LoadMoreUsers: "더 많은 사용자 로드",
                PasswordMustBe: "비밀번호는",
                PasswordMustBeAtLeast: "비밀번호는 최소한",
                PasswordMustBeAtMost: "비밀번호는 최대 이하 여야합니다.",
                PasswordMustContainAtLeast: "비밀번호에는 최소한",
                NumericCharacters: "숫자",
                SpecialCharacters: "특수 문자",
                CharactersLong: "비밀번호 길이 ",
                PasswordRequirement: "비밀번호는 대문자,소문자, 특수, 숫자 4 가지 유형 중 3 가지를 포함해야합니다.",
                CurrentPassword: "현재 비밀번호",
                NewPassword: "새 비밀번호",
                ReenterPassword: "새 비밀번호 다시 입력",
                TypeMsg: "메세지를 여기에 입력하세요...",
                To: "여기",
                SentFileToYou: " 님이 파일을 보냈습니다. 여기서 다운로드 할 수 있습니다.",
                Here: "여기",
                Hello: "안녕 하세요",
                ClientView: "멤버 보기",
                ReportArrival: "시계 입력",
                ReportDeparture: "클록 아웃",
                Logout: "로그 아웃",
                Completion: "오늘 완료",
                NoMatchedClients: "일치하는 멤버가 없습니다! 연락 주세요",
                ConfirmDeparture: "출발 확인",
                ArrivalDate: "체크인 날짜",
                ArrivalTime: "체크인 시간",
                DepartureDate: "체크아웃 날짜",
                DepartureTime: "체크아웃 시간",
                VisitDocuments: "방문 문서",
                Complete: "완료",
                Incomplete: "미 완료",
                NotStarted: "시작되지 않음",
                ProcessDocuments: "문서 진행",
                OnlyOnline: " 온라인으로 만 가능",
                ConnectionOflline: "인터넷 연결이 되지 않은 상태입니다",
                SaveIncomplete: "미 완료 저장",
                ResetToNew: "새로 재설정",
                PickerDisplay: "날짜 / 숫자 시간 선택기",
                NewAppVersionAvailable: "새로운 애플리케이션 버전을 사용할 수 있습니다. 업데이트 하십시오!",
                FaceID: "FaceID",
                Fingerprint: "지문",
                ReportNoShow: "노쇼 신고",
                ReportCancelVisit: "신고 취소 방문",
                NotificationCenter: "알림 센터",
                Visits: "방문",
                Time: "시간",
                Client: "멤버",
                Location: "위치",
                AcceptVisit: "방문 수락",
                DeclineVisit: "방문 거부",
                Messages: "메세지",
                Title2: "제목",
                Delete: "지우기",
                ViewDocsPatients: "다음 멤버에 대한 문서보기 :",
                ViewDocuments: "문서보기",
                Documents: "문서",
                PayrollHistory: "급여 내역",
                WeeklyHours: "주간 근무 시간",
                NoPayrollsToShow: "표시 할 급여가 없습니다.",
                PayrollSummary: "급여 요약",
                WeeklySummary: "주간 근무 시간 요약",
                GrossEarnings: "총 수익",
                GrossEarnings2: "총 수익",
                TotalHourBreakdown: "총 시간 내역",
                Regular: "정기적인",
                Overtime: "시간 외에",
                TotalHoursWorked: "총 근무 시간",
                VisitTime: "방문 시간",
                Adjustments: "조정",
                AdjustmentsReflect: "조정은 이전 지불에 대한 변경을 반영 합니다.",
                ExpectedPayment: "세금 전 예상 지불",
                HoursWorked: "근무 시간",
                NumberofDays: "일 수",
                NumberOfVisits: "방문 수",
                VisitHistory: "방문 기록",
                Trips: "이동 ",
                TripOptionQuestion: "이번 방문에서 비 응급 차량을 완료 했습니까?",
                RefreshGPS: "GPS 새로고침",
                ClockIn: "Clock in 시간 없음",
                ClockOut: "Clock out 시간 없음",
                CurrentArrival: "클럭 인 시간",
                AcceptTime: "클럭 인",
                ReportItems: "항목 보고",
                AddBreak: "휴식 추가",
                NA: "해당 없음",
                Set: "선택 ",
                NotSet: "미선택 ",
                AddAnotherItem: "다른 항목 추가",
                NothingToAdd: "추가 할 내용 없음",
                AddItem: "아이템 추가",
                NoItemsToDisplay: "표시 할 항목이 없습니다.",
                Next: "다음",
                SelectVisitType: "방문 유형 선택",
                Settings: "설정",
                Availability: "가용성",
                General: "일반",
                Security: "보안",
                NameUploadPicturesDocs: "이름, 사진/문서 업로드",
                ConsenttoReceiveTexts: "문자 수신 동의",
                ChangePasswordFingerprintFaceID: "비밀번호 변경, 지문/Face ID",
                AddSlots: "슬롯 추가",
                ToSetAdditionalSettings: "추가 설정을 지정하려면 다음 위치에서 동일한 자격 증명을 사용하여 로그인 하십시오.",
                Authentication: "입증",
                EnterSMSCode: "문자를 통해 받은 코드를 입력 하세요.",
                Back: "뒤로",
                Code: "코드",
                MyVisits: "나의 스케줄 ",
                Address: "주소",
                CreatedByPhone: "전화로 생성",
                ViewMoreDetails: "자세히 보기",
                NoShow: "더 쇼 없다",
                Tasks: "케어플랜",
                CancelVisit: "방문 취소",
                UploadDocs: "문서 업로드",
                DocumentsAreLoading: "문서를 로딩 중입니다...",
                NoDocuments: "문서 없음",
                Rework: "재 작업",
                NoVisitsToShow: "표시 할 방문 없음",
                UploadTimesheets: "타임 시트 업로드",
                UploadDocuments: "문서 업로드",
                EnterAdditionalNotes: "여기에 추가 메모를 입력 하십시오 ...",
                VisitDirections: "방문 경로",
                DriveTime: "운전 시간",
                PrecedingVisitEndTime: "이전 방문 종료 시간",
                TimeBetweenVisits: "방문 사이의 시간",
                VisitAddress: "방문 주소",
                LiveDirections: "라이브로 길 찾기",
                VisitDetails: "방문 세부 정보",
                ClientName: "멤버 이름",
                ServiceName: "서비스 이름",
                VisitDate: "방문 날짜",
                VisitStatus: "방문 현황",
                PrimaryPhone: "기본 전화",
                SecondaryPhone: "보조 전화",
                GetDirections: "길 찾기",
                VisitNotes: "방문 노트",
                Instructions: "지침",
                PleaseUseTheButton: "타임시트 사진을 찍으려면 하단의 버튼을 사용하십시오. 사진이 선명하지 않은 경우 재시도 버튼을 사용하십시오.",
                Keep: "유지",
                TakePicture: "사진 찍기",
                UploadOrTakePicture: "업로드 또는 사진 촬영",
                RetakePicture: "사진 다시 찍기",
                AddPhoto2: "사진 추가",
                VisitHistoryCaps: "방문 기록",
                Completed: "완료",
                WorkerName: "간병인 이름",
                Notes: "메모",
                ResponseNotes: "응답 노트",
                AddNotes: "메모 추가",
                MoveVisitToday: "오늘 방문 이동",
                ShowMore: "... 더 보기",
                VisitType: "방문 유형",
                PleaseAsk: "오늘 서비스를 받았는지 확인 해주세요 ",
                ToConfirmThatTheyReceived: "그들이받은 것을 고백하기 위해",
                ServiceToday: "오늘 서비스",
                Yes: "예",
                No: "아니요",
                ToConfirmThatTheVisit: "방문 시간을 확인 해주세요.",
                ReportDeparture2: "클록 아웃",
                ToSignHere: "여기에 서명 하려면",
                VoiceSignature: "음성 서명",
                PleaseSignHere: "여기에 싸인 해주세요",
                PleaseAskYour: "귀하의",
                ErrandMiles: "심부름 마일",
                AddPhoto: "사진 추가",
                Clear: "해제",
                Accept: "수락",
                NotAvailable: "사용 할 수 없습니다",
                VisitConfirmation: "방문 확인",
                RequestForConfirmation: "녹화 시작을 누른 후 이름과 오늘 날짜를 말하여 오늘 서비스를 받았음을 확인 하십시오.",
                PlayRecording: "녹음 재생",
                StopPlayRecording: "녹음 재생 중지",
                StartRecording: "녹음 시작",
                StopRecording: "녹음 중지",
                MonthView: "월별보기",
                WeekView: "주간보기",
                ArrSuccess: "체크인 보고가 기록 되었습니다.",
                ArrOffline: "체크인이 기록 되었지만 오프라인 상태입니다. 회사에서 늦었다는 알림을 받을 수 있다는 점 고려 해주십시오.",
                ArrSuccessDeparture: "체크아웃보고 시간은 ",
                CurrentVisit: "현재 방문 시간",
                Hours: "시간",
                Minutes: "분",
                ClockOutButton: "클록 아웃",
                ConfirmLocation: "귀하의 위치를 ​​확인하는 중 입니다. 최대 3 분 동안 계속 시도합니다.",
                ViewTasks: "테스크 보기",
                CurrentDeparture: "현재 체크아웃 시간",
                Duration: "소요시간",
                Duration2: "소요시간",
                ConfirmClockOut: "체크아웃을 하시겠습니까?",
                Only3OnHoldVisitsWillShowAtaTime: "한 번에 최대 3 개의 대기중인 방문만 표시됩니다.",
                Submit: "제출",
                DepSuccess: "체크아웃이 다음과 같은 시간에 성공적으로 기록되었습니다.",
                VisitSuccesfullyClosed: "방문이 성공적으로 종료되었습니다",
                DepOffline: "체크아웃 기록 되었지만 오프라인 상태입니다. 회사에서 늦었다는 알림을 받을 수 있다는 점 고려 해주십시오.",
                PleaseOpenYourAnkotaApplater: " 오늘 나중에 신호가 더 좋아지면(온라인 상태일 때) Ankota 앱을 열어 방문 데이터를 사무실로 보내주세요.",
                Home: "홈 화면",
                Save: "저장",
                ReportMissedVisit: "놓친 방문 신고",
                ReportVisit: "방문 신고",
                AddMissedVisitReason: "방문을 놓친 이유 선택 ",
                CorrectDatesTime: "위의 날짜/시간을 클릭하고 올바른 옵션으로 스크롤하여 수정하세요.",
                ContigousVisitBlock: "이 방문은 방문 블록의 일부였습니다. 이 블록에 대한 실제 시작 시간과 최종 퇴근 시간을 입력하세요.",
                AddWorkerDocument: "문서 선택    ",
                ReportExpensesTitle: "비용보고",
                ReportExpensesQuestion: "보고 할 비용이 있습니까?",
                Amount: "양",
                Description: "기술",
                Company: "회사",
                YourVisitDurationIs: "</br></br>방문 시간은 ",
                YourDepartureTimeIs: "</br></br>출발 시간은 ",
                PleaseSelectReason: "理由を選んでください！",
                PleaseSelectDocument: "文書を選択してください!",
                OnHold: "保留中の訪問を完了する",
                DurationGreaterThan0: "방문 시간은 0 분 이상이어야합니다!",
                PleaseWaitSearch: "활성 과제를 검색하는 동안 잠시 기다려 주십시오.",
                NotesAndInfo: "참고 및 정보",
                InfoOnlyItems: "정보 전용 항목",
                NoNotesForVisit: "이 방문에 대한 메모가 없습니다!",
                NoInfoForVisit: "이 방문에 대한 정보 항목이 없습니다!",
                ContiguousVisits: "연속 방문",
                Details: "세부",
                Signature: "서명",
                GoToSign: "패드 표시",
                History: "역사",
                NoNotesInHistory: "기록에 메모가 없습니다!",
                CarePlanHistoryNotAvailableOffline: "케어플랜 항목 내역은 오프라인 모드에서 사용할 수 없습니다!",
                TheVisitIsAlreadySigned: "방문은 이미 서명되었습니다. 서명 없이 계속할 수 있습니다.",
                OfflineUptimeWarning: "마지막 온라인 로그인 이후 장치가 다시 시작되었을 수 있습니다. 가능하면 온라인으로 로그인하여 시간을 업데이트하십시오.",
                Phone: "핸드폰",
                Email: "이메일",
                OfflineModeWarning: "연결 불량으로 인해 애플리케이션에 문제가 발생했으며 데이터를 오프라인으로 캡처합니다. 네트워크 연결이 개선되는 대로 사무실이 업데이트됩니다.",
                OnlineModeWarning: "귀하의 애플리케이션이 서버에 다시 연결하는 데 성공했습니다. 이제 방문 데이터가 온라인으로 동기화되고 처리됩니다.",
                Refresh: "새로 고치다",
                ResetMapsApp: "지도 앱 재설정",
                DefaultMapsAppWarning: "기본 지도 앱이 재설정되었습니다. 다음에 네비게이터를 시작할 때 새 응용 프로그램을 선택할 수 있습니다.",
                UseBingInstead: "Bing 지도 사용",
                NoLocationWarning: "위치를 캡처할 수 없습니다. GPS가 켜져 있는지 확인하십시오. 그렇지 않으면 선택한 지도 응용 프로그램이 위치를 찾지 못할 수 있습니다. 그래도 계속하시겠습니까? 현재 위치를 수동으로 입력해야 할 수도 있습니다!",
                NoMapsWarning: "장치에서 지도 응용 프로그램을 찾을 수 없습니다. 대신 Bing 지도가 열립니다.",
                HoursLimitWarning: "</br><b><p style='color:Red'>방문 시간 > 16시간. 확실합니까?</p></b>",
                SlotChangeWarning: "이 시간대에 방문을 예약했습니다. 사무실에 연락하여 가용성 변경을 요청하십시오.",
                WorkerPhone: "작업자 전화",
                PleaseTurnOnGPS: "GPS가 꺼져 있습니다. 계속하기 전에 응용 프로그램이 위치를 캡처하도록 허용하십시오. 위치 캡처를 허용한 후 'GPS 새로 고침' 버튼을 눌러야 할 수도 있습니다.",
                NoGPSOnVisit: "GPS 위치를 제 시간에 감지할 수 없습니다. 좌표 없이 계속하시겠습니까?",
                NoGPSPermission: "앱에 대한 위치 공유를 활성화하지 않았기 때문에 이 앱을 사용할 수 없습니다. 앱 설정을 업데이트하거나 앱을 삭제하고 다시 설치할 수 있습니다. 다시 설치하면 로그인할 때 앱이 위치를 사용할 수 있는지 묻습니다. 계속하려면 예라고 말해야 합니다.",
                SyncVisitWarning: "방문을 서버와 동기화할 수 없습니다. 나중에 다시 시도 해주십시오!",
                CarePlanItemHistoryDisplayMode: "케어 플랜 이력 표시 모드",
                Individually: "개별적으로",
                AllAtOnce: "한번에",
                GpsTimeLeft: "응용 프로그램이 GPS 좌표를 가져오려고 합니다. 장애가 발생한 경우 최대 시간 내에 클럭 인/아웃을 사용할 수 있습니다 ",
                Seconds: "초",
                BlockUser: "사용자 차단",
                ServicePeriod: "서비스 기간",
                ServicePeriodStartDate: "서비스 기간 시작일",
                UseBy: "사용자",
                TotalTime: "총 시간",
                UsedTime: "사용 시간",
                RemainingTime: "남은 시간",
                AuthInfo: "Auth Info",
                YouMayWorkUpTo: "<br/><br/>까지 일할 수 있습니다.",
                NoAuthorizedUnitsLeftWarning: "방문 승인 시간이 0분 남았으므로 이 환자 및 방문 유형에 대해 새 방문을 시작할 수 없습니다!",
            },
            "zh": { //Chinese (Simplified)
                Nothing: "",
                Monday: "周一",
                Tuesday: "周二",
                Wednesday: "周三",
                Thursday: "周四",
                Friday: "周五",
                Saturday: "周六",
                Sunday: "周日",
                ViewMap: "查看地图",
                NoteTooLong: "备注太长。最多请保持512个字符！",
                NoteTooLong4000characters: "备注太长。最多请保持4000个字符！",
                OfflinePassForgot: "您处于离线状态。请连网以重置密码。",
                ConfirmPassReset: "您确定要重置密码吗",
                ConfirmShiftResponse: "您确定要对此开放班次做出回应吗？",
                PatientName: "</br></br>患者姓名：",
                EmptyUsername: "请确保您已填写用户名/邮箱！",
                EmptyError: "您没有存档您的电话号码或邮箱。请联系您的办公室让他们重置您的密码。",
                PassResetSuccess: "密码重置邮件已发送到您的邮箱",
                PhoneError: "密码重置短信已发送到您的手机。",
                NewMessages: "您可能有新消息。",
                ReadNow: "现在阅读",
                ReadLater: "稍后阅读",
                Ok: "好的",
                Close: "关闭",
                DeleteWorking: "您确定要删除工作时间吗？",
                DeleteAdjustment: "您确定要删除调整<b>",
                InitiatingCall: "正在发起呼叫...",
                CallFailed: "呼叫失败",
                CallCanceled: "呼叫已取消",
                OngoingCall: "通话中...",
                CallEnded: "通话结束",
                IncomingCall: "来电",
                ConnectingToCall: "正在连接...",
                Rejected: "已拒绝 ...",
                RejectionFailed: "拒绝失败...",
                ChangePasswordOfflineWarning: "更改密码仅在联网时可用！",
                PassBlank: "重输密码为空或两者不匹配！",
                PleaseConnect: "请连接互联网进行登录！",
                InvalidPassword: "当前密码无效。请再试一次！",
                AcceptedChars: "可接受的字符为字母、数字和符号'.', '!'。",
                NewInvalidPass: "新密码无效。请检查上述要求。",
                InvalidCurrentPassword: "当前密码无效！",
                PasswordMustBeDifferent: "新密码必须与您最近的 3 个密码不同。请尝试不同的新密码。",
                PasswordsDoNotMatch: "密码不匹配！",
                PassBlockedWord1: "新密码包含屏蔽词",
                PassBlockedWord2: "密码不得包含屏蔽词。",
                PasswordResetSuccess: "您已成功更改了密码。请登录。",
                AgreeToReceiveInformationalMessages: "我同意通过我的电话号码接收来自 ",
                PasswordResetNotSuccessful: "无法更改密码。 请再试一次。",
                Enable: "启用",
                Disable: "禁用",
                UnableToSaveCode: "无法保存验证码。请联系支持团队！",
                InvalidCode: "验证码无效",
                ConfirmingLocation: "正在确认位置 - 请稍候！",
                GPSNotCaptured: "您的GPS坐标未被获取。请刷新GPS重试！",
                GPSNotCaptured2: "您的GPS坐标未被获取。您可以按“接受时间”开始您的护理，但请将应用程序打开最多3 分钟，以便我们继续尝试获取您的位置。",
                GPSNotCaptured3: "您的GPS坐标未被获取。请再试一次！",
                TooEarlyToReport: "您来不及打卡。请在您预定的时间打卡。",
                TooLateToReport: "你来不及打卡了。",
                LocationNotCloseEnough: "您的位置距离客户家不够近。 请在客户家中打卡，然后使用刷新 GPS 重试！",
                YourArrivalTimeIs: "您的打卡时间是",
                SomeoneElseIsAlreadyClocked: "其他人已经打卡了。请让他们打卡，以便您可以打卡",
                YourExpectedDeparture: " 您的预计出发时间是",
                ClientDocumentsReady: " 通过确认您的到来，您承认您已经阅读了客户文件。",
                OpenShiftDate: "</br></br> 打开轮班日期：",
                OpenShiftTime: "</br></br>打开换档时间: ",
                WeStillTryingConfirmLocation: " 我们仍在尝试确认您的位置。我们将继续尝试最多3分钟。",
                YourExpectedDepartureTimeNotUntil: "您预计的出发时间是",
                CompleteFullySchedule: "如果您想完成您完全预定的时间，请打卡在",
                PleaseSetStatus: "请为所有项目设置状态！",
                CarePlanItemAlreadyExisit: "您要添加的护理计划项目已添加到列表中",
                MessageConfirmLogOut: "您确定要退出吗？",
                Confirm: "确认",
                Cancel: "取消",
                PageAvailableOnlyOnline: "此页面仅在在线时可用。",
                SomethingWentWrong: "出了点问题，请重试！",
                EnrolledSuccessfully: "报名成功！",
                SuccessfullPictureUpload: "已成功上传图片。",
                VisitMoved: "护理今天有变！",
                PatientConcernTooLong: "患者关注时间过长。请保持添加最多512个字符！",
                VisitHistoryOffline: "护理历史记录仅在有互联网连接时可用。",
                OnlyNetAccess: "仅当有网时可用！",
                ErrorSavingSignature: "保存签名时出错。请重试或联系Ankota。",
                ErrorSavingWorkerSignature: "保存工作人员签名时出错。请重试或联系Ankota。",
                ErrorSavingPatientSignature: "保存患者签名时出错。请重试或联系Ankota。",
                CouldNotCreateFile: "无法创建文件",
                NoRecording: "请勿录音！",
                UploadedFile: "成功上传文件。",
                MarkWhileOffline: "您无法在离线时将消息标记为已读！,",
                Offline: "您已离线",
                Syncing: "正在同步...请稍候",
                LoadingMessage: "加载中...请稍候",
                Title: "标题",
                Message: "信息",
                Date: "日期",
                DateAndTime: "约会时间",
                MarkAsRead: "标记为已读",
                Call: "呼叫",
                Immediately: "立刻。",
                HourShort: "时",
                MinShort: "分",
                Actions: "行动",
                UnblockUser: "解锁用户，",
                Image: "图像",
                Document: "文件",
                LoadingDocsWait: "正在加载文件，请稍候",
                ProcessDocsWait: "正在处理文件，请稍候",
                PleaseConnectToLogIn: "请连接互联网进行登录！",
                AvailableShifsNoInternet: "可用的班次只有在有互联网连接的情况下才能访问！",
                ShiftNotAvailable: "班次不再可用。",
                ShiftAssignedToYou: "办公室为你安排了这个班次。 如果您不能这样做，请联系办公室！",
                InvalidUserOrPass: "无效的用户名或密码。请再试一次。",
                UnexpectedErrorContactSupport: "意外的错误！请联系支持！",
                FingerprintAuthError: "处理指纹认证时出错",
                EnrollAgain: "出了点问题，请重新注册！",
                UsernameEnrollmentError: "此用户名未注册，请尝试不同的用户名或密码登录！",
                BiometricAuthentication: "请输入用户名进行生物识别。",
                InvalidCoordinates: "无效坐标",
                SigningInPleaseWait: "正在登录，请稍候",
                SignIn: "登录",
                UseBackup: "使用备份",
                FingerprintAuthentication: "指纹认证",
                PleaseEnrollYourProfile: "请登记您的个人资料",
                DoYouHave: "你有没有",
                Concerns: "担忧？",
                HRNotifications: "人力资源通知",
                NoNotifications: "没有通知。",
                Hi: "您好",
                Expected: "预期的",
                SelectLanguage: "选择语言...",
                TitleApp: "居家服务",
                Subtitle: "护理员门户",
                Username: "邮箱或用户名",
                Password: "密码",
                UserError: "请输入有效的用户名。",
                PwError: "您的密码需要超过6个字符。",
                Login: "登录",
                PwForgot: "忘记密码",
                ChangePassword: "更改密码",
                LoginErr: "登录无效。请再试一次。",
                About: "关于",
                Version: "版本",
                Account: "帐户",
                UploadDocumentOrPicture: "上传文件或图片",
                Name: "名称",
                PickUpCases: "选取案例",
                CaseOrderName: "案例＃：",
                TimeBetweenCases: "案例之间的时间：",
                TravelTime: "旅行时间",
                Status: "状态",
                Language: "语言",
                AssignToMe: "分配给我",
                AcceptCase: "接受案例",
                DeclineCase: "拒绝案例",
                SeeDetails: "查看详细信息",
                ConsumerNoShow: "消费者未出现",
                ReturnCase: "退货案例",
                LateCancellation: "延迟取消",
                YouArePreferred: "您是首选",
                NoCasesToShow: "没有可显示的案例。",
                AssignedPatients: "指定的客户",
                AvailableShifts: "可用班次",
                NoAssignedPatients: "您没有指定的客户！",
                ReportTasks: "报告任务",
                MyRegularSchedule: "我的常规日程",
                BookingsPerWeek: "每周预订",
                Slot: "插槽",
                AddASlot: "添加插槽",
                AddTimeoffConflict: "添加休假/冲突时间",
                OverrideSchedule: "覆盖日程",
                Type: "类型",
                OverwriteEmployeeCalendar: "覆盖员工日历",
                BlockedUsers: "被封禁的用户",
                Chat: "聊天",
                LoadMoreUsers: "加载更多用户",
                PasswordMustBe: "密码必须是",
                PasswordMustBeAtLeast: "密码必须至少为",
                PasswordMustBeAtMost: "密码最多为",
                PasswordMustContainAtLeast: "密码必须至少包含",
                NumericCharacters: "数字字符",
                SpecialCharacters: "特殊字符",
                CharactersLong: "字符长度。",
                PasswordRequirement: "密码必须包含4种类型中的 3 种，包括小写、大写、特殊、数字字符。",
                CurrentPassword: "当前密码",
                NewPassword: "新密码",
                ReenterPassword: "重新输入新的密码",
                TypeMsg: "在这里输入您的消息...",
                To: "至",
                SentFileToYou: "给您发了一个文件，您可以下载它",
                Here: "在这里。",
                Hello: "您好 ",
                ClientView: "客户视图",
                ReportArrival: "打卡",
                ReportDeparture: "下班",
                Logout: "登出",
                Completion: "今天已完成",
                NoMatchedClients: "没有匹配的客户！请联系",
                ConfirmDeparture: "确认出发",
                ArrivalDate: "到达日期",
                ArrivalTime: "到达时间",
                DepartureDate: "出发日期",
                DepartureTime: "出发时间",
                VisitDocuments: "护理文件",
                Complete: "完成",
                Incomplete: "未完成",
                NotStarted: "未开始",
                ProcessDocuments: "流程文件",
                OnlyOnline: " 只能在线完成",
                ConnectionOflline: "网络于离线状态",
                SaveIncomplete: "保存未完成",
                ResetToNew: "重置为新",
                PickerDisplay: "日期/数字时间选择器",
                NewAppVersionAvailable: "应用程序出新版本了，请更新！",
                FaceID: "人脸识别",
                Fingerprint: "指纹",
                ReportNoShow: "报告未显示",
                ReportCancelVisit: "报告 取消访问",
                NotificationCenter: "通知中心",
                Visits: "护理",
                Time: "时间",
                Client: "客户",
                Location: "地点",
                AcceptVisit: "接受护理",
                DeclineVisit: "拒绝护理",
                Messages: "信息",
                Title2: "标题",
                Delete: "删除",
                ViewDocsPatients: "查看以下患者的文件：",
                ViewDocuments: "查看文件",
                Documents: "文件",
                PayrollHistory: "工资单历史记录",
                WeeklyHours: "每周工作时间",
                NoPayrollsToShow: "没有工资单可显示。",
                PayrollSummary: "工资汇总",
                WeeklySummary: "每周工作时间总结",
                GrossEarnings: "总收入",
                GrossEarnings2: "总收益",
                TotalHourBreakdown: "总小时数明细",
                Regular: "常规的",
                Overtime: "随着时间的推移",
                TotalHoursWorked: "总工作时数",
                VisitTime: "访问时间",
                Adjustments: "调整",
                AdjustmentsReflect: "调整反映了以前付款的变化。",
                ExpectedPayment: "预计税前付款",
                HoursWorked: "工作时间",
                NumberofDays: "天数",
                NumberOfVisits: "护理次数",
                VisitHistory: "护理历史",
                Trips: "旅行",
                TripOptionQuestion: "您在这次护理中是否完成了非医疗运输？",
                RefreshGPS: "刷新GPS",
                ClockIn: "没有打卡上班时间",
                ClockOut: "没有打卡下班时间",
                CurrentArrival: "打卡时间",
                AcceptTime: "打卡",
                ReportItems: "报告项目",
                AddBreak: "添加中断",
                NA: "不适用",
                Set: "设置",
                NotSet: "未设置",
                AddAnotherItem: "添加另一个项目",
                NothingToAdd: "没什么可添加的",
                AddItem: "添加项目",
                NoItemsToDisplay: "没有要显示的项目。",
                Next: "下一个",
                SelectVisitType: "选择护理类型",
                Settings: "设置",
                Availability: "可用性",
                General: "一般的",
                Security: "安全",
                NameUploadPicturesDocs: "姓名，上传图片/文件",
                ConsenttoReceiveTexts: "同意接收短信",
                ChangePasswordFingerprintFaceID: "更改密码，指纹/Face ID",
                AddSlots: "添加插槽",
                ToSetAdditionalSettings: "要设置其他设置，请使用相同的凭据登录",
                Authentication: "验证",
                EnterSMSCode: "输入您通过短信收到的验证码：",
                Back: "后退",
                Code: "验证码",
                MyVisits: "我的护理",
                Address: "地址",
                CreatedByPhone: "通过电话创建",
                ViewMoreDetails: "查看更多详情",
                NoShow: "不显示",
                Tasks: "任务",
                CancelVisit: "取消访问",
                UploadDocs: "上传文档",
                DocumentsAreLoading: "文档正在加载...",
                NoDocuments: "没有文件",
                Rework: "返工",
                NoVisitsToShow: "没有可显示护理",
                UploadTimesheets: "上传时间表",
                UploadDocuments: "上传文件",
                EnterAdditionalNotes: "在此处输入附加注释...",
                VisitDirections: "护理说明",
                DriveTime: "行驶时间",
                PrecedingVisitEndTime: "上次护理结束时间",
                TimeBetweenVisits: "护理间隔时间",
                VisitAddress: "护理地址",
                LiveDirections: "现场说明",
                VisitDetails: "护理详情",
                ClientName: "客户名称",
                ServiceName: "服务名称",
                VisitDate: "护理日期",
                VisitStatus: "护理状态",
                PrimaryPhone: "常用电话",
                SecondaryPhone: "辅助电话",
                GetDirections: "获取说明",
                VisitNotes: "参观须知",
                Instructions: "指示",
                PleaseUseTheButton: "请使用底部的按钮为您的工作表拍照。如果图片看起来不清楚，请使用重试按钮。",
                Keep: "保持",
                TakePicture: "拍照",
                UploadOrTakePicture: "上传或拍照",
                RetakePicture: "重拍",
                AddPhoto2: "添加照片",
                VisitHistoryCaps: "护理历史",
                Completed: "已完成",
                WorkerName: "工作人员姓名",
                Notes: "备注",
                ResponseNotes: "回应说明",
                AddNotes: "添加备注",
                MoveVisitToday: "今天搬家参观",
                ShowMore: "... 展示更多",
                VisitType: "护理类型",
                PleaseAsk: "请问 ",
                ToConfirmThatTheyReceived: "确认他们接受了",
                ServiceToday: "今天的服务",
                Yes: "是",
                No: "否",
                ToConfirmThatTheVisit: "确认护理时间是从",
                ReportDeparture2: "下班",
                ToSignHere: "在这里签字",
                VoiceSignature: "语音签名",
                PleaseSignHere: "请在这里签字",
                PleaseAskYour: "请询问您的",
                ErrandMiles: "跑腿里程",
                AddPhoto: "添加照片",
                Clear: "清除",
                Accept: "接受",
                NotAvailable: "不可用",
                VisitConfirmation: "护理确认",
                RequestForConfirmation: "请在按开始录制后说出您的姓名和今天的日期，以确认您已接受了今天的服务。",
                PlayRecording: "播放录音",
                StopPlayRecording: "停止播放录音",
                StartRecording: "开始录音",
                StopRecording: "停止录音",
                MonthView: "月视图",
                WeekView: "周视图",
                ArrSuccess: "您的到达已成功记录在",
                ArrOffline: "您的到达已被记录，但您处于离线状态。您的办公室可能会收到延迟警告。",
                ArrSuccessDeparture: "您的预计出发时间是",
                CurrentVisit: "当前护理时长",
                Hours: "小时",
                Minutes: "分钟",
                ClockOutButton: "下班打卡",
                ConfirmLocation: "我们仍在尝试确认您的位置。我们将继续尝试最多3分钟。",
                ViewTasks: "查看任务",
                CurrentDeparture: "当前出发时间",
                Duration: "期间",
                Duration2: "期间",
                ConfirmClockOut: "您确定要打卡下班吗？",
                Only3OnHoldVisitsWillShowAtaTime: "一次只会显示 3 个挂起的访问。",
                Submit: "提交",
                DepSuccess: "您的离开已成功记录在",
                VisitSuccesfullyClosed: "访问已成功结束",
                DepOffline: "您的离开已被记录，但您处于离线状态。您的办公室可能会收到延迟警告。",
                PleaseOpenYourAnkotaApplater: " 请在今天晚些时候信号更好（当您在线时）时打开您的 Ankota 应用程序，以便将您的访问数据发送到办公室。",
                Home: "主页",
                Save: "保存",
                ReportMissedVisit: "报告错过的访问",
                ReportVisit: "报告访问",
                AddMissedVisitReason: "选择错过的原因",
                CorrectDatesTime: "通过单击上面的日期/时间并滚动到正确的选项来更正它们。",
                ContigousVisitBlock: "此次访问是一系列访问的一部分。请输入您实际的开始时间和该系列访问的最终下班时间。",
                AddWorkerDocument: "选择文件 ",
                ReportExpensesTitle: "报告费用",
                ReportExpensesQuestion: "你有费用报告吗？",
                Amount: "数量",
                Description: "描述",
                Company: "公司",
                YourVisitDurationIs: "</br></br>访问时长为 ",
                YourDepartureTimeIs: "</br></br>您的出发时间是 ",
                PleaseSelectReason: "请选择理由！",
                PleaseSelectDocument: "请选择文件！",
                OnHold: "完成等待访问",
                DurationGreaterThan0: "访问时长必须大于0分钟！",
                PleaseWaitSearch: "我们正在搜索您的活动作业，请稍候。",
                NotesAndInfo: "注释和信息",
                InfoOnlyItems: "仅供参考的项目",
                NoNotesForVisit: "本次访问没有备注！",
                NoInfoForVisit: "本次访问没有信息项目！",
                ContiguousVisits: "连续访问",
                Details: "细节",
                Signature: "签名",
                GoToSign: "显示垫",
                History: "历史",
                NoNotesInHistory: "历史上没有笔记！",
                CarePlanHistoryNotAvailableOffline: "护理计划项目历史记录在离线模式下不可用！",
                TheVisitIsAlreadySigned: "此次访问已经签署。 无需签名即可继续。 ",
                OfflineUptimeWarning: "自您上次在线登录后，您的设备可能已重新启动。 如果可能，请在线登录以更新您的时间。",
                Phone: "电话",
                Email: "电子邮件",
                OfflineModeWarning: "您的应用程序由于连接不良而出现问题，并将离线捕获您的数据。 一旦您的网络连接改善，办公室将立即更新。",
                OnlineModeWarning: "您的应用程序设法重新连接到服务器。 您的访问数据现在将在线同步和处理。",
                Refresh: "刷新 ",
                ResetMapsApp: "重置地图应用",
                DefaultMapsAppWarning: "默认地图应用程序已重置。 下次启动导航器时，您将能够选择一个新应用程序。",
                UseBingInstead: "使用必应地图",
                NoLocationWarning: "无法捕获您的位置。 确保您的 GPS 已打开，否则您选择的地图应用程序可能无法定位您的位置。 你还是要继续吗？ 您可能需要手动输入当前位置！",
                NoMapsWarning: "在您的设备上未找到任何地图应用程序。 必应地图将改为打开。",
                HoursLimitWarning: "</br><b><p style='color:Red'>访问时间 > 16 小时。 你确定吗？</p></b>",
                SlotChangeWarning: "您已在此时间段安排访问。请联系办公室以请求您的可用性更改。",
                WorkerPhone: "工人电话",
                PleaseTurnOnGPS: "您的 GPS 已关闭。 请允许应用程序在继续之前捕获您的位置。 允许捕获您的位置后，您可能需要按“刷新 GPS”按钮。",
                NoGPSOnVisit: "无法及时检测到 GPS 位置。 您想在没有坐标的情况下继续吗？",
                NoGPSPermission: "您无法使用此应用，因为您尚未为该应用启用位置共享。 您可以更新您的应用程序设置或删除并重新安装该应用程序。 如果您重新安装，当您登录时它会询问该应用程序是否可以使用您的位置。 您必须说是才能继续。",
                SyncVisitWarning: "访问无法与服务器同步。 请稍后再试！",
                CarePlanItemHistoryDisplayMode: "护理计划历史显示模式",
                Individually: "个别",
                AllAtOnce: "一次全部",
                GpsTimeLeft: "该应用程序正在尝试获取 GPS 坐标。 如果发生故障，打卡/打卡将在最多可用 ",
                Seconds: "秒",
                BlockUser: "阻止用户",
                ServicePeriod: "服务期",
                ServicePeriodStartDate: "服务期开始日期",
                UseBy: "使用方",
                TotalTime: "总时间",
                UsedTime: "使用时间",
                RemainingTime: "剩余时间",
                AuthInfo: "Auth Info",
                YouMayWorkUpTo: "<br/><br/>你可以工作到",
                NoAuthorizedUnitsLeftWarning: "您无法为此患者和就诊类型开始新的就诊，因为就诊还剩 0 分钟授权！",
            },
            "tl": { //Tagalog / Filipino
                Nothing: "",
                Monday: "Lunes",
                Tuesday: "Martes",
                Wednesday: "Miyerkules",
                Thursday: "Huwebes",
                Friday: "Biyernes",
                Saturday: "Sabado",
                Sunday: "Linggo",
                ViewMap: "Tingnan ang Mapa",
                NoteTooLong: "Masyadong mahaba ang tala. Mangyaring mapanatili ang maximum na 512 na mga character!",
                NoteTooLong4000characters: "Masyadong mahaba ang tala. Mangyaring mapanatili ang maximum na 4000 na mga character!",
                OfflinePassForgot: "Offline ka. Mangyaring kumonekta sa isang network upang mai-reset ang iyong password.",
                ConfirmPassReset: "Kayo apos y tunay na gusto reset inyong password ?",
                ConfirmShiftResponse: "Sigurado ka bang gusto mong tumugon para sa bukas na shift na ito?",
                PatientName: "</br></br>Pangalan ng pasyente: ",
                EmptyUsername: "Mangyaring tiyaking nakumpleto mo ang username / email!",
                EmptyError: "Wala kang isang numero ng telepono o email sa file. Mangyaring makipag-ugnay sa iyong tanggapan upang mai-reset nila ang iyong password.",
                PassResetSuccess: "Ang isang email na pag-reset ng password ay naipadala sa iyong email",
                PhoneError: "Isang teksto ng pag-reset ng password ang naipadala sa iyong numero ng telepono.",
                NewMessages: "Maaari kang magkaroon ng mga bagong mensahe.",
                ReadNow: "Basahin na ngayon",
                ReadLater: "Basahin Mamaya",
                Ok: "Sige",
                Close: "Isara",
                DeleteWorking: "Sigurado ka bang nais mong tanggalin ang oras ng pagtatrabaho?",
                DeleteAdjustment: "Sigurado ka bang nais mong tanggalin ang pagsasaayos ng <b>",
                InitiatingCall: "Nagsisimula sa tawag ...",
                CallFailed: "Nabigo ang tawag",
                CallCanceled: "Nakansela ang tawag",
                OngoingCall: "Patuloy na tawag ...",
                CallEnded: "Natapos ang tawag",
                IncomingCall: "Papasok na tawag",
                ConnectingToCall: "Kumokonekta ...",
                Rejected: "Tinanggihan ...",
                RejectionFailed: "Nabigo ang pagtanggi ...",
                ChangePasswordOfflineWarning: "Magagamit lamang ang pagbabago ng password kapag may koneksyon sa internet!",
                PassBlank: "Ang reenter password ay blangko o hindi tugma!",
                PleaseConnect: "Mangyaring kumonekta sa internet upang mag-log in!",
                InvalidPassword: "Di-wasto ang kasalukuyang password. Ulitin mo ulit!",
                AcceptedChars: "Ang mga tinatanggap na character ay mga titik, numero, at mga sumusunod na simbolo na '.', '!'.",
                NewInvalidPass: "Di-wasto ang bagong password. Mangyaring suriin ang mga kinakailangan sa itaas.",
                InvalidCurrentPassword: "Di-wastong kasalukuyang password!",
                PasswordMustBeDifferent: "Ang bagong password ay dapat na naiiba mula sa iyong huling 3 mga password. Mangyaring sumubok ng ibang bagong password.",
                PasswordsDoNotMatch: "Ang mga password ay hindi tugma!",
                PassBlockedWord1: "Naglalaman ang bagong password ng naka-block na salita",
                PassBlockedWord2: "Hindi dapat maglaman ang password ng mga naka-block na salita.",
                PasswordResetSuccess: "Matagumpay mong nabago ang iyong password. Paki-login",
                AgreeToReceiveInformationalMessages: "Sumasang-ayon akong tumanggap ng mga mensahe/notification ng impormasyon sa aking numero ng telepono mula sa ",
                PasswordResetNotSuccessful: "Hindi mapalitan ang password. Pakisubukang muli.",
                Enable: "Paganahin",
                Disable: "Huwag paganahin",
                UnableToSaveCode: "Hindi mai-save ang code. Mangyaring makipag-ugnay sa koponan ng suporta!",
                InvalidCode: "Di-wastong Code",
                ConfirmingLocation: "Kinukumpirma ang Lokasyon - Mangyaring maghintay!",
                GPSNotCaptured: "Ang iyong mga coordinate sa GPS ay hindi nakunan. Mangyaring subukang muli gamit ang Refresh GPS!",
                GPSNotCaptured2: "Ang iyong mga coordinate sa GPS ay hindi nakunan. Maaari mong pindutin ang 'Tanggapin ang Oras' upang simulan ang iyong pagbisita, ngunit mangyaring iwanang bukas ang app ng hanggang sa 3 minuto upang masubukan naming subukang makuha ang iyong lokasyon.",
                GPSNotCaptured3: "Ang iyong mga coordinate sa GPS ay hindi nakunan. Ulitin mo ulit!",
                TooEarlyToReport: "Masyado kang maaga para mag-clock. Mangyaring mag-clock sa iyong naka-iskedyul na oras.",
                TooLateToReport: "Huli ka na para mag-clock.",
                LocationNotCloseEnough: "Ang iyong lokasyon ay hindi sapat na malapit sa tahanan ng kliyente. Mangyaring mag-clock mula sa bahay ng kliyente at subukang muli gamit ang Refresh GPS!",
                YourArrivalTimeIs: "Ang iyong orasan sa orasan ay ",
                SomeoneElseIsAlreadyClocked: "May ibang taong naka-clock in. Mangyaring hilingin sa kanila na mag-clock out para makapag-clock ka.",
                YourExpectedDeparture: " Ang iyong inaasahang oras ng pag-alis ay",
                ClientDocumentsReady: " Sa pamamagitan ng pagkumpirma ng iyong pagdating, kinikilala mo na nabasa mo ang mga dokumento ng kliyente.",
                OpenShiftDate: "</br></br>Buksan ang Petsa ng Shift：",
                OpenShiftTime: "</br></br>Oras ng bukas na shift: ",
                WeStillTryingConfirmLocation: " Sinusubukan pa rin naming kumpirmahin ang iyong lokasyon. Patuloy kaming susubukan ng hanggang 3 minuto.",
                YourExpectedDepartureTimeNotUntil: "Ang iyong inaasahang oras ng pag-alis ay",
                CompleteFullySchedule: "Kung nais mong kumpletuhin ang iyong kumpletong nakaiskedyul na oras, mangyaring mag-clock out",
                PleaseSetStatus: "Mangyaring magtakda ng katayuan sa lahat ng mga item!",
                CarePlanItemAlreadyExisit: "Ang item sa plano ng Pangangalaga na gusto mong idagdag ay naidagdag na sa listahan",
                MessageConfirmLogOut: "Sigurado ka bang nais mong mag-log out?",
                Confirm: "Kumpirmahin",
                Cancel: "Kanselahin",
                PageAvailableOnlyOnline: "Magagamit lamang ang pahinang ito habang online.",
                SomethingWentWrong: "Nagkaproblema, pakisubukan ulit!",
                EnrolledSuccessfully: "Nag-enrol na matagumpay!",
                SuccessfullPictureUpload: "Matagumpay na na-upload ang larawan.",
                VisitMoved: "Lumipat ang pagbisita ngayon!",
                PatientConcernTooLong: "Masyadong mahaba ang pag-aalala sa pasyente. Mangyaring magdagdag ng mapanatili ang maximum na 512 mga character!",
                VisitHistoryOffline: "Magagamit lamang ang History ng Pagbisita kung mayroong koneksyon sa internet.",
                OnlyNetAccess: "Magagamit lamang kapag mayroong access sa internet!",
                ErrorSavingSignature: "Error sa pag-save ng pirma. Mangyaring subukan ulit o makipag-ugnay sa Ankota.",
                ErrorSavingWorkerSignature: "Error sa pag-save ng pirma ng manggagawa. Mangyaring subukan ulit o makipag-ugnay sa Ankota.",
                ErrorSavingPatientSignature: "Error sa pag-save ng pirma ng pasyente. Mangyaring subukan ulit o makipag-ugnay sa Ankota.",
                CouldNotCreateFile: "Hindi makalikha ng file",
                NoRecording: "Walang Pagre-record!",
                UploadedFile: "Matagumpay na Na-upload na File.",
                MarkWhileOffline: "Hindi mo maaaring markahan ang isang mensahe bilang nabasa habang ikaw ay offline!",
                Offline: "Offline ka",
                Syncing: "Pagsi-sync ... Mangyaring Maghintay",
                LoadingMessage: "Naglo-load ... Mangyaring Maghintay",
                Title: "Pamagat",
                Message: "Mensahe",
                Date: "Petsa",
                DateAndTime: "Petsa at Oras",
                MarkAsRead: "Markahan bilang nabasa",
                Call: "Tumawag ka",
                Immediately: "kaagad",
                HourShort: "h",
                MinShort: "m",
                Actions: "Mga kilos",
                UnblockUser: "Tanggalin ang pagkablock ang Gumagamit / I-unblock ang user",
                Image: "Larawan",
                Document: "Dokumento",
                LoadingDocsWait: "Naglo-load ng mga dokumento, mangyaring maghintay",
                ProcessDocsWait: "Iproseso ang mga dokumento, mangyaring maghintay",
                PleaseConnectToLogIn: "Mangyaring kumonekta sa internet upang mag-log in!",
                AvailableShifsNoInternet: "Maa-access lang ang Available Shifts kung may internet connection!",
                ShiftNotAvailable: "Hindi na available ang shift.",
                ShiftAssignedToYou: "Iniskedyul ka ng opisina para sa shift na ito. Kung hindi mo magawa, mangyaring makipag-ugnayan sa opisina!",
                InvalidUserOrPass: "Di-wastong username o password. Ulitin mo ulit.",
                UnexpectedErrorContactSupport: "Hindi inaasahang error! Mangyaring makipag-ugnay sa suporta!",
                FingerprintAuthError: "Mayroong isang error habang pinoproseso ang pagpapatotoo ng fingerprint",
                EnrollAgain: "May naganap na mali, mangyaring magpatala muli!",
                UsernameEnrollmentError: "Walang pagpapatala para sa username na ito, mangyaring subukan ang ibang username o pag-login sa pamamagitan ng password!",
                BiometricAuthentication: "Mangyaring maglagay ng username para sa pagpapatotoo ng biometric.",
                InvalidCoordinates: "Di-wastong Mga Coordinate",
                SigningInPleaseWait: "Pag-sign in, mangyaring maghintay",
                SignIn: "Mag-sign In",
                UseBackup: "Gumamit ng Backup",
                FingerprintAuthentication: "Pagpapatotoo ng Fingerprint",
                PleaseEnrollYourProfile: "Mangyaring ipatala ang iyong profile",
                DoYouHave: "Meron ka bang",
                Concerns: "Mga alalahanin?",
                HRNotifications: "Mga Abiso sa HR",
                NoNotifications: "Walang Mga Abiso.",
                Hi: "HI",
                Expected: "inaasahan",
                SelectLanguage: "Pumili ng Wika ...",
                TitleApp: "PANGANGALAGA SA TAHANAN",
                Subtitle: "Portal ng Tagapag-alaga",
                Username: "Email o Username",
                Password: "Password",
                UserError: "Mangyaring maglagay ng wastong username.",
                PwError: "Ang iyong password ay nangangailangan ng higit sa 6 na mga character.",
                Login: "Mag log in",
                PwForgot: "Nakalimutan ang password?",
                ChangePassword: "Palitan ANG password",
                LoginErr: "Di-wasto ang pag-login. Ulitin mo ulit.",
                About: "Tungkol sa",
                Version: "Bersyon",
                Account: "Account",
                UploadDocumentOrPicture: "Mag-upload ng dokumento o larawan",
                Name: "Pangalan",
                PickUpCases: "PICK UP CASES",
                CaseOrderName: "Kaso #:",
                TimeBetweenCases: "Oras sa Pagitan ng Mga Kaso:",
                TravelTime: "Oras ng Paglalakbay",
                Status: "Katayuan",
                Language: "Wika",
                AssignToMe: "Magtalaga sa Akin",
                AcceptCase: "Tanggapin Kaso",
                DeclineCase: "Pagtanggi ng Kaso",
                SeeDetails: "Tignan ang detalye",
                ConsumerNoShow: "Walang Ipakita ang Consumer",
                ReturnCase: "Balik Kaso",
                LateCancellation: "Huling Pagkansela",
                YouArePreferred: "IKAW ANG NAPIPILI",
                NoCasesToShow: "Walang maipakitang kaso.",
                AssignedPatients: "MGA KLIENTE NA NATARANG",
                AvailableShifts: "Magagamit na mga Shift",
                NoAssignedPatients: "Wala kang nakatalagang kliyente!",
                ReportTasks: "Iulat ang Mga Gawain",
                MyRegularSchedule: "Ang Regular na Iskedyul Ko",
                BookingsPerWeek: "Mga Pag-book Per Linggo",
                Slot: "Slot",
                AddASlot: "Magdagdag ng Slot",
                AddTimeoffConflict: "Magdagdag ng Oras ng pahinga/Salungatan",
                OverrideSchedule: "Override Iskedyul",
                Type: "Uri",
                OverwriteEmployeeCalendar: "Overwrite ang Kalendaryo ng empleyado",
                BlockedUsers: "Mga Na-block na User",
                Chat: "Chat",
                LoadMoreUsers: "Mag-load ng Maraming Mga User",
                PasswordMustBe: "Ang password ay dapat",
                PasswordMustBeAtLeast: "Ang password ay dapat na hindi bababa sa",
                PasswordMustBeAtMost: "Ang password ay dapat na higit sa lahat",
                PasswordMustContainAtLeast: "Ang password ay dapat maglaman ng hindi bababa sa",
                NumericCharacters: "mga character na numero",
                SpecialCharacters: "mga espesyal na tauhan",
                CharactersLong: "haba ng character.",
                PasswordRequirement: "Ang password ay dapat maglaman ng 3 sa 4 na uri ng uri ng tunog, itaas, espesyal, at numerong character.",
                CurrentPassword: "Kasalukuyang Password",
                NewPassword: "Bagong Password",
                ReenterPassword: "Reenter Bagong Password",
                TypeMsg: "I-type ang Iyong Mensahe Dito ...",
                To: "sa",
                SentFileToYou: "ay nagpadala sa iyo ng isang file, maaari mong i-download ito",
                Here: "dito",
                Hello: "Kamusta ",
                ClientView: "View ng kliyente",
                ReportArrival: "Oras sa loob",
                ReportDeparture: "CLOCK OUT",
                Logout: "Mag-log out",
                Completion: "Nakumpleto Ngayon",
                NoMatchedClients: "Walang naitugmang kliyente! Mangyaring makipag-ugnay",
                ConfirmDeparture: "Kumpirmahin ang DEPARTURE",
                ArrivalDate: "Araw ng pagdating",
                ArrivalTime: "Oras ng pagdating",
                DepartureDate: "Petsa ng pagalis",
                DepartureTime: "Oras ng pag-alis",
                VisitDocuments: "Bisitahin ang Mga Dokumento",
                Complete: "Kumpleto",
                Incomplete: "Hindi kumpleto",
                NotStarted: "Hindi nagsimula",
                ProcessDocuments: "Mga Dokumento ng Proseso",
                OnlyOnline: " magagawa lamang sa online",
                ConnectionOflline: "Ang koneksyon sa internet ay offline",
                SaveIncomplete: "I-save ang Hindi Kumpleto",
                ResetToNew: "I-resetToNew",
                PickerDisplay: "mga tagapili ng oras / numero",
                NewAppVersionAvailable: "Magagamit ang bagong bersyon ng aplikasyon mangyaring i-update!",
                FaceID: "FaceID",
                Fingerprint: "Fingerprint",
                ReportNoShow: "Iulat ang Walang Ipakita",
                ReportCancelVisit: "Iulat ang Kanselahin ang Pagbisita",
                NotificationCenter: "NOTIFICATION CENTER",
                Visits: "Mga pagbisita",
                Time: "Oras",
                Client: "Kliyente",
                Location: "Lokasyon",
                AcceptVisit: "Tanggapin ang Pagbisita",
                DeclineVisit: "Tanggihan ang Pagbisita",
                Messages: "Mga mensahe",
                Title2: "Pamagat",
                Delete: "Tanggalin",
                ViewDocsPatients: "Tingnan ang mga dokumento para sa mga sumusunod na pasyente:",
                ViewDocuments: "Tingnan ang Mga Dokumento",
                Documents: "Mga Dokumento",
                PayrollHistory: "PAYROLL HISTORY",
                WeeklyHours: "LINGGUHANG ORAS",
                NoPayrollsToShow: "Walang ipapakita na mga payroll.",
                PayrollSummary: "BUOD NG PAYROLL",
                WeeklySummary: "BUOD NG LINGGUHANG ORAS",
                GrossEarnings: "KUMITA NG GROSS",
                GrossEarnings2: "Gross Earnings",
                Regular: "Regular",
                Overtime: "Overtime",
                TotalHourBreakdown: "Kabuuang Breakdown ng Oras",
                TotalHoursWorked: "Kabuuang Oras ng Trabaho",
                VisitTime: "Bisitahin ang Oras",
                Adjustments: "Mga pagsasaayos",
                AdjustmentsReflect: "Sinasalamin ng mga pagsasaayos ang mga pagbabago sa mga nakaraang pagbabayad.",
                ExpectedPayment: "Inaasahang Pagbabayad bago ang buwis",
                HoursWorked: "Oras na nagtrabaho",
                NumberofDays: "Bilang ng mga Araw",
                NumberOfVisits: "Bilang ng Pagbisita",
                VisitHistory: "Bisitahin ang Kasaysayan",
                Trips: "Mga paglalakbay",
                TripOptionQuestion: "Nakumpleto mo ba ang transportasyong hindi pang-medikal sa pagbisitang ito?",
                RefreshGPS: "I-refresh ang GPS",
                ClockIn: "walang orasan sa oras",
                ClockOut: "walang oras sa oras",
                CurrentArrival: "Oras ng Clock-in",
                AcceptTime: "Oras sa Papasok",
                ReportItems: "Iulat ang mga item",
                AddBreak: "Magdagdag ng Break",
                NA: "N / A",
                Set: "Itakda",
                NotSet: "NotSet",
                AddAnotherItem: "Magdagdag ng Isa pang Item",
                NothingToAdd: "Walang maidaragdag",
                AddItem: "Magdagdag ng Item",
                NoItemsToDisplay: "Walang ipapakitang item.",
                Next: "Susunod",
                SelectVisitType: "Piliin ang Uri ng Pagbisita",
                Settings: "SETTING",
                Availability: "Pagkakaroon",
                General: "Pangkalahatan",
                Security: "Seguridad",
                NameUploadPicturesDocs: "Pangalan, Mag-upload ng mga larawan/dokumento",
                ConsenttoReceiveTexts: "Pahintulot na Makatanggap ng mga Teksto",
                ChangePasswordFingerprintFaceID: "Palitan ang Password, Fingerprint/Face ID",
                AddSlots: "Magdagdag ng Mga Slot",
                ToSetAdditionalSettings: "Upang magtakda ng mga karagdagang setting, mangyaring mag-log in gamit ang parehong mga kredensyal sa",
                Authentication: "AUTHENTICATION",
                EnterSMSCode: "Ipasok ang code na iyong natanggap sa pamamagitan ng SMS:",
                Back: "Bumalik",
                Code: "Code",
                MyVisits: "ANG BISITA KO",
                Address: "Address",
                CreatedByPhone: "Nilikha sa pamamagitan ng telepono",
                ViewMoreDetails: "Tingnan ang Higit pang Mga Detalye",
                NoShow: "Walang Palabas",
                Tasks: "Mga Gawain",
                CancelVisit: "Kanselahin ang Pagbisita",
                UploadDocs: "Mag-upload ng Docs",
                DocumentsAreLoading: "Naglo-load ang mga dokumento...",
                NoDocuments: "Walang mga Dokumento",
                Rework: "REWORK",
                NoVisitsToShow: "Walang pagbisita sa Show",
                UploadTimesheets: "UPLOAD TIMESHEETS",
                UploadDocuments: "Mag-upload ng Mga Dokumento",
                EnterAdditionalNotes: "Maglagay ng mga karagdagang tala dito ...",
                VisitDirections: "DIREKSYON NG BISITA",
                DriveTime: "Oras ng Pagmamaneho",
                PrecedingVisitEndTime: "Nauna nang Oras ng Pagbisita",
                TimeBetweenVisits: "Oras sa Pagitan ng Mga Pagbisita",
                VisitAddress: "Bisitahin ang Address",
                LiveDirections: "Mga Live na Direksyon",
                VisitDetails: "Bisitahin ang mga DETALYE",
                ClientName: "Pangalan ng kliyente",
                ServiceName: "Pangalan ng Serbisyo",
                VisitDate: "Petsa ng Pagbisita",
                VisitStatus: "Katayuan sa Pagbisita",
                PrimaryPhone: "pangunahing Telepono",
                SecondaryPhone: "Pangalawang Telepono",
                GetDirections: "Kumuha ng mga direksyon",
                VisitNotes: "Bisitahin ang Mga Tala",
                Instructions: "Panuto",
                PleaseUseTheButton: "Mangyaring gamitin ang pindutan sa ibaba upang kumuha ng larawan ng iyong sheet. Gamitin ang pindutang subukang muli kung ang larawan ay tila hindi malinaw.",
                Keep: "Panatilihin",
                TakePicture: "Kumuha ng larawan",
                UploadOrTakePicture: "Mag-upload O Kumuha ng Larawan",
                RetakePicture: "Retake Larawan",
                AddPhoto2: "Magdagdag ng LARAWAN",
                VisitHistoryCaps: "Bisitahin ang KASAYSAYAN",
                Completed: "nakumpleto",
                WorkerName: "Pangalan ng Manggagawa",
                Notes: "Mga tala",
                ResponseNotes: "Mga Tala sa Tugon",
                AddNotes: "Magdagdag ng Tala",
                MoveVisitToday: "Ilipat ang Pagbisita Ngayon",
                ShowMore: "... Ipakita ang Higit Pa",
                VisitType: "Uri ng Pagbisita",
                PleaseAsk: "Tanungin nyo po ",
                ToConfirmThatTheyReceived: "upang kumpirmahin na natanggap nila ang kanilang",
                ServiceToday: "serbisyo ngayon",
                Yes: "Oo",
                No: "Hindi",
                ToConfirmThatTheVisit: "upang kumpirmahing ang mga oras ng pagbisita ay nagmula",
                ReportDeparture2: "CLOCK OUT",
                ToSignHere: "upang mag-sign dito",
                VoiceSignature: "Lagda ng Boses",
                PleaseSignHere: "Mangyaring mag-sign dito",
                PleaseAskYour: "Mangyaring tanungin ang iyong",
                ErrandMiles: "Errand Miles",
                AddPhoto: "Magdagdag ng Larawan",
                Clear: "Malinaw",
                Accept: "Tanggapin",
                NotAvailable: "Hindi magagamit",
                VisitConfirmation: "Bisitahin ang Kumpirmasyon",
                RequestForConfirmation: "Mangyaring sabihin ang iyong pangalan at petsa ngayon pagkatapos ng pagpindot sa Simula sa Pagrekord upang kumpirmahing natanggap mo ang iyong mga serbisyo para ngayon.",
                PlayRecording: "Pag-record ng Play",
                StopPlayRecording: "Ihinto ang Pagre-record sa Play",
                StartRecording: "Simulan ang recording",
                StopRecording: "Ihinto ang Pagre-record",
                MonthView: "Pagtingin sa Buwan",
                WeekView: "Pagtingin sa Linggo",
                ArrSuccess: "Ang iyong pagdating ay matagumpay na naitala sa",
                ArrOffline: "Naitala ang iyong pagdating ngunit ikaw ay offline. Ang iyong tanggapan ay maaaring makatanggap ng isang huling babala.",
                ArrSuccessDeparture: "Ang iyong inaasahang oras ng pag-alis ay",
                CurrentVisit: "Kasalukuyang tagal ng pagbisita",
                Hours: "oras",
                Minutes: "minuto",
                ClockOutButton: "Clock Out",
                ConfirmLocation: "Sinusubukan pa rin naming kumpirmahin ang iyong lokasyon. Patuloy kaming susubukan ng hanggang 3 minuto.",
                ViewTasks: "Tingnan ang Mga Gawain",
                CurrentDeparture: "Kasalukuyang oras ng pag-alis",
                Duration: "tagal",
                Duration2: "Tagal",
                ConfirmClockOut: "Sigurado ka bang nais mong mag-oras?",
                Only3OnHoldVisitsWillShowAtaTime: "Tanging 3 On Hold na mga pagdalaw ang ipapakita sa isang oras.",
                Submit: "Ipasa",
                DepSuccess: "Ang iyong pag-alis ay matagumpay na naitala sa",
                VisitSuccesfullyClosed: "Matagumpay na naisara ang pagbisita",
                DepOffline: "Naitala ang iyong pag-alis ngunit naka-offline ka. Ang iyong tanggapan ay maaaring makatanggap ng isang huling babala.",
                PleaseOpenYourAnkotaApplater: " Mangyaring buksan ang iyong Ankota app mamaya ngayon kapag mayroon kang mas mahusay na signal (kapag ONLINE ka) upang ang iyong data ng pagbisita ay maipadala sa opisina.",
                Home: "Bahay",
                Save: "Magtipid",
                ReportMissedVisit: "Iulat ang Napalampas na Pagbisita",
                ReportVisit: "Iulat ang Pagbisita",
                AddMissedVisitReason: "Piliin ang dahilan para sa hindi nasagot na pagbisita",
                CorrectDatesTime: "Iwasto ang mga petsa/oras sa itaas sa pamamagitan ng pag-click sa mga ito at pag-scroll sa tamang opsyon.",
                ContigousVisitBlock: "Ang pagbisitang ito ay bahagi ng isang bloke ng mga pagbisita. Pakilagay ang iyong aktwal na oras ng pagsisimula at ang iyong huling oras ng clock-out para sa block na ito.",
                AddWorkerDocument: "Pumili ng dokumento ",
                ReportExpensesTitle: "Iulat ang Mga Gastos",
                ReportExpensesQuestion: "Mayroon ba kayong mga gastos upang iulat?",
                Amount: "Halaga",
                Description: "Paglalarawan",
                Company: "Kumpanya",
                YourVisitDurationIs: "</br></br> Ang tagal ng pagbisita ay ",
                YourDepartureTimeIs: "</br></br> Ang iyong oras ng pag-alis ay ",
                PleaseSelectReason: "Mangyaring pumili ng isang dahilan!",
                PleaseSelectDocument: "Mangyaring pumili ng isang dokumento!",
                OnHold: "KUMPLETO SA HOLD VISIT",
                DurationGreaterThan0: "Ang tagal ng pagbisita ay dapat na mas malaki sa 0 minuto!",
                PleaseWaitSearch: "Mangyaring maghintay habang hinahanap namin ang iyong mga aktibong takdang-aralin.",
                NotesAndInfo: "Mga Tala at Impormasyon",
                InfoOnlyItems: "Mga Item Lamang sa Impormasyon",
                NoNotesForVisit: "Walang mga tala para sa pagbisitang ito!",
                NoInfoForVisit: "Walang mga item sa impormasyon sa pagbisita na ito!",
                ContiguousVisits: "Magkadugtong na Pagbisita",
                Details: "Mga Detalye",
                Signature: "Lagda",
                GoToSign: "Ipakita ang pad",
                History: "Kasaysayan",
                NoNotesInHistory: "Walang mga tala sa kasaysayan!",
                CarePlanHistoryNotAvailableOffline: "Ang kasaysayan ng item ng plano sa pangangalaga ay hindi magagamit sa offline mode!",
                TheVisitIsAlreadySigned: "Ang pagbisita ay pinirmahan na. Maaari kang magpatuloy nang walang pirma.",
                OfflineUptimeWarning: "Maaaring na-restart ang iyong device mula noong huli mong online na pag-log in. Kung maaari mangyaring mag-login online upang i-update ang iyong oras.",
                Phone: "Telepono",
                Email: "Email",
                OfflineModeWarning: "Nagkakaproblema ang iyong application dahil sa hindi magandang koneksyon at kukunin ang iyong data offline. Maa-update ang opisina sa sandaling bumuti ang iyong koneksyon sa network.",
                OnlineModeWarning: "Nagawa ng iyong application na muling kumonekta sa server. Isi-synchronize at mapoproseso na ang data ng iyong pagbisita online.",
                Refresh: "Refresh",
                ResetMapsApp: "I-reset ang Maps App",
                DefaultMapsAppWarning: "Na-reset ang default na maps app. Sa susunod na ilunsad mo ang navigator makakapili ka ng bagong application.",
                UseBingInstead: "Gumamit ng Bing Maps ",
                NoLocationWarning: "Hindi makuha ang iyong lokasyon. Tiyaking naka-on ang iyong GPS, kung hindi, maaaring hindi mahanap ng iyong napiling application ng mapa ang iyong posisyon. Gusto mo pa rin bang magpatuloy? Maaaring kailanganin mong ipasok nang manu-mano ang iyong kasalukuyang posisyon!",
                NoMapsWarning: "Walang nahanap na mga application ng mapa sa iyong device. Sa halip, bubuksan ang mga mapa ng Bing.",
                HoursLimitWarning: "</br><b><p style='color:Red'>Tagal ng pagbisita > 16 na oras. Sigurado ka ba?</p></b>",
                SlotChangeWarning: "Mayroon kang mga nakaiskedyul na pagbisita sa puwang ng oras na ito. Mangyaring makipag-ugnayan sa opisina upang hilingin ang iyong pagbabago sa availability.",
                WorkerPhone: "Telepono ng Manggagawa",
                PleaseTurnOnGPS: "Naka-off ang iyong GPS. Mangyaring payagan ang application na makuha ang iyong lokasyon bago magpatuloy. Maaaring kailanganin mong pindutin ang button na 'I-refresh ang GPS' pagkatapos payagan ang iyong lokasyon na makuha.",
                NoGPSOnVisit: "Ang lokasyon ng GPS ay hindi matukoy sa oras. Gusto mo bang magpatuloy nang walang mga coordinate?",
                NoGPSPermission: "Hindi mo magagamit ang app na ito dahil hindi mo pinagana ang pagbabahagi ng lokasyon para sa app. Maaari mong i-update ang mga setting ng iyong app o tanggalin at muling i-install ang app. Kung muli mong i-install, kapag nag-log in ka, tatanungin nito kung magagamit ng app ang iyong lokasyon. Dapat kang magsabi ng oo upang magpatuloy.",
                SyncVisitWarning: "Hindi ma-synchronize ang pagbisita sa server. Subukang muli mamaya!",
                CarePlanItemHistoryDisplayMode: "Display Mode ng Kasaysayan ng Plano ng Pangangalaga",
                Individually: "Indibidwal",
                AllAtOnce: "Sabay-sabay",
                GpsTimeLeft: "Sinusubukan ng application na makuha ang mga coordinate ng GPS. Sa kaso ng pagkabigo, ang clocking in/out ay gagawing available sa maximum na ",
                Seconds: "segundo",
                BlockUser: "I-block ang User",
                ServicePeriod: "Panahon ng Serbisyo",
                ServicePeriodStartDate: "Petsa ng Pagsisimula ng Panahon ng Serbisyo",
                UseBy: "Ginamit ni",
                TotalTime: "Kabuuang Oras",
                UsedTime: "Nagamit na Oras",
                RemainingTime: "Natitirang oras",
                AuthInfo: "Auth Info",
                YouMayWorkUpTo: "<br/><br/>Maaari kang magtrabaho hanggang sa",
                NoAuthorizedUnitsLeftWarning: "Hindi ka makakapagsimula ng bagong pagbisita para sa pasyenteng ito at uri ng pagbisita dahil may 0 awtorisadong minuto na natitira sa pagbisita!",
            },
            "ht": {
                Nothing: "",
                Username: "ImŠl oswa non itilizatŠ",
                Password: "Modpas",
                NewAppVersionAvailable: "Nouvo vŠsyon aplikasyon an disponib tanpri mete ajou!",
                UserError: "Tanpri antre yon non itilizatŠ valab.",
                PwError: "Modpas ou bezwen plis pase 6 karaktŠ.",
                Login: "Konekte",
                FaceID: "FaceID",
                Fingerprint: "Anprent",
                PwForgot: "Bliye modpas?",
                Version: "Version",
                TitleApp: "MANOS SWEN LAKAY",
                Subtitle: "P otal moun kap bay swen",
                Monday: "Lendi",
                Tuesday: "Madi",
                Wednesday: "MŠkredi",
                Thursday: "Jedi",
                Friday: "Vandredi",
                Saturday: "Samdi",
                Sunday: "Dimanch",
                ViewMap: "Gade kat jeyografik",
                NoteTooLong: "N ot tw o long. Tanpri kenbe yon maksim om de 512 karaktŠ!",
                NoteTooLong4000characters: "N ot tw o long. Tanpri kenbe yon maksim om de 4000 karaktŠ!",
                OfflinePassForgot: "Ou offline. Tanpri konekte ak yon rezo pou reset modpas ou.",
                ConfirmPassReset: "?ske w sŠten ou vle reset modpas ou a?",
                ConfirmShiftResponse: "?ske w sŠten ou vle reponn ak chanjman ouvŠ sa a?",
                PatientName: "</br></br>Non Pasyan an:",
                EmptyUsername: "Tanpri asire w ke w fin ranpli non itilizatŠ/imel la!",
                EmptyError: "Ou pa gen yon nimewo telef on oswa imŠl nan dosye. Tanpri kontakte biwo w la pou fŠ yo reset modpas ou.",
                PassResetSuccess: "Yo voye yon imŠl reset modpas nan imel ou a",
                PhoneError: "Yo voye yon tŠks reset modpas sou nimewo telef on ou.",
                NewMessages: "Ou ka gen nouvo mesaj.",
                ReadNow: "Li kounye a",
                ReadLater: "Li pita",
                Ok: "Oke",
                Close: "FŠmen",
                DeleteWorking: "?ske ou sŠten ou vle efase lŠ travay?",
                DeleteAdjustment: "?ske ou sŠten ou vle efase ajisteman <b>",
                InitiatingCall: "Inisye apŠl...",
                CallFailed: "Rele echwe",
                CallCanceled: "ApŠl anile",
                OngoingCall: "ApŠl ap kontinye...",
                CallEnded: "ApŠl te fini",
                IncomingCall: "ApŠl k ap rantre",
                ConnectingToCall: "Konekte...",
                Rejected: "Rejte...",
                RejectionFailed: "Rejeksyon echwe ...",
                ChangePasswordOfflineWarning: "Chanje modpas disponib sŠlman lŠ gen koneksyon entŠnŠt!",
                PassBlank: "Reantre modpas la vid oswa li pa matche!",
                PleaseConnect: "Tanpri konekte ak entŠnŠt la pou konekte!",
                InvalidPassword: "Modpas aktyŠl la pa valab. Tanpri eseye ank o!",
                AcceptedChars: "KaraktŠ yo aksepte yo se lŠt, nimewo, ak senb ol sa yo: '.', '!'.",
                NewInvalidPass: "Nouvo modpas pa valab. Tanpri tcheke kondisyon pi wo a.",
                InvalidCurrentPassword: "Modpas aktyŠl envalid!",
                PasswordMustBeDifferent: "Nouvo modpas dwe diferan de 3 dŠnye modpas ou yo. Tanpri eseye yon nouvo modpas diferan.",
                PasswordsDoNotMatch: "Modpas pa koresponn!",
                PassBlockedWord1: "Nouvo modpas gen mo bloke:",
                PassBlockedWord2: ". Modpas pa dwe genyen mo bloke.",
                PasswordResetSuccess: "Ou chanje modpas ou avŠk siksŠ. Tanpri konekte.",
                AgreeToReceiveInformationalMessages: "Mwen dakò pou resevwa mesaj/notifikasyon enfòmasyon sou nimewo telefòn mwen nan men ",
                PasswordResetNotSuccessful: "Pa t 'kapab chanje modpas. Tanpri eseye ank o.",
                Enable: "PŠmŠt",
                Disable: "Enfim",
                UnableToSaveCode: "Pa kapab sove k od la. Tanpri kontakte ekip sip o a!",
                InvalidCode: "K od ki pa valab",
                ConfirmingLocation: "Konfime Kote - Tanpri tann!",
                GPSNotCaptured: "Kow odone GPS ou yo pa te kaptire. Tanpri eseye ank o lŠ l sŠvi avŠk Refresh GPS!",
                GPSNotCaptured2: "Kow odone GPS ou yo pa te kaptire. Ou ka peze 'Aksepte Tan' pou k omanse vizit ou a, men tanpri kite aplikasyon an louvri pou jiska 3 minit pou nou ka kontinye eseye jwenn kote ou ye a.",
                GPSNotCaptured3: "Kow odone GPS ou yo pa te kaptire. Tanpri eseye ank o!",
                TooEarlyToReport: "Ou tw o bonŠ pou w antre. Tanpri antre nan lŠ w fikse a.",
                TooLateToReport: "Ou tw o ta pou w antre.",
                LocationNotCloseEnough: "Kote w la pa ase pre kay kliyan an. Tanpri antre nan kay kliyan an epi eseye ank o lŠ l sŠvi avŠk Refresh GPS!",
                YourArrivalTimeIs: "Tan revŠy ou a se",
                SomeoneElseIsAlreadyClocked: "Yon l ot moun deja antre. Tanpri mande yo pou yo fŠ revŠy pou ou ka antre.",
                YourDepartureTimeIs: "</br></br>LŠ depa w se",
                YourVisitDurationIs: "</br></br>Dire vizit se",
                YourExpectedDeparture: "Tan depa ou espere se",
                ClientDocumentsReady: "LŠ w konfime arive w, w ap rekonŠt ou te li dokiman kliyan yo.",
                OpenShiftDate: "</br></br>Dat Chanjman Louvri:",
                OpenShiftTime: "</br></br>Open Shift Time:",
                WeStillTryingConfirmLocation: "Nou toujou ap eseye konfime kote ou ye a. Nou pral kontinye eseye pou jiska 3 minit.",
                YourExpectedDepartureTimeNotUntil: "Tan depa ou espere se",
                CompleteFullySchedule: "Si ou ta renmen ranpli tout tan ou pwograme, tanpri antre",
                PleaseSetStatus: "Tanpri mete yon estati pou tout atik!",
                CarePlanItemAlreadyExisit: "Atik plan swen ou vle ajoute a deja ajoute nan lis la",
                DurationGreaterThan0: "Dire vizit la dwe plis pase 0 minit!",
                MessageConfirmLogOut: "?ske ou sŠten ou vle dekonekte?",
                Confirm: "Konfime",
                Cancel: "Anile",
                PageAvailableOnlyOnline: "Paj sa a disponib sŠlman pandan w sou entŠnŠt.",
                SomethingWentWrong: "Gen yon bagay ki mal pase, tanpri eseye ank o!",
                EnrolledSuccessfully: "Enskri avŠk siksŠ!",
                SuccessfullPictureUpload: "Uploaded foto a avŠk siksŠ.",
                VisitMoved: "Vizit deplase jodi a!",
                PatientConcernTooLong: "Enkyetid pasyan an tw o lontan. Tanpri ajoute kenbe maksim om 2500 karaktŠ!",
                VisitHistoryOffline: "Vizite Istwa disponib sŠlman si gen koneksyon entŠnŠt.",
                OnlyNetAccess: "SŠlman disponib lŠ gen aksŠ entŠnŠt!",
                ErrorSavingSignature: "ErŠ nan sove siyati. Tanpri eseye ank o oswa kontakte Ankota.",
                ErrorSavingWorkerSignature: "ErŠ nan sove siyati travayŠ a. Tanpri eseye ank o oswa kontakte Ankota.",
                ErrorSavingPatientSignature: "ErŠ nan sove siyati pasyan an. Tanpri eseye ank o oswa kontakte Ankota.",
                CouldNotCreateFile: "Pa t 'kapab kreye dosye",
                NoRecording: "Pa gen anrejistreman!",
                UploadedFile: "Fichye Uploaded avŠk siksŠ.",
                MarkWhileOffline: "Ou pa ka make yon mesaj k om li pandan w ap offline!",
                Offline: "Ou offline",
                Syncing: "Senkronize... Tanpri tann",
                LoadingMessage: "Loading... Tanpri tann",
                Title: "Tit",
                Message: "Mesaj",
                Date: "Dat",
                DateAndTime: "Dat ak LŠ",
                MarkAsRead: "Make k om li",
                Call: "Rele",
                Immediately: "imedyatman.",
                HourShort: "h",
                MinShort: "m",
                Actions: "Aksyon",
                UnblockUser: "Debloke itilizatŠ",
                Image: "Imaj",
                Document: "Dokiman",
                LoadingDocsWait: "Chaje dokiman yo, tanpri tann",
                ProcessDocsWait: "Pwosesis dokiman yo, tanpri tann",
                PleaseConnectToLogIn: "Tanpri konekte ak entŠnŠt la pou konekte!",
                AvailableShifsNoInternet: "Chanjman ki disponib yo aksesib sŠlman si gen koneksyon entŠnŠt!",
                ShiftNotAvailable: "Chanjman an pa disponib ank o.",
                ShiftAssignedToYou: "Biwo a te pwograme w pou chanjman sa a. Si ou pa kapab fŠ li, tanpri kontakte biwo a!",
                InvalidUserOrPass: "Non itilizatŠ oswa modpas pa valab. Tanpri eseye ank o.",
                UnexpectedErrorContactSupport: "ErŠ inatandi! Tanpri kontakte sip o!",
                FingerprintAuthError: "Te gen yon erŠ pandan y ap trete otantifikasyon anprent",
                EnrollAgain: "Gen yon bagay ki mal pase, tanpri enskri ank o!",
                UsernameEnrollmentError: "Pa gen okenn enskripsyon pou non itilizatŠ sa a, tanpri eseye yon l ot non itilizatŠ oswa konekte pa modpas!",
                BiometricAuthentication: "Tanpri antre non itilizatŠ pou otantifikasyon byometrik.",
                InvalidCoordinates: "Kow odone envalid",
                SigningInPleaseWait: "LŠ w ap konekte, tanpri tann",
                PleaseWaitSearch: "Tanpri tann pandan n ap chŠche devwa aktif ou yo.",
                SignIn: "Konekte",
                UseBackup: "SŠvi ak sovgad",
                FingerprintAuthentication: "Otantifikasyon anprent",
                PleaseEnrollYourProfile: "Tanpri enskri pwofil ou a",
                DoYouHave: "ou genyen",
                Concerns: "enkyetid?",
                HRNotifications: "Notifikasyon HR",
                NoNotifications: "Pa gen Notifikasyon.",
                Hi: "Alo",
                Expected: "espere",
                SelectLanguage: "Chwazi yon lang...",
                ChangePassword: "Chanje modpas",
                LoginErr: "Login pa valab. Tanpri eseye ank o.",
                About: "KonsŠnan",
                Account: "Kont",
                UploadDocumentOrPicture: "Telechaje dokiman oswa foto",
                Name: "Non",
                PickUpCases: "RANMAN KA",
                CaseOrderName: "Ka #:",
                TimeBetweenCases: "Tan ant ka yo:",
                TravelTime: "Tan vwayaj",
                Status: "Estati",
                Language: "Lang",
                AssignToMe: "Bay mwen",
                AcceptCase: "Aksepte Ka",
                DeclineCase: "Ka refize",
                SeeDetails: "Gade Detay yo",
                ConsumerNoShow: "KonsomatŠ pa montre",
                ReturnCase: "Retounen Ka",
                LateCancellation: "Anilasyon an reta",
                YouArePreferred: "OU PREFERE",
                NoCasesToShow: "Pa gen ka yo montre.",
                AssignedPatients: "KLIYAN ASIGNE",
                AvailableShifts: "Chanjman ki disponib",
                NoAssignedPatients: "Ou pa gen kliyan plase!",
                ReportTasks: "Rap ote Travay",
                MyRegularSchedule: "OrŠ regilye mwen an",
                BookingsPerWeek: "RezŠvasyon pou chak semŠn",
                Slot: "Fant",
                AddASlot: "Ajoute yon plas",
                AddTimeoffConflict: "Ajoute konje/Konfli",
                OverrideSchedule: "Pase OrŠ",
                Type: "Kalite",
                OverwriteEmployeeCalendar: "Ecrase Kalandriye Anplwaye",
                BlockedUsers: "ItilizatŠ bloke yo",
                Chat: "Chat",
                LoadMoreUsers: "Chaje plis itilizatŠ yo",
                PasswordMustBe: "Modpas dwe",
                PasswordMustBeAtLeast: "Modpas dwe omwen",
                PasswordMustBeAtMost: "Modpas dwe pi plis",
                PasswordMustContainAtLeast: "Modpas dwe genyen omwen",
                NumericCharacters: "karaktŠ nimerik",
                SpecialCharacters: "karaktŠ espesyal",
                CharactersLong: "karaktŠ long.",
                PasswordRequirement: "Modpas dwe genyen 3 nan 4 kalite: pi ba, anwo, espesyal, karaktŠ nimerik.",
                CurrentPassword: "Modpas aktyŠl la",
                NewPassword: "Nouvo Modpas",
                ReenterPassword: "Reantre nouvo modpas",
                TypeMsg: "Tape mesaj ou a isit la...",
                To: "pou",
                SentFileToYou: "te voye yon fichye ba ou, ou ka telechaje li",
                Here: "isit la.",
                Hello: "Bonjou",
                ClientView: "View Kliyan",
                ReportArrival: "RevŠy Nan",
                ReportDeparture: "L?T SOTI",
                Logout: "Dekonekte",
                Completion: "Konplete Jodi a",
                NoMatchedClients: "Pa gen kliyan matche! Tanpri kontakte",
                ConfirmDeparture: "KONFIME DEPART",
                ArrivalDate: "Dat Arive",
                ArrivalTime: "Tan Arive",
                DepartureDate: "Dat Depa",
                DepartureTime: "Tan Depa",
                VisitDocuments: "Vizite Dokiman yo",
                Complete: "Ranpli",
                Incomplete: "EnkonplŠ",
                NotStarted: "Pa te k omanse",
                ProcessDocuments: "Pwosesis Dokiman yo",
                OnlyOnline: "ka fŠt sŠlman sou entŠnŠt",
                ConnectionOflline: "Koneksyon entŠnŠt la se offline",
                SaveIncomplete: "Sove EnkonplŠ",
                ResetToNew: "ResetToNew",
                PickerDisplay: "dat/nimewo yo chwazi lŠ",
                ReportNoShow: "Rap ote pa montre",
                ReportCancelVisit: "Rap o Anile Vizit",
                NotificationCenter: "SANT NOTIFIKASYON",
                Visits: "Vizit",
                Time: "Tan",
                Client: "Kliyan",
                Location: "Kote",
                AcceptVisit: "Aksepte Vizit",
                DeclineVisit: "Dekline Vizite",
                Messages: "Mesaj",
                Title2: "Tit",
                Delete: "Efase",
                ViewDocsPatients: "Gade dokiman pou pasyan sa yo:",
                ViewDocuments: "Gade Dokiman yo",
                Documents: "Dokiman",
                PayrollHistory: "ISTWA PE?L",
                WeeklyHours: "L? SEM?N",
                NoPayrollsToShow: "Pa gen pew ol pou montre.",
                PayrollSummary: "REZIME PE?L",
                WeeklySummary: "REZIME L? SEKMAN",
                GrossEarnings: "SAL? BRIT",
                GrossEarnings2: "SalŠ Brit",
                TotalHourBreakdown: "Pann total Šdtan",
                TotalHoursWorked: "Total OrŠ Travay",
                VisitTime: "Vizite Tan",
                Regular: "Regilye",
                Overtime: "LŠ siplemantŠ",
                Adjustments: "Ajisteman",
                AdjustmentsReflect: "Ajisteman yo reflete chanjman nan peman anvan yo.",
                ExpectedPayment: "Espere Peman anvan taks",
                HoursWorked: "OrŠ Travay",
                NumberofDays: "Kantite Jou",
                NumberOfVisits: "Kantite Vizit",
                VisitHistory: "Vizite Istwa",
                Trips: "Vwayaj",
                TripOptionQuestion: "?ske w te konplete transp o ki pa medikal nan vizit sa a?",
                RefreshGPS: "Rafrechi GPS",
                ClockIn: "pa gen revŠy nan tan",
                ClockOut: "pa gen revŠy soti lŠ",
                CurrentArrival: "RevŠy-nan Tan",
                AcceptTime: "RevŠy Nan",
                ReportItems: "RAP? ATIK",
                AddBreak: "Ajoute yon poz",
                NA: "N/A",
                Set: "Mete",
                NotSet: "Pa Mete",
                AddAnotherItem: "Ajoute yon l ot atik",
                NothingToAdd: "Pa gen anyen pou ajoute",
                AddItem: "Ajoute atik",
                NoItemsToDisplay: "Pa gen atik pou montre.",
                Next: "Next",
                SelectVisitType: "Chwazi Kalite Vizit",
                Settings: "PARAM?T",
                Availability: "Disponibilite",
                General: "Jeneral",
                Security: "Sekirite",
                NameUploadPicturesDocs: "Non, Telechaje foto/dokiman",
                ConsenttoReceiveTexts: "Konsantman pou resevwa tèks",
                ChangePasswordFingerprintFaceID: "Chanje Modpas, Anprent dwèt/Face ID",
                AddSlots: "Ajoute Slots",
                ToSetAdditionalSettings: "Pou mete l ot paramŠt, tanpri konekte ak menm kalifikasyon yo nan",
                Authentication: "OTANSYON",
                EnterSMSCode: "Antre k od ou te resevwa via SMS:",
                Back: "Retounen",
                Code: "K od",
                MyVisits: "VIZ MWEN",
                Address: "AdrŠs",
                CreatedByPhone: "Kreye pa telef on",
                ViewMoreDetails: "Gade plis detay",
                NoShow: "Pa montre",
                Tasks: "Travay",
                CancelVisit: "Anile Vizit",
                UploadDocs: "Telechaje Docs",
                Rework: "RETRAVAY",
                OnHold: "RANPLI VIZIT TANDE",
                PleaseSelectReason: "Tanpri chwazi yon rezon!",
                PleaseSelectDocument: "Tanpri chwazi yon dokiman!",
                NoVisitsToShow: "Pa gen vizit nan Show",
                UploadTimesheets: "TELECHARGE F?Y TAN",
                UploadDocuments: "Telechaje Dokiman yo",
                EnterAdditionalNotes: "Antre l ot n ot isit la...",
                VisitDirections: "VIZITE DIREKSYON",
                DriveTime: "Kondwi tan",
                PrecedingVisitEndTime: "LŠ fini vizit anvan",
                TimeBetweenVisits: "Tan Ant Vizit yo",
                VisitAddress: "Vizite AdrŠs",
                LiveDirections: "Live Directions",
                VisitDetails: "VIZITE DETAY",
                ClientName: "Non Kliyan an",
                ServiceName: "Non SŠvis",
                VisitDate: "Vizite Dat",
                VisitStatus: "Vizite Status",
                PrimaryPhone: "Telef on Prensipal",
                SecondaryPhone: "Telef on SegondŠ",
                GetDirections: "Jwenn direksyon",
                VisitNotes: "Vizite N ot",
                Instructions: "Enstriksyon yo",
                PleaseUseTheButton: "Tanpri itilize bouton ki anba a pou pran yon foto fŠy ou a. SŠvi ak bouton Retry si foto a sanble klŠ.",
                Keep: "Kenbe",
                TakePicture: "Pran Foto",
                UploadOrTakePicture: "Telechaje oswa pran foto",
                RetakePicture: "Repran foto",
                AddPhoto2: "AJOUTE FOTO",
                VisitHistoryCaps: "VIZITE ISTWA",
                Completed: "konplete",
                WorkerName: "Non travayŠ",
                Notes: "N ot",
                ResponseNotes: "N ot repons",
                AddNotes: "Ajoute N ot",
                MoveVisitToday: "Deplase Vizite Jodi a",
                ShowMore: "... Montre plis",
                VisitType: "Vizite Kalite",
                PleaseAsk: "Tanpri mande ",
                ToConfirmThatTheyReceived: "pou konfime ke yo te resevwa yo",
                ServiceToday: "sŠvis jodi a",
                Yes: "Wi",
                No: "Non",
                ToConfirmThatTheVisit: "pou konfime ke fwa vizit yo te soti nan",
                ReportDeparture2: "L?T SOTI",
                ToSignHere: "pou siyen isit la",
                VoiceSignature: "Siyati Vwa",
                PleaseSignHere: "Tanpri siyen isit la",
                PleaseAskYour: "Tanpri mande w",
                ErrandMiles: "KomŠs Miles",
                AddPhoto: "Ajoute foto",
                Clear: "KlŠ",
                Accept: "Aksepte",
                NotAvailable: "Pa Disponib",
                VisitConfirmation: "Vizite Konfimasyon",
                RequestForConfirmation: "Tanpri di non w ak dat jodi a apre w fin peze Start Recording pou konfime ke ou te resevwa sŠvis ou jodi a.",
                PlayRecording: "Jwe Anrejistreman",
                StopPlayRecording: "Sispann jwe anrejistreman",
                StartRecording: "K omanse anrejistreman",
                StopRecording: "Sispann anrejistreman",
                MonthView: "Mwa View",
                WeekView: "View SemŠn",
                VisitSuccesfullyClosed: "Vizit la te fŠmen avŠk siksŠ",
                ArrSuccess: "Arive ou te anrejistre avŠk siksŠ nan",
                ArrOffline: "Yo anrejistre arive ou men ou offline. Biwo w la ka resevwa yon avŠtisman an reta.",
                ArrSuccessDeparture: "Tan depa ou espere se",
                CurrentVisit: "Dire vizit aktyŠl la",
                Hours: "Šdtan",
                Minutes: "minit",
                ClockOutButton: "RevŠy soti",
                ConfirmLocation: "Nou toujou ap eseye konfime kote ou ye a. Nou pral kontinye eseye pou jiska 3 minit.",
                ViewTasks: "Gade travay yo",
                CurrentDeparture: "Tan depa aktyŠl la",
                Duration: "dire",
                Duration2: "Dire",
                ConfirmClockOut: "?ske ou sŠten ou vle revŠy soti?",
                Only3OnHoldVisitsWillShowAtaTime: "Se sŠlman 3 vizit On Hold ap parŠt nan yon moman.",
                Submit: "SoumŠt",
                DepSuccess: "Depa ou te anrejistre avŠk siksŠ nan",
                DepOffline: "Yo anrejistre depa ou men ou offline. Biwo w la ka resevwa yon avŠtisman an reta.",
                PleaseOpenYourAnkotaApplater: " Tanpri ouvri aplikasyon Ankota ou a pita jodi a lè ou gen pi bon siyal (lè w SOU ENTÈNÈT) pou yo ka voye done vizit ou a nan biwo a.",
                Home: "Lakay",
                Save: "Sove",
                ReportMissedVisit: "Rap ote vizit ki manke",
                ReportVisit: "Rap o vizit",
                AddMissedVisitReason: "Chwazi rezon",
                CorrectDatesTime: "Korije dat/lŠ ki anwo yo lŠ w klike sou yo epi ale nan opsyon ki k orŠk la.",
                ContigousVisitBlock: "Vizit sa a te fŠ pati yon bl ok vizit. Tanpri antre tan aktyŠl ou k omanse ak lŠ final revŠy ou pou bl ok sa a.",
                AddWorkerDocument: "Chwazi dokiman an",
                ReportExpensesTitle: "Rap ote Depans yo",
                ReportExpensesQuestion: "?ske ou gen depans pou rap ote?",
                Amount: "Kantite lajan",
                Description: "Deskripsyon",
                Company: "Konpayi",
                NotesAndInfo: "N ot ak enf omasyon",
                InfoOnlyItems: "Enf omasyon sŠlman Atik",
                NoNotesForVisit: "Pa gen okenn n ot pou vizit sa a!",
                NoInfoForVisit: "Pa gen okenn atik enf omasyon sou vizit sa a!",
                ContiguousVisits: "Vizit kontigu",
                Details: "Detay yo",
                Signature: "Siyati",
                GoToSign: "Montre pad",
                History: "Istwa",
                NoNotesInHistory: "Pa gen n ot nan listwa!",
                CarePlanHistoryNotAvailableOffline: "Istwa atik plan swen pa disponib nan m od offline!",
                TheVisitIsAlreadySigned: "Vizit la deja siyen. Ou ka kontinye san siyati.",
                OfflineUptimeWarning: "AparŠy ou a ka rek omanse depi dŠnye koneksyon ou sou entŠnŠt. Si sa posib tanpri konekte sou entŠnŠt pou mete ajou tan ou.",
                Phone: "Telef on",
                Email: "ImŠl",
                OfflineModeWarning: "Aplikasyon ou a gen pwoblŠm ak oz move koneksyon epi li pral pran done ou offline. Biwo a pral mete ajou le pli vit ke koneksyon rezo ou amelyore.",
                OnlineModeWarning: "Aplikasyon ou a te jere rekonekte ak sŠvŠ a. Done vizit ou yo pral kounye a senkronize ak trete sou entŠnŠt.",
                Refresh: "Rafrechi",
                ResetMapsApp: "Reyajiste Maps App",
                DefaultMapsAppWarning: "Aplikasyon kat default yo te reset. Pwochen fwa ou lanse navigatŠ a ou pral kapab chwazi yon nouvo aplikasyon.",
                UseBingInstead: "SŠvi ak Bing Maps",
                NoLocationWarning: "Pa t 'kapab pran pozisyon ou. Asire w ke GPS ou a limen, otreman aplikasyon kat ou chwazi a ta ka pa kapab lokalize pozisyon ou. Ou vle kontinye kanmenm? Ou ta ka oblije antre pozisyon ou ye kounye a manyŠlman!",
                NoMapsWarning: "Yo pa jwenn okenn aplikasyon pou kat sou aparŠy ou an. Bing kat yo pral louvri pito.",
                HoursLimitWarning: "</br><b><p style='color:Red'>Dire vizit > 16 Šdtan. ?ske w sŠten?</p></b>",
                SlotChangeWarning: "Ou te pwograme vizit pandan plas tan sa a. Tanpri kontakte biwo a pou mande chanjman disponiblite ou.",
                WorkerPhone: "Telef on TravayŠ",
                PleaseTurnOnGPS: "GPS ou etenn. Tanpri pŠmŠt aplikasyon an pran pozisyon ou anvan ou kontinye. Ou ta ka bezwen peze bouton 'Rafrechi GPS la' apre w fin pŠmŠt ou pran kote w.",
                NoGPSOnVisit: "Kote GPS pa t 'kapab detekte a tan. Ou vle kontinye san kow odone?",
                NoGPSPermission: "Ou pa ka sŠvi ak aplikasyon sa a paske ou pa pŠmŠt pataje kote pou aplikasyon an. Ou ka swa mete ajou paramŠt aplikasyon w lan oswa efase epi reenstale aplikasyon an. Si ou re-enstale, lŠ ou konekte li pral mande si app a ka itilize kote ou ye a. Ou dwe di wi pou kontinye.",
                SyncVisitWarning: "Vizit pa t 'kapab senkronize ak sŠvŠ a. Tanpri eseye ank o pita!",
                CarePlanItemHistoryDisplayMode: "M od ekspozisyon istwa plan swen",
                Individually: "EndividyŠlman",
                AllAtOnce: "Tout nan yon fwa",
                GpsTimeLeft: "Aplikasyon an ap eseye jwenn kow odone GPS yo. Nan ka echŠk, revŠy nan / soti yo pral disponib nan yon maksim om de",
                Seconds: "segonn",
                BlockUser: "Bloke itilizatŠ",
                ServicePeriod: "Pery od SŠvis",
                ServicePeriodStartDate: "Dat K omansman Pery od SŠvis",
                UseBy: "SŠvi ak pa",
                TotalTime: "Tan total",
                UsedTime: "Itilize Tan",
                RemainingTime: "Tan ki rete",
                AuthInfo: "Enf omasyon sou otorizasyon",
                YouMayWorkUpTo: "<br/><br/>Ou ka travay jiska",
                NoAuthorizedUnitsLeftWarning: "Ou pa kapab k omanse yon nouvo vizit pou pasyan sa a ak kalite vizit sa a paske gen 0 minit otorize ki rete nan vizit la!",
                DocumentsAreLoading: "Dokiman ap chaje...",
                NoDocuments: "Pa gen Dokiman",
            },
            'yue': {},
            'cmn': {},
        }
};

@Directive({
    selector: '[translate-placeholder]',
})
export class TranslatePlaceholder extends Translate {
    private labelval2: string;
    constructor(el: ElementRef) {
        super(el);
        this.placeText(el);
    }

    placeText(el: ElementRef) {
        let currentLanguage = Translate.getCurrentLanguage();
        this.labelval2 = Translate.languages[currentLanguage][el.nativeElement.getAttribute('paramdata')];
        let placeholderText = (el.nativeElement as HTMLElement).getAttribute("placeholder");
        if (!placeholderText) placeholderText = "";
        (el.nativeElement as HTMLElement).setAttribute("placeholder", this.labelval2);
    }
}

@Directive({
    selector: '[translate-label]',
})
export class TranslateLabelDirective extends Translate {
    private translatedText: string;
    constructor(el: ElementRef) {
        super(el);
        this.placeText(el);
    }

    placeText(el: ElementRef) {
        const currentLanguage = Translate.getCurrentLanguage();
        const key = el.nativeElement.getAttribute('paramdata');
        this.translatedText = Translate.languages[currentLanguage][el.nativeElement.getAttribute('paramdata')];
        // this.translatedText = Translate.languages[currentLanguage][key] || key;
        console.log("Translated taxte label = "+ this.translatedText);
        let labelText = (el.nativeElement as HTMLElement).getAttribute("label");
        console.log("Translated taxte labelText = "+ labelText);
        if (!labelText) labelText = "";
        (el.nativeElement as HTMLElement).setAttribute("label", this.translatedText);

        if ('label' in el.nativeElement) {
            el.nativeElement.label =  this.translatedText;
          }
      
    }

}

@Directive({
    selector: '[translate-hidden]',
})
export class TranslateHidden extends Translate {
    constructor(el: ElementRef) {
        super(el);
        this.placeText(el);
    }

    placeText(el: ElementRef) {
        //do nothing
    }
}